import { EmissionSourceGreenHouseGases } from '@/app/org-cfv/src/enums/EmissionSourceEnum';

import { RefrigerantGHG } from '../../src/enums/FugitiveEmissionEnum';

export const RAW_MATERIALS_DROPDOWN_OPTIONS_ORDER = [
  'COAL',
  'FUEL_OIL',
  'FUEL_GAS',
  'OTHER_FUEL',
  'BIOFUEL',
  'JP_SOLID_FUEL',
  'JP_LIQUID_FUEL',
  'JP_FOSSIL_NATURAL_GAS',
  'JP_WASTE_AS_FUEL',
  'JP_BIOMASS',
  'IN_BIOFUEL',
  'IN_COAL',
  'IN_FUEL_GAS',
  'IN_FUEL_OIL',
  'IN_OTHER_FUEL',
  'TH_FUEL_OIL',
  'TH_COAL',
  'TH_BIOFUEL',
  'CN_COAL',
  'CN_FUEL_OIL',
  'CN_FUEL_GAS',
  'CN_OTHER_FUEL',
  'CN_BIOFUEL',
  'US_COAL',
  'US_OTHER_FUEL_SOLID',
  'US_BIOFUEL_SOLID',
  'US_FUEL_GAS',
  'US_OTHER_FUEL_GAS',
  'US_BIOFUEL_GAS',
  'US_FUEL_OIL',
  'US_BIOFUEL_LIQUID',
  'VN_COAL',
  'VN_FUEL_OIL',
  'VN_FUEL_GAS',
  'VN_BIOFUEL',
  'CA_FUEL_GAS',
  'CA_FUEL_OIL',
  'CA_COAL',
  'CA_ALTERNATIVE_FUEL',
  'CA_BIOMASS',
  'MX_COAL',
  'MX_FUEL_OIL',
  'MX_FUEL_GAS',
  'MX_OTHER_FUEL',
  'MX_BIOFUEL',
  'HK_FUEL_OIL',
  'HK_FUEL_GAS',
  'HK_BIOFUEL',
  'SG_COAL',
  'SG_FUEL_OIL',
  'SG_FUEL_GAS',
  'SG_OTHER_FUEL',
  'SG_BIOFUEL',
  'EURO_FUEL_OIL',
  'EURO_FUEL_GAS',
  'EURO_FUEL_BIOFUEL',
  'EURO_OTHER_FUEL',
  'EURO_COAL',
  'NA_FUEL_OIL',
  'NA_FUEL_GAS',
  'NA_BIOFUEL',
  'GLO_FUEL_OIL',
  'GLO_FUEL_GAS',
  'GLO_BIOFUEL',
  'ADEME_COAL',
  'ADEME_FUEL_OIL',
  'ADEME_FUEL_GAS',
  'ADEME_OTHER_FUEL',
  'ADEME_BIOFUEL',
  'RM_FUEL_1',
  'RM_FUEL_2',
  'RM_FUEL_3',
  'RM_FUEL_4',
  'RM_FUEL_5',
  'RM_FUEL_6',
  'RM_FUEL_7',
  'RM_FUEL_8',
  'RM_FUEL_9',
  'RM_FUEL_10',
  'RM_FUEL_11',
  'RM_FUEL_12',
  'RM_FUEL_13',
  'RM_FUEL_14',
  'RM_FUEL_15',
  'RM_FUEL_16',
  'RM_FUEL_17',
  'RM_FUEL_18',
  'RM_FUEL_19',
  'RM_FUEL_20',
  'RM_FUEL_21',
  'RM_FUEL_22',
  'RM_FUEL_23',
  'RM_FUEL_24',
  'RM_FUEL_25',
  'RM_FUEL_26',
  'RM_FUEL_27',
  'RM_FUEL_28',
  'RM_FUEL_29',
  'RM_FUEL_30',
  'RM_FUEL_31',
  'RM_FUEL_32',
  'RM_FUEL_33',
  'RM_FUEL_34',
  'RM_FUEL_35',
  'RM_FUEL_36',
  'RM_FUEL_37',
  'RM_FUEL_38',
  'RM_FUEL_39',
  'RM_FUEL_40',
  'RM_FUEL_41',
  'RM_FUEL_42',
  'RM_FUEL_43',
  'RM_FUEL_44',
  'RM_FUEL_45',
  'RM_FUEL_46',
  'RM_FUEL_47',
  'RM_FUEL_48',
  'RM_FUEL_49',
  'RM_FUEL_50',
  'RM_FUEL_51',
  'RM_FUEL_52',
  'RM_FUEL_53',
  'RM_FUEL_54',
  'RM_FUEL_55',
  'RM_FUEL_56',
  'RM_FUEL_57',
  'RM_FUEL_58',
  'RM_FUEL_59',
  'RM_FUEL_60',
  'RM_FUEL_61',
  'RM_FUEL_62',
  'RM_FUEL_63',
  'RM_FUEL_64',
  'RM_FUEL_65',
  'RM_FUEL_66',
  'RM_FUEL_67',
  'RM_FUEL_68',
  'RM_FUEL_69',
  'RM_FUEL_70',
  'RM_FUEL_71',
  'RM_FUEL_72',
  'JP_RM_FUEL_S1_EQ1',
  'JP_RM_FUEL_S2_EQ1',
  'JP_RM_FUEL_S3_EQ1',
  'JP_RM_FUEL_S4_EQ1',
  'JP_RM_FUEL_S5_EQ1',
  'JP_RM_FUEL_S6_EQ1',
  'JP_RM_FUEL_S7_EQ1',
  'JP_RM_FUEL_S8_EQ1',
  'JP_RM_FUEL_S9_EQ1',
  'JP_RM_FUEL_S10_EQ1',
  'JP_RM_FUEL_W1_EQ1',
  'JP_RM_FUEL_W2_EQ1',
  'JP_RM_FUEL_W3_EQ1',
  'JP_RM_FUEL_W4_EQ1',
  'JP_RM_FUEL_W5_EQ1',
  'JP_RM_FUEL_L2_EQ1',
  'JP_RM_FUEL_L9_EQ1',
  'JP_RM_FUEL_L1_EQ1',
  'JP_RM_FUEL_L3_EQ1',
  'JP_RM_FUEL_L4_EQ1',
  'JP_RM_FUEL_L5_EQ1',
  'JP_RM_FUEL_L6_EQ1',
  'JP_RM_FUEL_L7_EQ1',
  'JP_RM_FUEL_L8_EQ1',
  'JP_RM_FUEL_L10_EQ1',
  'JP_RM_FUEL_W6_EQ1',
  'JP_RM_FUEL_W7_EQ1',
  'JP_RM_FUEL_G1_EQ1',
  'JP_RM_FUEL_G2_EQ1',
  'JP_RM_FUEL_G3_EQ1',
  'JP_RM_FUEL_G4_EQ1',
  'JP_RM_FUEL_G5_EQ1',
  'JP_RM_FUEL_G6_EQ1',
  'JP_RM_FUEL_G7_EQ1',
  'JP_RM_FUEL_G8_EQ1',
  'JP_RM_FUEL_G9_EQ1',
  'JP_RM_FUEL_G10_EQ1',
  'JP_RM_FUEL_G11_EQ1',
  'JP_RM_FUEL_G12_EQ1',
  'JP_RM_FUEL_G13_EQ1',
  'JP_RM_FUEL_G14_EQ1',
  'JP_RM_FUEL_G15_EQ1',
  'JP_RM_FUEL_G16_EQ1',
  'JP_RM_FUEL_G17_EQ1',
  'JP_RM_FUEL_G18_EQ1',
  'JP_RM_FUEL_G19_EQ1',
  'JP_RM_FUEL_G20_EQ1',
  'JP_RM_FUEL_G21_EQ1',
  'JP_RM_FUEL_G22_EQ1',
  'JP_RM_FUEL_G23_EQ1',
  'JP_RM_FUEL_G24_EQ1',
  'JP_RM_FUEL_B1_EQ1_1',
  'JP_RM_FUEL_B2_EQ1_1',
  'JP_RM_FUEL_B1_EQ1_2',
  'JP_RM_FUEL_B2_EQ1_2',
  'JP_RM_FUEL_B2_EQ1_3',
  'JP_RM_FUEL_B3_EQ1',
  'JP_RM_FUEL_B4_EQ1',
  'JP_RM_FUEL_B5_EQ1',
  'JP_RM_FUEL_S1_EQ2',
  'JP_RM_FUEL_S2_EQ2',
  'JP_RM_FUEL_S3_EQ2',
  'JP_RM_FUEL_S4_EQ2',
  'JP_RM_FUEL_S5_EQ2',
  'JP_RM_FUEL_S6_EQ2',
  'JP_RM_FUEL_S7_EQ2',
  'JP_RM_FUEL_S8_EQ2',
  'JP_RM_FUEL_S9_EQ2',
  'JP_RM_FUEL_S10_EQ2',
  'JP_RM_FUEL_W4_EQ2',
  'JP_RM_FUEL_W5_EQ2',
  'JP_RM_FUEL_S1_EQ3',
  'JP_RM_FUEL_S2_EQ3',
  'JP_RM_FUEL_S3_EQ3',
  'JP_RM_FUEL_S6_EQ3',
  'JP_RM_FUEL_S7_EQ3',
  'JP_RM_FUEL_S8_EQ3',
  'JP_RM_FUEL_S9_EQ3',
  'JP_RM_FUEL_S10_EQ3',
  'JP_RM_FUEL_S4_EQ3',
  'JP_RM_FUEL_S5_EQ3',
  'JP_RM_FUEL_S1_EQ4',
  'JP_RM_FUEL_S2_EQ4',
  'JP_RM_FUEL_S3_EQ4',
  'JP_RM_FUEL_S4_EQ4',
  'JP_RM_FUEL_S5_EQ4',
  'JP_RM_FUEL_S6_EQ4',
  'JP_RM_FUEL_S7_EQ4',
  'JP_RM_FUEL_S8_EQ4',
  'JP_RM_FUEL_S9_EQ4',
  'JP_RM_FUEL_S10_EQ4',
  'JP_RM_FUEL_L1_EQ4',
  'JP_RM_FUEL_L2_EQ4',
  'JP_RM_FUEL_L3_EQ4',
  'JP_RM_FUEL_L4_EQ4',
  'JP_RM_FUEL_L5_EQ4',
  'JP_RM_FUEL_L6_EQ4',
  'JP_RM_FUEL_L7_EQ4',
  'JP_RM_FUEL_L8_EQ4',
  'JP_RM_FUEL_L9_EQ4',
  'JP_RM_FUEL_L10_EQ4',
  'JP_RM_FUEL_G1_EQ4',
  'JP_RM_FUEL_G2_EQ4',
  'JP_RM_FUEL_G3_EQ4',
  'JP_RM_FUEL_G4_EQ4',
  'JP_RM_FUEL_G5_EQ4',
  'JP_RM_FUEL_G6_EQ4',
  'JP_RM_FUEL_G7_EQ4',
  'JP_RM_FUEL_G8_EQ4',
  'JP_RM_FUEL_G9_EQ4',
  'JP_RM_FUEL_G10_EQ4',
  'JP_RM_FUEL_G11_EQ4',
  'JP_RM_FUEL_G12_EQ4',
  'JP_RM_FUEL_G13_EQ4',
  'JP_RM_FUEL_G14_EQ4',
  'JP_RM_FUEL_G15_EQ4',
  'JP_RM_FUEL_G16_EQ4',
  'JP_RM_FUEL_G17_EQ4',
  'JP_RM_FUEL_G18_EQ4',
  'JP_RM_FUEL_G19_EQ4',
  'JP_RM_FUEL_G20_EQ4',
  'JP_RM_FUEL_G21_EQ4',
  'JP_RM_FUEL_G22_EQ4',
  'JP_RM_FUEL_G23_EQ4',
  'JP_RM_FUEL_G24_EQ4',
  'JP_RM_FUEL_S1_EQ5',
  'JP_RM_FUEL_S2_EQ5',
  'JP_RM_FUEL_S3_EQ5',
  'JP_RM_FUEL_S4_EQ5',
  'JP_RM_FUEL_S5_EQ5',
  'JP_RM_FUEL_S6_EQ5',
  'JP_RM_FUEL_S7_EQ5',
  'JP_RM_FUEL_S8_EQ5',
  'JP_RM_FUEL_S9_EQ5',
  'JP_RM_FUEL_S10_EQ5',
  'JP_RM_FUEL_L1_EQ5',
  'JP_RM_FUEL_L2_EQ5',
  'JP_RM_FUEL_L3_EQ5',
  'JP_RM_FUEL_L4_EQ5',
  'JP_RM_FUEL_L5_EQ5',
  'JP_RM_FUEL_L6_EQ5',
  'JP_RM_FUEL_L7_EQ5',
  'JP_RM_FUEL_L8_EQ5',
  'JP_RM_FUEL_L9_EQ5',
  'JP_RM_FUEL_L10_EQ5',
  'JP_RM_FUEL_G1_EQ5',
  'JP_RM_FUEL_G2_EQ5',
  'JP_RM_FUEL_G3_EQ5',
  'JP_RM_FUEL_G4_EQ5',
  'JP_RM_FUEL_G5_EQ5',
  'JP_RM_FUEL_G6_EQ5',
  'JP_RM_FUEL_G7_EQ5',
  'JP_RM_FUEL_G8_EQ5',
  'JP_RM_FUEL_G9_EQ5',
  'JP_RM_FUEL_G10_EQ5',
  'JP_RM_FUEL_G11_EQ5',
  'JP_RM_FUEL_G12_EQ5',
  'JP_RM_FUEL_G13_EQ5',
  'JP_RM_FUEL_G14_EQ5',
  'JP_RM_FUEL_G15_EQ5',
  'JP_RM_FUEL_G16_EQ5',
  'JP_RM_FUEL_G17_EQ5',
  'JP_RM_FUEL_G18_EQ5',
  'JP_RM_FUEL_G19_EQ5',
  'JP_RM_FUEL_G20_EQ5',
  'JP_RM_FUEL_G21_EQ5',
  'JP_RM_FUEL_G22_EQ5',
  'JP_RM_FUEL_G23_EQ5',
  'JP_RM_FUEL_G24_EQ5',
  'JP_RM_FUEL_S1_EQ6',
  'JP_RM_FUEL_S2_EQ6',
  'JP_RM_FUEL_S3_EQ6',
  'JP_RM_FUEL_S4_EQ6',
  'JP_RM_FUEL_S5_EQ6',
  'JP_RM_FUEL_S6_EQ6',
  'JP_RM_FUEL_S7_EQ6',
  'JP_RM_FUEL_S8_EQ6',
  'JP_RM_FUEL_S9_EQ6',
  'JP_RM_FUEL_S10_EQ6',
  'JP_RM_FUEL_L1_EQ6',
  'JP_RM_FUEL_L2_EQ6',
  'JP_RM_FUEL_L3_EQ6',
  'JP_RM_FUEL_L4_EQ6',
  'JP_RM_FUEL_L5_EQ6',
  'JP_RM_FUEL_L6_EQ6',
  'JP_RM_FUEL_L7_EQ6',
  'JP_RM_FUEL_L8_EQ6',
  'JP_RM_FUEL_L9_EQ6',
  'JP_RM_FUEL_L10_EQ6',
  'JP_RM_FUEL_G1_EQ6',
  'JP_RM_FUEL_G2_EQ6',
  'JP_RM_FUEL_G3_EQ6',
  'JP_RM_FUEL_G4_EQ6',
  'JP_RM_FUEL_G5_EQ6',
  'JP_RM_FUEL_G6_EQ6',
  'JP_RM_FUEL_G7_EQ6',
  'JP_RM_FUEL_G8_EQ6',
  'JP_RM_FUEL_G9_EQ6',
  'JP_RM_FUEL_G10_EQ6',
  'JP_RM_FUEL_G11_EQ6',
  'JP_RM_FUEL_G12_EQ6',
  'JP_RM_FUEL_G13_EQ6',
  'JP_RM_FUEL_G14_EQ6',
  'JP_RM_FUEL_G15_EQ6',
  'JP_RM_FUEL_G16_EQ6',
  'JP_RM_FUEL_G17_EQ6',
  'JP_RM_FUEL_G18_EQ6',
  'JP_RM_FUEL_G19_EQ6',
  'JP_RM_FUEL_G20_EQ6',
  'JP_RM_FUEL_G21_EQ6',
  'JP_RM_FUEL_G22_EQ6',
  'JP_RM_FUEL_G23_EQ6',
  'JP_RM_FUEL_G24_EQ6',
  'JP_RM_FUEL_G5_EQ7',
  'JP_RM_FUEL_G6_EQ7',
  'JP_RM_FUEL_S1_EQ8',
  'JP_RM_FUEL_S2_EQ8',
  'JP_RM_FUEL_S3_EQ8',
  'JP_RM_FUEL_S4_EQ8',
  'JP_RM_FUEL_S5_EQ8',
  'JP_RM_FUEL_S6_EQ8',
  'JP_RM_FUEL_S7_EQ8',
  'JP_RM_FUEL_S8_EQ8',
  'JP_RM_FUEL_S9_EQ8',
  'JP_RM_FUEL_S10_EQ8',
  'JP_RM_FUEL_L1_EQ8',
  'JP_RM_FUEL_L2_EQ8',
  'JP_RM_FUEL_L3_EQ8',
  'JP_RM_FUEL_L4_EQ8',
  'JP_RM_FUEL_L5_EQ8',
  'JP_RM_FUEL_L6_EQ8',
  'JP_RM_FUEL_L7_EQ8',
  'JP_RM_FUEL_L8_EQ8',
  'JP_RM_FUEL_L9_EQ8',
  'JP_RM_FUEL_L10_EQ8',
  'JP_RM_FUEL_G1_EQ8',
  'JP_RM_FUEL_G2_EQ8',
  'JP_RM_FUEL_G3_EQ8',
  'JP_RM_FUEL_G4_EQ8',
  'JP_RM_FUEL_G5_EQ8',
  'JP_RM_FUEL_G6_EQ8',
  'JP_RM_FUEL_G7_EQ8',
  'JP_RM_FUEL_G8_EQ8',
  'JP_RM_FUEL_G9_EQ8',
  'JP_RM_FUEL_G10_EQ8',
  'JP_RM_FUEL_G11_EQ8',
  'JP_RM_FUEL_G12_EQ8',
  'JP_RM_FUEL_G13_EQ8',
  'JP_RM_FUEL_G14_EQ8',
  'JP_RM_FUEL_G15_EQ8',
  'JP_RM_FUEL_G16_EQ8',
  'JP_RM_FUEL_G17_EQ8',
  'JP_RM_FUEL_G18_EQ8',
  'JP_RM_FUEL_G19_EQ8',
  'JP_RM_FUEL_G20_EQ8',
  'JP_RM_FUEL_G21_EQ8',
  'JP_RM_FUEL_G22_EQ8',
  'JP_RM_FUEL_G23_EQ8',
  'JP_RM_FUEL_G24_EQ8',
  'JP_RM_FUEL_S8_EQ9',
  'JP_RM_FUEL_S10_EQ9',
  'JP_RM_FUEL_S1_EQ10',
  'JP_RM_FUEL_S2_EQ10',
  'JP_RM_FUEL_S3_EQ10',
  'JP_RM_FUEL_S4_EQ10',
  'JP_RM_FUEL_S5_EQ10',
  'JP_RM_FUEL_S6_EQ10',
  'JP_RM_FUEL_S8_EQ10',
  'JP_RM_FUEL_S9_EQ10',
  'JP_RM_FUEL_S10_EQ10',
  'JP_RM_FUEL_S11_EQ10',
  'JP_RM_FUEL_L1_EQ11',
  'JP_RM_FUEL_L2_EQ11',
  'JP_RM_FUEL_L3_EQ11',
  'JP_RM_FUEL_L4_EQ11',
  'JP_RM_FUEL_L5_EQ11',
  'JP_RM_FUEL_L6_EQ11',
  'JP_RM_FUEL_L7_EQ11',
  'JP_RM_FUEL_L8_EQ11',
  'JP_RM_FUEL_L9_EQ11',
  'JP_RM_FUEL_L10_EQ11',
  'JP_RM_FUEL_G1_EQ11',
  'JP_RM_FUEL_G2_EQ11',
  'JP_RM_FUEL_G3_EQ11',
  'JP_RM_FUEL_G5_EQ11',
  'JP_RM_FUEL_G6_EQ11',
  'JP_RM_FUEL_G7_EQ11',
  'JP_RM_FUEL_G8_EQ11',
  'JP_RM_FUEL_G9_EQ11',
  'JP_RM_FUEL_G10_EQ11',
  'JP_RM_FUEL_G11_EQ11',
  'JP_RM_FUEL_G12_EQ11',
  'JP_RM_FUEL_G13_EQ11',
  'JP_RM_FUEL_G14_EQ11',
  'JP_RM_FUEL_G15_EQ11',
  'JP_RM_FUEL_G16_EQ11',
  'JP_RM_FUEL_G17_EQ11',
  'JP_RM_FUEL_G18_EQ11',
  'JP_RM_FUEL_G19_EQ11',
  'JP_RM_FUEL_G20_EQ11',
  'JP_RM_FUEL_G21_EQ11',
  'JP_RM_FUEL_G22_EQ11',
  'JP_RM_FUEL_G23_EQ11',
  'JP_RM_FUEL_G24_EQ11',
  'JP_RM_FUEL_S1_EQ12',
  'JP_RM_FUEL_S2_EQ12',
  'JP_RM_FUEL_S3_EQ12',
  'JP_RM_FUEL_S4_EQ12',
  'JP_RM_FUEL_S5_EQ12',
  'JP_RM_FUEL_S6_EQ12',
  'JP_RM_FUEL_S7_EQ12',
  'JP_RM_FUEL_S8_EQ12',
  'JP_RM_FUEL_S9_EQ12',
  'JP_RM_FUEL_S10_EQ12',
  'JP_RM_FUEL_L1_EQ12',
  'JP_RM_FUEL_L2_EQ12',
  'JP_RM_FUEL_L3_EQ12',
  'JP_RM_FUEL_L4_EQ12',
  'JP_RM_FUEL_L5_EQ12',
  'JP_RM_FUEL_L6_EQ12',
  'JP_RM_FUEL_L7_EQ12',
  'JP_RM_FUEL_L8_EQ12',
  'JP_RM_FUEL_L9_EQ12',
  'JP_RM_FUEL_L10_EQ12',
  'JP_RM_FUEL_G1_EQ12',
  'JP_RM_FUEL_G2_EQ12',
  'JP_RM_FUEL_G3_EQ12',
  'JP_RM_FUEL_G4_EQ12',
  'JP_RM_FUEL_G5_EQ12',
  'JP_RM_FUEL_G6_EQ12',
  'JP_RM_FUEL_G7_EQ12',
  'JP_RM_FUEL_G8_EQ12',
  'JP_RM_FUEL_G9_EQ12',
  'JP_RM_FUEL_G10_EQ12',
  'JP_RM_FUEL_G11_EQ12',
  'JP_RM_FUEL_G12_EQ12',
  'JP_RM_FUEL_G13_EQ12',
  'JP_RM_FUEL_G14_EQ12',
  'JP_RM_FUEL_G15_EQ12',
  'JP_RM_FUEL_G16_EQ12',
  'JP_RM_FUEL_G17_EQ12',
  'JP_RM_FUEL_G18_EQ12',
  'JP_RM_FUEL_G19_EQ12',
  'JP_RM_FUEL_G20_EQ12',
  'JP_RM_FUEL_G21_EQ12',
  'JP_RM_FUEL_G22_EQ12',
  'JP_RM_FUEL_G23_EQ12',
  'JP_RM_FUEL_G24_EQ12',
  'JP_RM_FUEL_S1_EQ13',
  'JP_RM_FUEL_S2_EQ13',
  'JP_RM_FUEL_S3_EQ13',
  'JP_RM_FUEL_S4_EQ13',
  'JP_RM_FUEL_S5_EQ13',
  'JP_RM_FUEL_S6_EQ13',
  'JP_RM_FUEL_S7_EQ13',
  'JP_RM_FUEL_S8_EQ13',
  'JP_RM_FUEL_S9_EQ13',
  'JP_RM_FUEL_S10_EQ13',
  'JP_RM_FUEL_L1_EQ13',
  'JP_RM_FUEL_L2_EQ13',
  'JP_RM_FUEL_L3_EQ13',
  'JP_RM_FUEL_L4_EQ13',
  'JP_RM_FUEL_L5_EQ13',
  'JP_RM_FUEL_L6_EQ13',
  'JP_RM_FUEL_L7_EQ13',
  'JP_RM_FUEL_L8_EQ13',
  'JP_RM_FUEL_L9_EQ13',
  'JP_RM_FUEL_L10_EQ13',
  'JP_RM_FUEL_G1_EQ13',
  'JP_RM_FUEL_G2_EQ13',
  'JP_RM_FUEL_G3_EQ13',
  'JP_RM_FUEL_G4_EQ13',
  'JP_RM_FUEL_G5_EQ13',
  'JP_RM_FUEL_G6_EQ13',
  'JP_RM_FUEL_G7_EQ13',
  'JP_RM_FUEL_G8_EQ13',
  'JP_RM_FUEL_G9_EQ13',
  'JP_RM_FUEL_G10_EQ13',
  'JP_RM_FUEL_G11_EQ13',
  'JP_RM_FUEL_G12_EQ13',
  'JP_RM_FUEL_G13_EQ13',
  'JP_RM_FUEL_G14_EQ13',
  'JP_RM_FUEL_G15_EQ13',
  'JP_RM_FUEL_G16_EQ13',
  'JP_RM_FUEL_G17_EQ13',
  'JP_RM_FUEL_G18_EQ13',
  'JP_RM_FUEL_G19_EQ13',
  'JP_RM_FUEL_G20_EQ13',
  'JP_RM_FUEL_G21_EQ13',
  'JP_RM_FUEL_G22_EQ13',
  'JP_RM_FUEL_G23_EQ13',
  'JP_RM_FUEL_G24_EQ13',
  'JP_RM_FUEL_S1_EQ14',
  'JP_RM_FUEL_S2_EQ14',
  'JP_RM_FUEL_S3_EQ14',
  'JP_RM_FUEL_S4_EQ14',
  'JP_RM_FUEL_S5_EQ14',
  'JP_RM_FUEL_S6_EQ14',
  'JP_RM_FUEL_S7_EQ14',
  'JP_RM_FUEL_S8_EQ14',
  'JP_RM_FUEL_S9_EQ14',
  'JP_RM_FUEL_S10_EQ14',
  'JP_RM_FUEL_L1_EQ14',
  'JP_RM_FUEL_L2_EQ14',
  'JP_RM_FUEL_L3_EQ14',
  'JP_RM_FUEL_L4_EQ14',
  'JP_RM_FUEL_L5_EQ14',
  'JP_RM_FUEL_L6_EQ14',
  'JP_RM_FUEL_L7_EQ14',
  'JP_RM_FUEL_L8_EQ14',
  'JP_RM_FUEL_L9_EQ14',
  'JP_RM_FUEL_L10_EQ14',
  'JP_RM_FUEL_G1_EQ14',
  'JP_RM_FUEL_G2_EQ14',
  'JP_RM_FUEL_G3_EQ14',
  'JP_RM_FUEL_G4_EQ14',
  'JP_RM_FUEL_G5_EQ14',
  'JP_RM_FUEL_G6_EQ14',
  'JP_RM_FUEL_G7_EQ14',
  'JP_RM_FUEL_G8_EQ14',
  'JP_RM_FUEL_G9_EQ14',
  'JP_RM_FUEL_G10_EQ14',
  'JP_RM_FUEL_G11_EQ14',
  'JP_RM_FUEL_G12_EQ14',
  'JP_RM_FUEL_G13_EQ14',
  'JP_RM_FUEL_G14_EQ14',
  'JP_RM_FUEL_G15_EQ14',
  'JP_RM_FUEL_G16_EQ14',
  'JP_RM_FUEL_G17_EQ14',
  'JP_RM_FUEL_G18_EQ14',
  'JP_RM_FUEL_G19_EQ14',
  'JP_RM_FUEL_G20_EQ14',
  'JP_RM_FUEL_G21_EQ14',
  'JP_RM_FUEL_G22_EQ14',
  'JP_RM_FUEL_G23_EQ14',
  'JP_RM_FUEL_G24_EQ14',
  'JP_RM_FUEL_S1_EQ15',
  'JP_RM_FUEL_S2_EQ15',
  'JP_RM_FUEL_S3_EQ15',
  'JP_RM_FUEL_S4_EQ15',
  'JP_RM_FUEL_S5_EQ15',
  'JP_RM_FUEL_S6_EQ15',
  'JP_RM_FUEL_S7_EQ15',
  'JP_RM_FUEL_S8_EQ15',
  'JP_RM_FUEL_S9_EQ15',
  'JP_RM_FUEL_S10_EQ15',
  'JP_RM_FUEL_W2_EQ15',
  'JP_RM_FUEL_W3_EQ15',
  'JP_RM_FUEL_W4_EQ15',
  'JP_RM_FUEL_W5_EQ15',
  'JP_RM_FUEL_L1_EQ15',
  'JP_RM_FUEL_L2_EQ15',
  'JP_RM_FUEL_L3_EQ15',
  'JP_RM_FUEL_L4_EQ15',
  'JP_RM_FUEL_L5_EQ15',
  'JP_RM_FUEL_L6_EQ15',
  'JP_RM_FUEL_L7_EQ15',
  'JP_RM_FUEL_L8_EQ15',
  'JP_RM_FUEL_L9_EQ15',
  'JP_RM_FUEL_L10_EQ15',
  'JP_RM_FUEL_G1_EQ15',
  'JP_RM_FUEL_G2_EQ15',
  'JP_RM_FUEL_G3_EQ15',
  'JP_RM_FUEL_G4_EQ15',
  'JP_RM_FUEL_G5_EQ15',
  'JP_RM_FUEL_G6_EQ15',
  'JP_RM_FUEL_G7_EQ15',
  'JP_RM_FUEL_G8_EQ15',
  'JP_RM_FUEL_G9_EQ15',
  'JP_RM_FUEL_G10_EQ15',
  'JP_RM_FUEL_G11_EQ15',
  'JP_RM_FUEL_G12_EQ15',
  'JP_RM_FUEL_G13_EQ15',
  'JP_RM_FUEL_G14_EQ15',
  'JP_RM_FUEL_G15_EQ15',
  'JP_RM_FUEL_G16_EQ15',
  'JP_RM_FUEL_G17_EQ15',
  'JP_RM_FUEL_G18_EQ15',
  'JP_RM_FUEL_G19_EQ15',
  'JP_RM_FUEL_G20_EQ15',
  'JP_RM_FUEL_G21_EQ15',
  'JP_RM_FUEL_G22_EQ15',
  'JP_RM_FUEL_G23_EQ15',
  'JP_RM_FUEL_G24_EQ15',
  'JP_RM_FUEL_L1_EQ16',
  'JP_RM_FUEL_L2_EQ16',
  'JP_RM_FUEL_L3_EQ16',
  'JP_RM_FUEL_L4_EQ16',
  'JP_RM_FUEL_L5_EQ16',
  'JP_RM_FUEL_L6_EQ16',
  'JP_RM_FUEL_L7_EQ16',
  'JP_RM_FUEL_L8_EQ16',
  'JP_RM_FUEL_L9_EQ16',
  'JP_RM_FUEL_L10_EQ16',
  'JP_RM_FUEL_G1_EQ16',
  'JP_RM_FUEL_G2_EQ16',
  'JP_RM_FUEL_G3_EQ16',
  'JP_RM_FUEL_G4_EQ16',
  'JP_RM_FUEL_G5_EQ16',
  'JP_RM_FUEL_G6_EQ16',
  'JP_RM_FUEL_G7_EQ16',
  'JP_RM_FUEL_G8_EQ16',
  'JP_RM_FUEL_G9_EQ16',
  'JP_RM_FUEL_G10_EQ16',
  'JP_RM_FUEL_G11_EQ16',
  'JP_RM_FUEL_G12_EQ16',
  'JP_RM_FUEL_G13_EQ16',
  'JP_RM_FUEL_G14_EQ16',
  'JP_RM_FUEL_G15_EQ16',
  'JP_RM_FUEL_G16_EQ16',
  'JP_RM_FUEL_G17_EQ16',
  'JP_RM_FUEL_G18_EQ16',
  'JP_RM_FUEL_G19_EQ16',
  'JP_RM_FUEL_G20_EQ16',
  'JP_RM_FUEL_G21_EQ16',
  'JP_RM_FUEL_G22_EQ16',
  'JP_RM_FUEL_G23_EQ16',
  'JP_RM_FUEL_G24_EQ16',
  'JP_RM_FUEL_L1_EQ17',
  'JP_RM_FUEL_L2_EQ17',
  'JP_RM_FUEL_L3_EQ17',
  'JP_RM_FUEL_L4_EQ17',
  'JP_RM_FUEL_L5_EQ17',
  'JP_RM_FUEL_L6_EQ17',
  'JP_RM_FUEL_L7_EQ17',
  'JP_RM_FUEL_L8_EQ17',
  'JP_RM_FUEL_L9_EQ17',
  'JP_RM_FUEL_L10_EQ17',
  'JP_RM_FUEL_G1_EQ17',
  'JP_RM_FUEL_G2_EQ17',
  'JP_RM_FUEL_G3_EQ17',
  'JP_RM_FUEL_G4_EQ17',
  'JP_RM_FUEL_G5_EQ17',
  'JP_RM_FUEL_G6_EQ17',
  'JP_RM_FUEL_G7_EQ17',
  'JP_RM_FUEL_G8_EQ17',
  'JP_RM_FUEL_G9_EQ17',
  'JP_RM_FUEL_G10_EQ17',
  'JP_RM_FUEL_G11_EQ17',
  'JP_RM_FUEL_G12_EQ17',
  'JP_RM_FUEL_G13_EQ17',
  'JP_RM_FUEL_G14_EQ17',
  'JP_RM_FUEL_G15_EQ17',
  'JP_RM_FUEL_G16_EQ17',
  'JP_RM_FUEL_G17_EQ17',
  'JP_RM_FUEL_G18_EQ17',
  'JP_RM_FUEL_G19_EQ17',
  'JP_RM_FUEL_G20_EQ17',
  'JP_RM_FUEL_G21_EQ17',
  'JP_RM_FUEL_G22_EQ17',
  'JP_RM_FUEL_G23_EQ17',
  'JP_RM_FUEL_G24_EQ17',
  'JP_RM_FUEL_L1_EQ18',
  'JP_RM_FUEL_L2_EQ18',
  'JP_RM_FUEL_L3_EQ18',
  'JP_RM_FUEL_L4_EQ18',
  'JP_RM_FUEL_L5_EQ18',
  'JP_RM_FUEL_L6_EQ18',
  'JP_RM_FUEL_L7_EQ18',
  'JP_RM_FUEL_L8_EQ18',
  'JP_RM_FUEL_L9_EQ18',
  'JP_RM_FUEL_L10_EQ18',
  'JP_RM_FUEL_G1_EQ18',
  'JP_RM_FUEL_G2_EQ18',
  'JP_RM_FUEL_G3_EQ18',
  'JP_RM_FUEL_G4_EQ18',
  'JP_RM_FUEL_G5_EQ18',
  'JP_RM_FUEL_G6_EQ18',
  'JP_RM_FUEL_G7_EQ18',
  'JP_RM_FUEL_G8_EQ18',
  'JP_RM_FUEL_G9_EQ18',
  'JP_RM_FUEL_G10_EQ18',
  'JP_RM_FUEL_G11_EQ18',
  'JP_RM_FUEL_G12_EQ18',
  'JP_RM_FUEL_G13_EQ18',
  'JP_RM_FUEL_G14_EQ18',
  'JP_RM_FUEL_G15_EQ18',
  'JP_RM_FUEL_G16_EQ18',
  'JP_RM_FUEL_G17_EQ18',
  'JP_RM_FUEL_G18_EQ18',
  'JP_RM_FUEL_G19_EQ18',
  'JP_RM_FUEL_G20_EQ18',
  'JP_RM_FUEL_G21_EQ18',
  'JP_RM_FUEL_G22_EQ18',
  'JP_RM_FUEL_G23_EQ18',
  'JP_RM_FUEL_G24_EQ18',
  'JP_RM_FUEL_S1_EQ19',
  'JP_RM_FUEL_S2_EQ19',
  'JP_RM_FUEL_S3_EQ19',
  'JP_RM_FUEL_S4_EQ19',
  'JP_RM_FUEL_S5_EQ19',
  'JP_RM_FUEL_S6_EQ19',
  'JP_RM_FUEL_S7_EQ19',
  'JP_RM_FUEL_S8_EQ19',
  'JP_RM_FUEL_S9_EQ19',
  'JP_RM_FUEL_S10_EQ19',
  'JP_RM_FUEL_L1_EQ19',
  'JP_RM_FUEL_L2_EQ19',
  'JP_RM_FUEL_L3_EQ19',
  'JP_RM_FUEL_L4_EQ19',
  'JP_RM_FUEL_L5_EQ19',
  'JP_RM_FUEL_L6_EQ19',
  'JP_RM_FUEL_L7_EQ19',
  'JP_RM_FUEL_L8_EQ19',
  'JP_RM_FUEL_L9_EQ19',
  'JP_RM_FUEL_L10_EQ19',
  'JP_RM_FUEL_G1_EQ19',
  'JP_RM_FUEL_G2_EQ19',
  'JP_RM_FUEL_G3_EQ19',
  'JP_RM_FUEL_G4_EQ19',
  'JP_RM_FUEL_G5_EQ19',
  'JP_RM_FUEL_G6_EQ19',
  'JP_RM_FUEL_G7_EQ19',
  'JP_RM_FUEL_G8_EQ19',
  'JP_RM_FUEL_G9_EQ19',
  'JP_RM_FUEL_G10_EQ19',
  'JP_RM_FUEL_G11_EQ19',
  'JP_RM_FUEL_G12_EQ19',
  'JP_RM_FUEL_G13_EQ19',
  'JP_RM_FUEL_G14_EQ19',
  'JP_RM_FUEL_G15_EQ19',
  'JP_RM_FUEL_G16_EQ19',
  'JP_RM_FUEL_G17_EQ19',
  'JP_RM_FUEL_G18_EQ19',
  'JP_RM_FUEL_G19_EQ19',
  'JP_RM_FUEL_G20_EQ19',
  'JP_RM_FUEL_G21_EQ19',
  'JP_RM_FUEL_G22_EQ19',
  'JP_RM_FUEL_G23_EQ19',
  'JP_RM_FUEL_G24_EQ19',
  'JP_RM_FUEL_B4_EQ19',
  'JP_RM_FUEL_B5_EQ19',
  'JP_RM_FUEL_B6_EQ19',
  'JP_RM_FUEL_B7_EQ19',
  'JP_RM_FUEL_B8_EQ19',
  'JP_RM_FUEL_B9_EQ19',
  'JP_RM_FUEL_L5',
  'JP_RM_FUEL_L8',
  'JP_RM_FUEL_L9',
  'JP_RM_FUEL_L10',
  'JP_RM_FUEL_L11',
  'JP_RM_FUEL_L12',
  'JP_RM_FUEL_L13',
  'JP_RM_FUEL_L14',
  'JP_RM_FUEL_L15',
  'IN_BIOFUEL_1',
  'IN_BIOFUEL_2',
  'IN_BIOFUEL_3',
  'IN_BIOFUEL_4',
  'IN_BIOFUEL_5',
  'IN_BIOFUEL_6',
  'IN_BIOFUEL_7',
  'IN_BIOFUEL_8',
  'IN_BIOFUEL_9',
  'IN_BIOFUEL_10',
  'IN_BIOFUEL_11',
  'IN_BIOFUEL_12',
  'IN_BIOFUEL_13',
  'IN_BIOFUEL_14',
  'IN_BIOFUEL_15',
  'IN_COAL_1',
  'IN_COAL_2',
  'IN_COAL_3',
  'IN_COAL_4',
  'IN_COAL_5',
  'IN_COAL_6',
  'IN_COAL_7',
  'IN_COAL_8',
  'IN_COAL_9',
  'IN_COAL_10',
  'IN_COAL_11',
  'IN_COAL_12',
  'IN_COAL_13',
  'IN_COAL_14',
  'IN_COAL_15',
  'IN_COAL_16',
  'IN_COAL_17',
  'IN_COAL_18',
  'IN_FUELGAS_1',
  'IN_FUELOIL_1',
  'IN_FUELOIL_2',
  'IN_FUELOIL_3',
  'IN_FUELOIL_4',
  'IN_FUELOIL_5',
  'IN_FUELOIL_6',
  'IN_FUELOIL_7',
  'IN_FUELOIL_8',
  'IN_FUELOIL_9',
  'IN_FUELOIL_10',
  'IN_FUELOIL_11',
  'IN_FUELOIL_12',
  'IN_FUELOIL_13',
  'IN_FUELOIL_14',
  'IN_FUELOIL_15',
  'IN_FUELOIL_16',
  'IN_FUELOIL_17',
  'IN_FUELOIL_18',
  'IN_FUELOIL_19',
  'IN_FUELOIL_20',
  'IN_FUELOIL_21',
  'IN_FUELOIL_22',
  'IN_FUELOIL_23',
  'IN_FUELOIL_24',
  'IN_FUELOIL_25',
  'IN_FUELOIL_26',
  'IN_OTHERFUEL_1',
  'IN_OTHERFUEL_2',
  'IN_FUELOIL_27',
  'IN_FUELOIL_28',
  'IN_FUELOIL_29',
  'IN_FUELOIL_30',
  'IN_FUELOIL_31',
  'IN_FUELOIL_32',
  'IN_FUELOIL_33',
  'IN_FUELOIL_34',
  'IN_FUELOIL_35',
  'TH_BIOFUEL_1',
  'TH_BIOFUEL_2',
  'TH_BIOFUEL_3',
  'TH_BIOFUEL_4',
  'TH_BIOFUEL_5',
  'TH_BIOFUEL_6',
  'TH_BIOFUEL_7',
  'TH_BIOFUEL_8',
  'TH_BIOFUEL_9',
  'TH_BIOFUEL_10',
  'TH_COAL_1',
  'TH_COAL_2',
  'TH_COAL_3',
  'TH_FUEL_1',
  'TH_FUEL_2',
  'TH_FUEL_3',
  'TH_FUEL_4',
  'TH_FUEL_5',
  'TH_FUEL_6',
  'TH_FUEL_7',
  'TH_FUEL_8',
  'TH_FUEL_9',
  'TH_FUEL_10',
  'TH_FUEL_11',
  'TH_FUEL_12',
  'TH_FUEL_13',
  'TH_FUEL_14',
  'TH_FUEL_15',
  'TH_FUEL_16',
  'TH_FUEL_17',
  'TH_FUEL_18',
  'TH_FUEL_19',
  'TH_FUEL_20',
  'TH_FUEL_21',
  'TH_FUEL_22',
  'TH_FUEL_23',
  'TH_FUEL_24',
  'TH_FUEL_25',
  'TH_FUEL_26',
  'TH_FUEL_27',
  'TH_FUEL_28',
  'US_COAL_1',
  'US_COAL_2',
  'US_COAL_3',
  'US_COAL_4',
  'US_COAL_5',
  'US_COAL_6',
  'US_COAL_7',
  'US_COAL_8',
  'US_COAL_9',
  'US_OTHER_FUEL_SOLID_1',
  'US_OTHER_FUEL_SOLID_2',
  'US_OTHER_FUEL_SOLID_3',
  'US_OTHER_FUEL_SOLID_4',
  'US_BIOFUEL_SOLID_1',
  'US_BIOFUEL_SOLID_2',
  'US_BIOFUEL_SOLID_3',
  'US_BIOFUEL_SOLID_4',
  'US_FUEL_GAS_1',
  'US_OTHER_FUEL_GAS_1',
  'US_OTHER_FUEL_GAS_2',
  'US_OTHER_FUEL_GAS_3',
  'US_OTHER_FUEL_GAS_4',
  'US_BIOFUEL_GAS_1',
  'US_BIOFUEL_GAS_2',
  'US_FUEL_OIL_1',
  'US_FUEL_OIL_2',
  'US_FUEL_OIL_3',
  'US_FUEL_OIL_4',
  'US_FUEL_OIL_5',
  'US_FUEL_OIL_6',
  'US_FUEL_OIL_7',
  'US_FUEL_OIL_8',
  'US_FUEL_OIL_9',
  'US_FUEL_OIL_10',
  'US_FUEL_OIL_11',
  'US_FUEL_OIL_12',
  'US_FUEL_OIL_13',
  'US_FUEL_OIL_14',
  'US_FUEL_OIL_15',
  'US_FUEL_OIL_16',
  'US_FUEL_OIL_17',
  'US_FUEL_OIL_18',
  'US_FUEL_OIL_19',
  'US_FUEL_OIL_20',
  'US_FUEL_OIL_21',
  'US_FUEL_OIL_22',
  'US_FUEL_OIL_23',
  'US_FUEL_OIL_24',
  'US_FUEL_OIL_25',
  'US_FUEL_OIL_26',
  'US_FUEL_OIL_27',
  'US_FUEL_OIL_28',
  'US_FUEL_OIL_29',
  'US_FUEL_OIL_30',
  'US_BIOFUEL_LIQUID_1',
  'US_BIOFUEL_LIQUID_2',
  'US_BIOFUEL_LIQUID_3',
  'US_BIOFUEL_LIQUID_4',
  'US_FUEL_OIL_31',
  'US_FUEL_OIL_32',
  'US_FUEL_OIL_33',
  'US_FUEL_OIL_34',
  'US_FUEL_OIL_35',
  'US_FUEL_OIL_36',
  'US_FUEL_OIL_37',
  'US_FUEL_OIL_38',
  'US_FUEL_OIL_39',
  'US_FUEL_OIL_40',
  'US_FUEL_OIL_41',
  'US_FUEL_OIL_42',
  'US_FUEL_OIL_43',
  'US_FUEL_OIL_44',
  'US_FUEL_OIL_45',
  'US_FUEL_OIL_46',
  'US_FUEL_OIL_47',
  'US_FUEL_OIL_48',
  'US_FUEL_OIL_49',
  'US_FUEL_OIL_50',
  'US_FUEL_OIL_51',
  'US_FUEL_OIL_52',
  'US_FUEL_OIL_53',
  'US_FUEL_OIL_54',
  'US_FUEL_OIL_55',
  'US_FUEL_OIL_56',
  'US_FUEL_OIL_57',
  'US_FUEL_OIL_58',
  'US_FUEL_OIL_59',
  'US_FUEL_OIL_60',
  'US_FUEL_OIL_61',
  'US_FUEL_OIL_62',
  'US_FUEL_OIL_63',
  'US_FUEL_OIL_64',
  'US_FUEL_OIL_65',
  'US_FUEL_OIL_66',
  'US_FUEL_OIL_67',
  'US_FUEL_OIL_68',
  'US_FUEL_OIL_69',
  'US_FUEL_OIL_70',
  'US_FUEL_OIL_71',
  'US_FUEL_OIL_72',
  'US_FUEL_OIL_73',
  'US_FUEL_OIL_74',
  'US_FUEL_OIL_75',
  'US_FUEL_OIL_76',
  'US_FUEL_OIL_77',
  'US_FUEL_OIL_78',
  'US_FUEL_OIL_79',
  'US_FUEL_OIL_80',
  'US_FUEL_OIL_81',
  'US_FUEL_OIL_82',
  'US_FUEL_OIL_83',
  'US_FUEL_OIL_84',
  'US_FUEL_OIL_85',
  'US_FUEL_OIL_86',
  'US_FUEL_OIL_87',
  'US_FUEL_OIL_88',
  'US_FUEL_OIL_89',
  'US_FUEL_OIL_90',
  'US_FUEL_OIL_91',
  'US_FUEL_OIL_92',
  'US_FUEL_OIL_93',
  'US_FUEL_OIL_94',
  'US_FUEL_OIL_95',
  'US_FUEL_OIL_96',
  'US_FUEL_OIL_97',
  'US_FUEL_OIL_98',
  'US_FUEL_OIL_99',
  'US_FUEL_OIL_100',
  'US_FUEL_OIL_101',
  'US_FUEL_OIL_102',
  'US_FUEL_OIL_103',
  'US_FUEL_OIL_104',
  'US_FUEL_OIL_105',
  'US_FUEL_OIL_106',
  'US_FUEL_OIL_107',
  'US_FUEL_OIL_108',
  'US_FUEL_OIL_109',
  'US_FUEL_OIL_110',
  'US_FUEL_OIL_111',
  'US_FUEL_OIL_112',
  'US_FUEL_OIL_113',
  'US_FUEL_OIL_114',
  'US_FUEL_OIL_115',
  'US_FUEL_OIL_116',
  'US_FUEL_OIL_117',
  'US_FUEL_OIL_118',
  'US_FUEL_OIL_119',
  'US_FUEL_OIL_120',
  'US_FUEL_OIL_121',
  'US_FUEL_OIL_122',
  'US_FUEL_OIL_123',
  'US_FUEL_OIL_124',
  'US_FUEL_OIL_125',
  'US_FUEL_OIL_126',
  'US_FUEL_OIL_127',
  'US_FUEL_OIL_128',
  'US_FUEL_OIL_129',
  'US_FUEL_OIL_130',
  'US_FUEL_OIL_131',
  'US_FUEL_OIL_132',
  'US_FUEL_OIL_133',
  'US_FUEL_OIL_134',
  'US_FUEL_OIL_135',
  'US_FUEL_OIL_136',
  'US_FUEL_OIL_137',
  'US_FUEL_OIL_138',
  'US_FUEL_OIL_139',
  'US_FUEL_OIL_140',
  'US_FUEL_OIL_141',
  'US_FUEL_OIL_142',
  'US_FUEL_OIL_143',
  'US_FUEL_OIL_144',
  'US_FUEL_OIL_145',
  'US_FUEL_OIL_146',
  'US_FUEL_OIL_147',
  'US_FUEL_OIL_148',
  'US_FUEL_OIL_149',
  'US_FUEL_OIL_150',
  'US_FUEL_OIL_151',
  'US_FUEL_OIL_152',
  'US_FUEL_OIL_153',
  'US_FUEL_OIL_154',
  'US_FUEL_OIL_155',
  'US_FUEL_OIL_156',
  'US_FUEL_OIL_157',
  'US_FUEL_OIL_158',
  'US_FUEL_OIL_159',
  'US_FUEL_OIL_160',
  'US_FUEL_OIL_161',
  'US_FUEL_OIL_162',
  'US_FUEL_OIL_163',
  'US_FUEL_OIL_164',
  'US_FUEL_OIL_165',
  'US_FUEL_OIL_166',
  'US_FUEL_OIL_167',
  'US_FUEL_OIL_168',
  'US_FUEL_OIL_169',
  'US_FUEL_OIL_170',
  'US_FUEL_OIL_171',
  'US_FUEL_OIL_172',
  'US_FUEL_OIL_173',
  'US_FUEL_OIL_174',
  'US_FUEL_OIL_175',
  'US_FUEL_OIL_176',
  'US_FUEL_OIL_177',
  'US_FUEL_OIL_178',
  'US_FUEL_OIL_179',
  'US_FUEL_OIL_180',
  'US_FUEL_OIL_181',
  'US_FUEL_OIL_182',
  'US_FUEL_OIL_183',
  'US_FUEL_OIL_184',
  'US_FUEL_OIL_185',
  'US_FUEL_OIL_186',
  'US_FUEL_OIL_187',
  'US_FUEL_OIL_188',
  'US_FUEL_OIL_189',
  'US_FUEL_OIL_190',
  'US_FUEL_OIL_191',
  'US_FUEL_OIL_192',
  'US_FUEL_OIL_193',
  'US_FUEL_OIL_194',
  'US_FUEL_OIL_195',
  'US_FUEL_OIL_196',
  'US_FUEL_OIL_197',
  'US_FUEL_OIL_198',
  'US_FUEL_OIL_199',
  'US_FUEL_OIL_200',
  'US_FUEL_OIL_201',
  'US_FUEL_OIL_202',
  'US_FUEL_OIL_203',
  'US_FUEL_OIL_204',
  'US_FUEL_OIL_205',
  'US_FUEL_OIL_206',
  'US_FUEL_OIL_207',
  'US_FUEL_OIL_208',
  'US_FUEL_OIL_209',
  'US_FUEL_OIL_210',
  'US_FUEL_OIL_211',
  'US_FUEL_OIL_212',
  'US_FUEL_OIL_213',
  'US_FUEL_OIL_214',
  'US_FUEL_OIL_215',
  'US_FUEL_OIL_216',
  'US_FUEL_OIL_217',
  'US_FUEL_OIL_218',
  'US_FUEL_OIL_219',
  'US_FUEL_OIL_220',
  'US_FUEL_OIL_221',
  'US_FUEL_OIL_222',
  'US_FUEL_OIL_223',
  'US_FUEL_OIL_224',
  'US_FUEL_OIL_225',
  'US_FUEL_OIL_226',
  'CN_COAL_1',
  'CN_COAL_2',
  'CN_COAL_3',
  'CN_COAL_4',
  'CN_COAL_5',
  'CN_COAL_6',
  'CN_COAL_7',
  'CN_COAL_8',
  'CN_COAL_9',
  'CN_COAL_10',
  'CN_COAL_11',
  'CN_COAL_12',
  'CN_COAL_13',
  'CN_COAL_14',
  'CN_COAL_15',
  'CN_COAL_16',
  'CN_COAL_17',
  'CN_COAL_18',
  'CN_COAL_19',
  'CN_COAL_20',
  'CN_COAL_21',
  'CN_COAL_22',
  'CN_COAL_23',
  'CN_COAL_24',
  'CN_COAL_25',
  'CN_COAL_26',
  'CN_COAL_27',
  'CN_COAL_28',
  'CN_COAL_29',
  'CN_COAL_30',
  'CN_COAL_31',
  'CN_COAL_32',
  'CN_COAL_33',
  'CN_COAL_34',
  'CN_COAL_35',
  'CN_COAL_36',
  'CN_COAL_37',
  'CN_COAL_38',
  'CN_COAL_39',
  'CN_COAL_40',
  'CN_COAL_41',
  'CN_COAL_42',
  'CN_COAL_43',
  'CN_COAL_44',
  'CN_COAL_45',
  'CN_COAL_46',
  'CN_COAL_47',
  'CN_COAL_48',
  'CN_COAL_49',
  'CN_COAL_50',
  'CN_COAL_51',
  'CN_COAL_52',
  'CN_COAL_53',
  'CN_COAL_54',
  'CN_COAL_55',
  'CN_COAL_56',
  'CN_COAL_57',
  'CN_COAL_58',
  'CN_COAL_59',
  'CN_COAL_60',
  'CN_COAL_61',
  'CN_COAL_62',
  'CN_COAL_63',
  'CN_COAL_64',
  'CN_COAL_65',
  'CN_COAL_66',
  'CN_COAL_67',
  'CN_COAL_68',
  'CN_COAL_69',
  'CN_COAL_70',
  'CN_COAL_71',
  'CN_COAL_72',
  'CN_COAL_73',
  'CN_COAL_74',
  'CN_COAL_75',
  'CN_COAL_76',
  'CN_COAL_77',
  'CN_COAL_78',
  'CN_COAL_79',
  'CN_COAL_80',
  'CN_COAL_81',
  'CN_COAL_82',
  'CN_COAL_83',
  'CN_COAL_84',
  'CN_COAL_85',
  'CN_COAL_86',
  'CN_COAL_87',
  'CN_COAL_88',
  'CN_COAL_89',
  'CN_COAL_90',
  'CN_COAL_91',
  'CN_COAL_92',
  'CN_COAL_93',
  'CN_COAL_94',
  'CN_COAL_95',
  'CN_COAL_96',
  'CN_COAL_97',
  'CN_COAL_98',
  'CN_COAL_99',
  'CN_COAL_100',
  'CN_COAL_101',
  'CN_COAL_102',
  'CN_COAL_103',
  'CN_COAL_104',
  'CN_COAL_105',
  'CN_COAL_106',
  'CN_COAL_107',
  'CN_COAL_108',
  'CN_COAL_109',
  'CN_COAL_110',
  'CN_COAL_111',
  'CN_COAL_112',
  'CN_COAL_113',
  'CN_COAL_114',
  'CN_COAL_115',
  'CN_COAL_116',
  'CN_COAL_117',
  'CN_COAL_118',
  'CN_COAL_119',
  'CN_COAL_120',
  'CN_COAL_121',
  'CN_COAL_122',
  'CN_COAL_123',
  'CN_COAL_124',
  'CN_COAL_125',
  'CN_COAL_126',
  'CN_COAL_127',
  'CN_COAL_128',
  'CN_COAL_129',
  'CN_COAL_130',
  'CN_COAL_131',
  'CN_COAL_132',
  'CN_COAL_133',
  'CN_COAL_134',
  'CN_COAL_135',
  'CN_COAL_136',
  'CN_COAL_137',
  'CN_COAL_138',
  'CN_COAL_139',
  'CN_COAL_140',
  'CN_COAL_141',
  'CN_COAL_142',
  'CN_COAL_143',
  'CN_COAL_144',
  'CN_COAL_145',
  'CN_COAL_146',
  'CN_COAL_147',
  'CN_COAL_148',
  'CN_COAL_149',
  'CN_COAL_150',
  'CN_COAL_151',
  'CN_COAL_152',
  'CN_COAL_153',
  'CN_COAL_154',
  'CN_COAL_155',
  'CN_COAL_156',
  'CN_COAL_157',
  'CN_COAL_158',
  'CN_COAL_159',
  'CN_COAL_160',
  'CN_COAL_161',
  'CN_COAL_162',
  'CN_COAL_163',
  'CN_COAL_164',
  'CN_COAL_165',
  'CN_COAL_166',
  'CN_COAL_167',
  'CN_COAL_168',
  'CN_COAL_169',
  'CN_COAL_170',
  'CN_COAL_171',
  'CN_COAL_172',
  'CN_COAL_173',
  'CN_COAL_174',
  'CN_COAL_175',
  'CN_COAL_176',
  'CN_COAL_177',
  'CN_COAL_178',
  'CN_COAL_179',
  'CN_FUEL_OIL_1',
  'CN_FUEL_OIL_2',
  'CN_FUEL_OIL_3',
  'CN_FUEL_OIL_4',
  'CN_FUEL_OIL_5',
  'CN_FUEL_OIL_6',
  'CN_FUEL_OIL_7',
  'CN_FUEL_OIL_8',
  'CN_FUEL_OIL_9',
  'CN_FUEL_OIL_10',
  'CN_FUEL_OIL_11',
  'CN_FUEL_OIL_12',
  'CN_FUEL_OIL_13',
  'CN_FUEL_OIL_14',
  'CN_FUEL_OIL_15',
  'CN_FUEL_OIL_16',
  'CN_FUEL_OIL_17',
  'CN_FUEL_OIL_18',
  'CN_FUEL_OIL_19',
  'CN_FUEL_OIL_20',
  'CN_FUEL_OIL_21',
  'CN_FUEL_OIL_22',
  'CN_FUEL_OIL_23',
  'CN_FUEL_OIL_24',
  'CN_FUEL_OIL_25',
  'CN_FUEL_OIL_26',
  'CN_FUEL_OIL_27',
  'CN_FUEL_OIL_28',
  'CN_FUEL_OIL_29',
  'CN_FUEL_OIL_30',
  'CN_FUEL_OIL_31',
  'CN_FUEL_OIL_32',
  'CN_FUEL_OIL_33',
  'CN_FUEL_OIL_34',
  'CN_FUEL_OIL_35',
  'CN_FUEL_OIL_36',
  'CN_FUEL_OIL_37',
  'CN_FUEL_OIL_38',
  'CN_FUEL_OIL_39',
  'CN_FUEL_OIL_40',
  'CN_FUEL_OIL_41',
  'CN_FUEL_OIL_42',
  'CN_FUEL_OIL_43',
  'CN_FUEL_OIL_44',
  'CN_FUEL_OIL_45',
  'CN_FUEL_OIL_46',
  'CN_FUEL_OIL_47',
  'CN_FUEL_OIL_48',
  'CN_FUEL_OIL_49',
  'CN_FUEL_OIL_50',
  'CN_FUEL_OIL_51',
  'CN_FUEL_OIL_52',
  'CN_FUEL_OIL_53',
  'CN_FUEL_OIL_54',
  'CN_FUEL_OIL_55',
  'CN_FUEL_OIL_56',
  'CN_FUEL_OIL_57',
  'CN_FUEL_OIL_58',
  'CN_FUEL_OIL_59',
  'CN_FUEL_OIL_60',
  'CN_FUEL_OIL_61',
  'CN_FUEL_OIL_62',
  'CN_FUEL_OIL_63',
  'CN_FUEL_OIL_64',
  'CN_FUEL_OIL_65',
  'CN_FUEL_OIL_66',
  'CN_FUEL_OIL_67',
  'CN_FUEL_OIL_68',
  'CN_FUEL_OIL_69',
  'CN_FUEL_OIL_70',
  'CN_FUEL_OIL_71',
  'CN_FUEL_OIL_72',
  'CN_FUEL_OIL_73',
  'CN_FUEL_OIL_74',
  'CN_FUEL_OIL_75',
  'CN_FUEL_OIL_76',
  'CN_FUEL_OIL_77',
  'CN_FUEL_OIL_78',
  'CN_FUEL_OIL_79',
  'CN_FUEL_OIL_80',
  'CN_FUEL_OIL_81',
  'CN_FUEL_OIL_82',
  'CN_FUEL_OIL_83',
  'CN_FUEL_OIL_84',
  'CN_FUEL_OIL_85',
  'CN_FUEL_OIL_86',
  'CN_FUEL_OIL_87',
  'CN_FUEL_OIL_88',
  'CN_FUEL_OIL_89',
  'CN_FUEL_OIL_90',
  'CN_FUEL_OIL_91',
  'CN_FUEL_OIL_92',
  'CN_FUEL_OIL_93',
  'CN_FUEL_OIL_94',
  'CN_FUEL_OIL_95',
  'CN_FUEL_OIL_96',
  'CN_FUEL_OIL_97',
  'CN_FUEL_OIL_98',
  'CN_FUEL_OIL_99',
  'CN_FUEL_OIL_100',
  'CN_FUEL_OIL_101',
  'CN_FUEL_OIL_102',
  'CN_FUEL_OIL_103',
  'CN_FUEL_OIL_104',
  'CN_FUEL_OIL_105',
  'CN_FUEL_OIL_106',
  'CN_FUEL_OIL_107',
  'CN_FUEL_OIL_108',
  'CN_FUEL_OIL_109',
  'CN_FUEL_OIL_110',
  'CN_FUEL_OIL_111',
  'CN_FUEL_OIL_112',
  'CN_FUEL_OIL_113',
  'CN_FUEL_OIL_114',
  'CN_FUEL_OIL_115',
  'CN_FUEL_OIL_116',
  'CN_FUEL_OIL_117',
  'CN_FUEL_OIL_118',
  'CN_FUEL_OIL_119',
  'CN_FUEL_OIL_120',
  'CN_FUEL_OIL_121',
  'CN_FUEL_OIL_122',
  'CN_FUEL_OIL_123',
  'CN_FUEL_OIL_124',
  'CN_FUEL_OIL_125',
  'CN_FUEL_OIL_126',
  'CN_FUEL_OIL_127',
  'CN_FUEL_OIL_128',
  'CN_FUEL_OIL_129',
  'CN_FUEL_OIL_130',
  'CN_FUEL_OIL_131',
  'CN_FUEL_OIL_132',
  'CN_FUEL_OIL_133',
  'CN_FUEL_OIL_134',
  'CN_FUEL_OIL_135',
  'CN_FUEL_OIL_136',
  'CN_FUEL_OIL_137',
  'CN_FUEL_OIL_138',
  'CN_FUEL_OIL_139',
  'CN_FUEL_OIL_140',
  'CN_FUEL_OIL_141',
  'CN_FUEL_OIL_142',
  'CN_FUEL_OIL_143',
  'CN_FUEL_OIL_144',
  'CN_FUEL_OIL_145',
  'CN_FUEL_OIL_146',
  'CN_FUEL_OIL_147',
  'CN_FUEL_OIL_148',
  'CN_FUEL_OIL_149',
  'CN_FUEL_OIL_150',
  'CN_FUEL_OIL_151',
  'CN_FUEL_OIL_152',
  'CN_FUEL_OIL_153',
  'CN_FUEL_OIL_154',
  'CN_FUEL_OIL_155',
  'CN_FUEL_OIL_156',
  'CN_FUEL_OIL_157',
  'CN_FUEL_OIL_158',
  'CN_FUEL_OIL_159',
  'CN_FUEL_GAS_1',
  'CN_FUEL_GAS_2',
  'CN_FUEL_GAS_3',
  'CN_FUEL_GAS_4',
  'CN_FUEL_GAS_5',
  'CN_FUEL_GAS_6',
  'CN_FUEL_GAS_7',
  'CN_FUEL_GAS_8',
  'CN_FUEL_GAS_9',
  'CN_FUEL_GAS_10',
  'CN_FUEL_GAS_11',
  'CN_FUEL_GAS_12',
  'CN_FUEL_GAS_13',
  'CN_FUEL_GAS_14',
  'CN_FUEL_GAS_15',
  'CN_FUEL_GAS_16',
  'CN_FUEL_GAS_17',
  'CN_FUEL_GAS_18',
  'CN_FUEL_GAS_19',
  'CN_FUEL_GAS_20',
  'CN_FUEL_GAS_21',
  'CN_FUEL_GAS_22',
  'CN_FUEL_GAS_23',
  'CN_FUEL_GAS_24',
  'CN_FUEL_GAS_25',
  'CN_FUEL_GAS_26',
  'CN_FUEL_GAS_27',
  'CN_FUEL_GAS_28',
  'CN_FUEL_GAS_29',
  'CN_FUEL_GAS_30',
  'CN_FUEL_GAS_31',
  'CN_FUEL_GAS_32',
  'CN_FUEL_GAS_33',
  'CN_FUEL_GAS_34',
  'CN_FUEL_GAS_35',
  'CN_FUEL_GAS_36',
  'CN_FUEL_GAS_37',
  'CN_FUEL_GAS_38',
  'CN_FUEL_GAS_39',
  'CN_FUEL_GAS_40',
  'CN_FUEL_GAS_41',
  'CN_FUEL_GAS_42',
  'CN_FUEL_GAS_43',
  'CN_FUEL_GAS_44',
  'CN_FUEL_GAS_45',
  'CN_FUEL_GAS_46',
  'CN_FUEL_GAS_47',
  'CN_FUEL_GAS_48',
  'CN_FUEL_GAS_49',
  'CN_FUEL_GAS_50',
  'CN_FUEL_GAS_51',
  'CN_FUEL_GAS_52',
  'CN_FUEL_GAS_53',
  'CN_FUEL_GAS_54',
  'CN_FUEL_GAS_55',
  'CN_FUEL_GAS_56',
  'CN_FUEL_GAS_57',
  'CN_FUEL_GAS_58',
  'CN_FUEL_GAS_59',
  'CN_FUEL_GAS_60',
  'CN_FUEL_GAS_61',
  'CN_FUEL_GAS_62',
  'CN_FUEL_GAS_63',
  'CN_FUEL_GAS_64',
  'CN_FUEL_GAS_65',
  'CN_FUEL_GAS_66',
  'CN_FUEL_GAS_67',
  'CN_FUEL_GAS_68',
  'CN_FUEL_GAS_69',
  'CN_FUEL_GAS_70',
  'CN_FUEL_GAS_71',
  'CN_FUEL_GAS_72',
  'CN_FUEL_GAS_73',
  'CN_FUEL_GAS_74',
  'CN_FUEL_GAS_75',
  'CN_FUEL_GAS_76',
  'CN_FUEL_GAS_77',
  'CN_FUEL_GAS_78',
  'CN_FUEL_GAS_79',
  'CN_FUEL_GAS_80',
  'CN_FUEL_GAS_81',
  'CN_FUEL_GAS_82',
  'CN_FUEL_GAS_83',
  'CN_FUEL_GAS_84',
  'CN_FUEL_GAS_85',
  'CN_FUEL_GAS_86',
  'CN_OTHER_FUEL_1',
  'CN_OTHER_FUEL_2',
  'CN_OTHER_FUEL_3',
  'CN_OTHER_FUEL_4',
  'CN_OTHER_FUEL_5',
  'CN_OTHER_FUEL_6',
  'CN_OTHER_FUEL_7',
  'CN_OTHER_FUEL_8',
  'CN_OTHER_FUEL_9',
  'CN_OTHER_FUEL_10',
  'CN_OTHER_FUEL_11',
  'CN_OTHER_FUEL_12',
  'CN_OTHER_FUEL_13',
  'CN_OTHER_FUEL_14',
  'CN_OTHER_FUEL_15',
  'CN_OTHER_FUEL_16',
  'CN_OTHER_FUEL_17',
  'CN_OTHER_FUEL_18',
  'CN_OTHER_FUEL_19',
  'CN_OTHER_FUEL_20',
  'CN_OTHER_FUEL_21',
  'CN_OTHER_FUEL_22',
  'CN_OTHER_FUEL_23',
  'CN_OTHER_FUEL_24',
  'CN_BIOFUEL_1',
  'CN_BIOFUEL_2',
  'CN_BIOFUEL_3',
  'CN_BIOFUEL_4',
  'CN_BIOFUEL_5',
  'CN_BIOFUEL_6',
  'CN_FUEL_OIL_160',
  'CN_FUEL_OIL_161',
  'CN_FUEL_OIL_162',
  'CN_FUEL_OIL_163',
  'CN_FUEL_OIL_164',
  'CN_FUEL_OIL_165',
  'CN_FUEL_OIL_166',
  'CN_FUEL_OIL_167',
  'CN_FUEL_OIL_168',
  'CN_FUEL_OIL_169',
  'CN_FUEL_OIL_170',
  'CN_FUEL_OIL_171',
  'VN_FUEL_OIL_1',
  'VN_FUEL_OIL_2',
  'VN_FUEL_OIL_3',
  'VN_FUEL_OIL_4',
  'VN_FUEL_OIL_5',
  'VN_FUEL_OIL_6',
  'VN_FUEL_OIL_7',
  'VN_FUEL_OIL_8',
  'VN_FUEL_OIL_9',
  'VN_FUEL_GAS_1',
  'VN_FUEL_GAS_2',
  'VN_FUEL_GAS_3',
  'VN_FUEL_GAS_4',
  'VN_FUEL_GAS_5',
  'VN_COAL_1',
  'VN_COAL_2',
  'VN_COAL_3',
  'VN_COAL_4',
  'VN_COAL_5',
  'VN_COAL_6',
  'VN_COAL_7',
  'VN_COAL_8',
  'VN_BIOFUEL_1',
  'VN_BIOFUEL_2',
  'VN_BIOFUEL_3',
  'VN_BIOFUEL_4',
  'VN_FUEL_OIL_10',
  'VN_FUEL_OIL_11',
  'VN_FUEL_OIL_12',
  'VN_FUEL_OIL_13',
  'VN_FUEL_OIL_14',
  'VN_FUEL_GAS_6',
  'VN_FUEL_GAS_7',
  'VN_FUEL_OIL_15',
  'VN_FUEL_OIL_16',
  'VN_FUEL_OIL_17',
  'MX_FUEL_OIL_1',
  'MX_FUEL_OIL_2',
  'MX_FUEL_OIL_3',
  'MX_FUEL_OIL_4',
  'MX_FUEL_OIL_5',
  'MX_FUEL_OIL_6',
  'MX_FUEL_OIL_7',
  'MX_FUEL_OIL_8',
  'MX_FUEL_OIL_9',
  'MX_FUEL_OIL_10',
  'MX_FUEL_OIL_11',
  'MX_FUEL_OIL_12',
  'MX_FUEL_OIL_13',
  'MX_FUEL_OIL_14',
  'MX_FUEL_OIL_15',
  'MX_FUEL_OIL_16',
  'MX_FUEL_OIL_17',
  'MX_COAL_1',
  'MX_COAL_2',
  'MX_COAL_3',
  'MX_COAL_4',
  'MX_COAL_5',
  'MX_COAL_6',
  'MX_COAL_7',
  'MX_COAL_8',
  'MX_COAL_9',
  'MX_COAL_10',
  'MX_FUEL_GAS_1',
  'MX_FUEL_GAS_2',
  'MX_FUEL_GAS_3',
  'MX_FUEL_GAS_4',
  'MX_FUEL_GAS_5',
  'MX_FUEL_GAS_6',
  'MX_FUEL_GAS_7',
  'MX_FUEL_GAS_8',
  'MX_FUEL_GAS_9',
  'MX_FUEL_GAS_10',
  'MX_FUEL_GAS_11',
  'MX_BIOFUEL_1',
  'MX_BIOFUEL_2',
  'MX_BIOFUEL_3',
  'MX_BIOFUEL_4',
  'MX_BIOFUEL_5',
  'MX_BIOFUEL_6',
  'MX_BIOFUEL_7',
  'MX_BIOFUEL_8',
  'MX_BIOFUEL_9',
  'MX_BIOFUEL_10',
  'MX_BIOFUEL_11',
  'MX_BIOFUEL_12',
  'MX_BIOFUEL_13',
  'MX_BIOFUEL_14',
  'MX_OTHER_FUEL_1',
  'MX_OTHER_FUEL_2',
  'MX_OTHER_FUEL_3',
  'MX_OTHER_FUEL_4',
  'MX_OTHER_FUEL_5',
  'MX_FUEL_OIL_18',
  'MX_FUEL_OIL_19',
  'MX_FUEL_OIL_20',
  'MX_FUEL_OIL_21',
  'MX_FUEL_OIL_22',
  'MX_FUEL_OIL_23',
  'MX_FUEL_OIL_24',
  'MX_FUEL_OIL_25',
  'MX_FUEL_OIL_26',
  'MX_FUEL_OIL_27',
  'MX_FUEL_OIL_28',
  'MX_FUEL_OIL_29',
  'MX_FUEL_OIL_30',
  'MX_FUEL_OIL_31',
  'MX_FUEL_OIL_32',
  'MX_FUEL_OIL_33',
  'MX_FUEL_OIL_34',
  'MX_FUEL_OIL_35',
  'MX_FUEL_OIL_36',
  'MX_FUEL_OIL_37',
  'MX_FUEL_OIL_38',
  'MX_FUEL_GAS_12',
  'MX_FUEL_GAS_13',
  'MX_FUEL_GAS_14',
  'MX_FUEL_GAS_15',
  'CA_FUEL_GAS_1',
  'CA_FUEL_GAS_2',
  'CA_FUEL_GAS_3',
  'CA_FUEL_GAS_4',
  'CA_FUEL_GAS_5',
  'CA_FUEL_GAS_6',
  'CA_FUEL_GAS_7',
  'CA_FUEL_GAS_8',
  'CA_FUEL_GAS_9',
  'CA_FUEL_GAS_10',
  'CA_FUEL_GAS_11',
  'CA_FUEL_GAS_12',
  'CA_FUEL_GAS_13',
  'CA_FUEL_GAS_14',
  'CA_FUEL_GAS_15',
  'CA_FUEL_GAS_16',
  'CA_FUEL_GAS_17',
  'CA_FUEL_GAS_18',
  'CA_FUEL_GAS_19',
  'CA_FUEL_GAS_20',
  'CA_FUEL_GAS_21',
  'CA_FUEL_GAS_22',
  'CA_FUEL_GAS_23',
  'CA_FUEL_GAS_24',
  'CA_FUEL_GAS_25',
  'CA_FUEL_GAS_26',
  'CA_FUEL_GAS_27',
  'CA_FUEL_GAS_28',
  'CA_FUEL_GAS_29',
  'CA_FUEL_GAS_30',
  'CA_FUEL_GAS_31',
  'CA_FUEL_GAS_32',
  'CA_FUEL_GAS_33',
  'CA_FUEL_GAS_34',
  'CA_FUEL_GAS_35',
  'CA_FUEL_GAS_36',
  'CA_FUEL_GAS_37',
  'CA_FUEL_GAS_38',
  'CA_FUEL_GAS_39',
  'CA_FUEL_GAS_40',
  'CA_FUEL_GAS_41',
  'CA_FUEL_GAS_42',
  'CA_FUEL_GAS_43',
  'CA_FUEL_GAS_44',
  'CA_FUEL_GAS_45',
  'CA_FUEL_GAS_46',
  'CA_FUEL_GAS_47',
  'CA_FUEL_GAS_48',
  'CA_FUEL_GAS_49',
  'CA_FUEL_GAS_50',
  'CA_FUEL_GAS_51',
  'CA_FUEL_GAS_52',
  'CA_FUEL_GAS_53',
  'CA_FUEL_GAS_54',
  'CA_FUEL_GAS_55',
  'CA_FUEL_GAS_56',
  'CA_FUEL_GAS_57',
  'CA_FUEL_GAS_58',
  'CA_FUEL_GAS_59',
  'CA_FUEL_GAS_60',
  'CA_FUEL_GAS_61',
  'CA_FUEL_GAS_62',
  'CA_FUEL_GAS_63',
  'CA_FUEL_GAS_64',
  'CA_FUEL_GAS_65',
  'CA_FUEL_GAS_66',
  'CA_FUEL_GAS_67',
  'CA_FUEL_GAS_68',
  'CA_FUEL_GAS_69',
  'CA_FUEL_GAS_70',
  'CA_FUEL_GAS_71',
  'CA_FUEL_GAS_72',
  'CA_FUEL_GAS_73',
  'CA_FUEL_GAS_74',
  'CA_FUEL_GAS_75',
  'CA_FUEL_GAS_76',
  'CA_FUEL_GAS_77',
  'CA_FUEL_GAS_78',
  'CA_FUEL_GAS_79',
  'CA_FUEL_GAS_80',
  'CA_FUEL_GAS_81',
  'CA_FUEL_GAS_82',
  'CA_FUEL_GAS_83',
  'CA_FUEL_GAS_84',
  'CA_FUEL_GAS_85',
  'CA_FUEL_GAS_86',
  'CA_FUEL_GAS_87',
  'CA_FUEL_GAS_88',
  'CA_FUEL_GAS_89',
  'CA_FUEL_GAS_90',
  'CA_FUEL_GAS_91',
  'CA_FUEL_GAS_92',
  'CA_FUEL_GAS_93',
  'CA_FUEL_GAS_94',
  'CA_FUEL_GAS_95',
  'CA_FUEL_GAS_96',
  'CA_FUEL_GAS_97',
  'CA_FUEL_GAS_98',
  'CA_FUEL_GAS_99',
  'CA_FUEL_GAS_100',
  'CA_FUEL_GAS_101',
  'CA_FUEL_GAS_102',
  'CA_FUEL_GAS_103',
  'CA_FUEL_GAS_104',
  'CA_FUEL_GAS_105',
  'CA_FUEL_GAS_106',
  'CA_FUEL_GAS_107',
  'CA_FUEL_GAS_108',
  'CA_FUEL_GAS_109',
  'CA_FUEL_GAS_110',
  'CA_FUEL_GAS_111',
  'CA_FUEL_GAS_112',
  'CA_FUEL_GAS_113',
  'CA_FUEL_GAS_114',
  'CA_FUEL_GAS_115',
  'CA_FUEL_GAS_116',
  'CA_FUEL_GAS_117',
  'CA_FUEL_GAS_118',
  'CA_FUEL_GAS_119',
  'CA_FUEL_GAS_120',
  'CA_FUEL_GAS_121',
  'CA_FUEL_GAS_122',
  'CA_FUEL_GAS_123',
  'CA_FUEL_GAS_124',
  'CA_FUEL_GAS_125',
  'CA_FUEL_GAS_126',
  'CA_FUEL_GAS_127',
  'CA_FUEL_GAS_128',
  'CA_FUEL_GAS_129',
  'CA_FUEL_GAS_130',
  'CA_FUEL_GAS_131',
  'CA_FUEL_GAS_132',
  'CA_FUEL_GAS_133',
  'CA_FUEL_GAS_134',
  'CA_FUEL_GAS_135',
  'CA_FUEL_GAS_136',
  'CA_FUEL_GAS_137',
  'CA_FUEL_GAS_138',
  'CA_FUEL_GAS_139',
  'CA_FUEL_GAS_140',
  'CA_FUEL_GAS_141',
  'CA_FUEL_GAS_142',
  'CA_FUEL_GAS_143',
  'CA_FUEL_GAS_144',
  'CA_FUEL_GAS_145',
  'CA_FUEL_GAS_146',
  'CA_FUEL_GAS_147',
  'CA_FUEL_GAS_148',
  'CA_FUEL_GAS_149',
  'CA_FUEL_GAS_150',
  'CA_FUEL_GAS_151',
  'CA_FUEL_GAS_152',
  'CA_FUEL_GAS_153',
  'CA_FUEL_GAS_154',
  'CA_FUEL_GAS_155',
  'CA_FUEL_GAS_156',
  'CA_FUEL_GAS_157',
  'CA_FUEL_GAS_158',
  'CA_FUEL_GAS_159',
  'CA_FUEL_GAS_160',
  'CA_FUEL_GAS_161',
  'CA_FUEL_GAS_162',
  'CA_FUEL_GAS_163',
  'CA_FUEL_GAS_164',
  'CA_FUEL_GAS_165',
  'CA_FUEL_GAS_166',
  'CA_FUEL_GAS_167',
  'CA_FUEL_GAS_168',
  'CA_FUEL_GAS_169',
  'CA_FUEL_GAS_170',
  'CA_FUEL_GAS_171',
  'CA_FUEL_GAS_172',
  'CA_FUEL_GAS_173',
  'CA_FUEL_GAS_174',
  'CA_FUEL_GAS_175',
  'CA_FUEL_GAS_176',
  'CA_FUEL_GAS_177',
  'CA_FUEL_GAS_178',
  'CA_FUEL_GAS_179',
  'CA_FUEL_GAS_180',
  'CA_FUEL_GAS_181',
  'CA_FUEL_GAS_182',
  'CA_FUEL_GAS_183',
  'CA_FUEL_GAS_184',
  'CA_FUEL_GAS_185',
  'CA_FUEL_GAS_186',
  'CA_FUEL_GAS_187',
  'CA_FUEL_GAS_188',
  'CA_FUEL_GAS_189',
  'CA_FUEL_GAS_190',
  'CA_FUEL_GAS_191',
  'CA_FUEL_GAS_192',
  'CA_FUEL_GAS_193',
  'CA_FUEL_GAS_194',
  'CA_FUEL_GAS_195',
  'CA_FUEL_GAS_196',
  'CA_FUEL_GAS_197',
  'CA_FUEL_GAS_198',
  'CA_FUEL_GAS_199',
  'CA_FUEL_GAS_200',
  'CA_FUEL_GAS_201',
  'CA_FUEL_GAS_202',
  'CA_FUEL_GAS_203',
  'CA_FUEL_GAS_204',
  'CA_FUEL_GAS_205',
  'CA_FUEL_GAS_206',
  'CA_FUEL_GAS_207',
  'CA_FUEL_GAS_208',
  'CA_FUEL_GAS_209',
  'CA_FUEL_GAS_210',
  'CA_FUEL_GAS_211',
  'CA_FUEL_GAS_212',
  'CA_FUEL_GAS_213',
  'CA_FUEL_GAS_214',
  'CA_FUEL_GAS_215',
  'CA_FUEL_GAS_216',
  'CA_FUEL_GAS_217',
  'CA_FUEL_GAS_218',
  'CA_FUEL_GAS_219',
  'CA_FUEL_GAS_220',
  'CA_FUEL_GAS_221',
  'CA_FUEL_GAS_222',
  'CA_FUEL_GAS_223',
  'CA_FUEL_GAS_224',
  'CA_FUEL_GAS_225',
  'CA_FUEL_GAS_226',
  'CA_FUEL_GAS_227',
  'CA_FUEL_GAS_228',
  'CA_FUEL_GAS_229',
  'CA_FUEL_GAS_230',
  'CA_FUEL_GAS_231',
  'CA_FUEL_GAS_232',
  'CA_FUEL_GAS_233',
  'CA_FUEL_GAS_234',
  'CA_FUEL_GAS_235',
  'CA_FUEL_GAS_236',
  'CA_FUEL_GAS_237',
  'CA_FUEL_GAS_238',
  'CA_FUEL_GAS_239',
  'CA_FUEL_GAS_240',
  'CA_FUEL_GAS_241',
  'CA_FUEL_GAS_242',
  'CA_FUEL_GAS_243',
  'CA_FUEL_GAS_244',
  'CA_FUEL_GAS_245',
  'CA_FUEL_GAS_246',
  'CA_FUEL_GAS_247',
  'CA_FUEL_GAS_248',
  'CA_FUEL_GAS_249',
  'CA_FUEL_GAS_250',
  'CA_FUEL_GAS_251',
  'CA_FUEL_GAS_252',
  'CA_FUEL_GAS_253',
  'CA_FUEL_GAS_254',
  'CA_FUEL_GAS_255',
  'CA_FUEL_GAS_256',
  'CA_FUEL_GAS_257',
  'CA_FUEL_GAS_258',
  'CA_FUEL_GAS_259',
  'CA_FUEL_GAS_260',
  'CA_FUEL_GAS_261',
  'CA_FUEL_GAS_262',
  'CA_FUEL_GAS_263',
  'CA_FUEL_GAS_264',
  'CA_FUEL_GAS_265',
  'CA_FUEL_GAS_266',
  'CA_FUEL_GAS_267',
  'CA_FUEL_GAS_268',
  'CA_FUEL_GAS_269',
  'CA_FUEL_GAS_270',
  'CA_FUEL_GAS_271',
  'CA_FUEL_GAS_272',
  'CA_FUEL_GAS_273',
  'CA_FUEL_GAS_274',
  'CA_FUEL_GAS_275',
  'CA_FUEL_GAS_276',
  'CA_FUEL_GAS_277',
  'CA_FUEL_GAS_278',
  'CA_FUEL_GAS_279',
  'CA_FUEL_GAS_280',
  'CA_FUEL_GAS_281',
  'CA_FUEL_GAS_282',
  'CA_FUEL_GAS_283',
  'CA_FUEL_GAS_284',
  'CA_FUEL_GAS_285',
  'CA_FUEL_GAS_286',
  'CA_FUEL_GAS_287',
  'CA_FUEL_GAS_288',
  'CA_FUEL_GAS_289',
  'CA_FUEL_GAS_290',
  'CA_FUEL_GAS_291',
  'CA_FUEL_GAS_292',
  'CA_FUEL_GAS_293',
  'CA_FUEL_GAS_294',
  'CA_FUEL_GAS_295',
  'CA_FUEL_GAS_296',
  'CA_FUEL_GAS_297',
  'CA_FUEL_GAS_298',
  'CA_FUEL_GAS_299',
  'CA_FUEL_GAS_300',
  'CA_FUEL_GAS_301',
  'CA_FUEL_GAS_302',
  'CA_FUEL_GAS_303',
  'CA_FUEL_GAS_304',
  'CA_FUEL_GAS_305',
  'CA_FUEL_GAS_306',
  'CA_FUEL_GAS_307',
  'CA_FUEL_GAS_308',
  'CA_FUEL_GAS_309',
  'CA_FUEL_GAS_310',
  'CA_FUEL_GAS_311',
  'CA_FUEL_GAS_312',
  'CA_FUEL_GAS_313',
  'CA_FUEL_GAS_314',
  'CA_FUEL_GAS_315',
  'CA_FUEL_GAS_316',
  'CA_FUEL_GAS_317',
  'CA_FUEL_GAS_318',
  'CA_FUEL_GAS_319',
  'CA_FUEL_GAS_320',
  'CA_FUEL_GAS_321',
  'CA_FUEL_GAS_322',
  'CA_FUEL_GAS_323',
  'CA_FUEL_GAS_324',
  'CA_FUEL_GAS_325',
  'CA_FUEL_GAS_326',
  'CA_FUEL_GAS_327',
  'CA_FUEL_GAS_328',
  'CA_FUEL_GAS_329',
  'CA_FUEL_GAS_330',
  'CA_FUEL_GAS_331',
  'CA_FUEL_GAS_332',
  'CA_FUEL_GAS_333',
  'CA_FUEL_GAS_334',
  'CA_FUEL_GAS_335',
  'CA_FUEL_GAS_336',
  'CA_FUEL_GAS_337',
  'CA_FUEL_GAS_338',
  'CA_FUEL_GAS_339',
  'CA_FUEL_GAS_340',
  'CA_FUEL_GAS_341',
  'CA_FUEL_GAS_342',
  'CA_FUEL_GAS_343',
  'CA_FUEL_GAS_344',
  'CA_FUEL_GAS_345',
  'CA_FUEL_GAS_346',
  'CA_FUEL_GAS_347',
  'CA_FUEL_GAS_348',
  'CA_FUEL_GAS_349',
  'CA_FUEL_GAS_350',
  'CA_FUEL_GAS_351',
  'CA_FUEL_GAS_352',
  'CA_FUEL_GAS_353',
  'CA_FUEL_GAS_354',
  'CA_FUEL_GAS_355',
  'CA_FUEL_GAS_356',
  'CA_FUEL_GAS_357',
  'CA_FUEL_GAS_358',
  'CA_FUEL_GAS_359',
  'CA_FUEL_GAS_360',
  'CA_FUEL_GAS_361',
  'CA_FUEL_GAS_362',
  'CA_FUEL_GAS_363',
  'CA_FUEL_GAS_364',
  'CA_FUEL_GAS_365',
  'CA_FUEL_GAS_366',
  'CA_FUEL_GAS_367',
  'CA_FUEL_GAS_368',
  'CA_FUEL_GAS_369',
  'CA_FUEL_GAS_370',
  'CA_FUEL_GAS_371',
  'CA_FUEL_GAS_372',
  'CA_FUEL_GAS_373',
  'CA_FUEL_GAS_374',
  'CA_FUEL_GAS_375',
  'CA_FUEL_GAS_376',
  'CA_FUEL_GAS_377',
  'CA_FUEL_GAS_378',
  'CA_FUEL_GAS_379',
  'CA_FUEL_GAS_380',
  'CA_FUEL_GAS_381',
  'CA_FUEL_GAS_382',
  'CA_FUEL_GAS_383',
  'CA_FUEL_GAS_384',
  'CA_FUEL_GAS_385',
  'CA_FUEL_GAS_386',
  'CA_FUEL_GAS_387',
  'CA_FUEL_GAS_388',
  'CA_FUEL_GAS_389',
  'CA_FUEL_GAS_390',
  'CA_FUEL_GAS_391',
  'CA_FUEL_GAS_392',
  'CA_FUEL_GAS_393',
  'CA_FUEL_GAS_394',
  'CA_FUEL_GAS_395',
  'CA_FUEL_GAS_396',
  'CA_FUEL_GAS_397',
  'CA_FUEL_GAS_398',
  'CA_FUEL_GAS_399',
  'CA_FUEL_GAS_400',
  'CA_FUEL_GAS_401',
  'CA_FUEL_GAS_402',
  'CA_FUEL_GAS_403',
  'CA_FUEL_GAS_404',
  'CA_FUEL_GAS_405',
  'CA_FUEL_GAS_406',
  'CA_FUEL_GAS_407',
  'CA_FUEL_GAS_408',
  'CA_FUEL_GAS_409',
  'CA_FUEL_GAS_410',
  'CA_FUEL_GAS_411',
  'CA_FUEL_GAS_412',
  'CA_FUEL_GAS_413',
  'CA_FUEL_GAS_414',
  'CA_FUEL_GAS_415',
  'CA_FUEL_GAS_416',
  'CA_FUEL_GAS_417',
  'CA_FUEL_GAS_418',
  'CA_FUEL_GAS_419',
  'CA_FUEL_GAS_420',
  'CA_FUEL_GAS_421',
  'CA_FUEL_GAS_422',
  'CA_FUEL_GAS_423',
  'CA_FUEL_GAS_424',
  'CA_FUEL_GAS_425',
  'CA_FUEL_GAS_426',
  'CA_FUEL_GAS_427',
  'CA_FUEL_GAS_428',
  'CA_FUEL_GAS_429',
  'CA_FUEL_GAS_430',
  'CA_FUEL_GAS_431',
  'CA_FUEL_GAS_432',
  'CA_FUEL_GAS_433',
  'CA_FUEL_GAS_434',
  'CA_FUEL_GAS_435',
  'CA_FUEL_GAS_436',
  'CA_FUEL_GAS_437',
  'CA_FUEL_GAS_438',
  'CA_FUEL_GAS_439',
  'CA_FUEL_GAS_440',
  'CA_FUEL_GAS_441',
  'CA_FUEL_GAS_442',
  'CA_FUEL_GAS_443',
  'CA_FUEL_GAS_444',
  'CA_FUEL_GAS_445',
  'CA_FUEL_GAS_446',
  'CA_FUEL_GAS_447',
  'CA_FUEL_GAS_448',
  'CA_FUEL_GAS_449',
  'CA_FUEL_GAS_450',
  'CA_FUEL_GAS_451',
  'CA_FUEL_GAS_452',
  'CA_FUEL_GAS_453',
  'CA_FUEL_GAS_454',
  'CA_FUEL_GAS_455',
  'CA_FUEL_GAS_456',
  'CA_FUEL_GAS_457',
  'CA_FUEL_GAS_458',
  'CA_FUEL_GAS_459',
  'CA_FUEL_GAS_460',
  'CA_FUEL_GAS_461',
  'CA_FUEL_GAS_462',
  'CA_FUEL_GAS_463',
  'CA_FUEL_GAS_464',
  'CA_FUEL_GAS_465',
  'CA_FUEL_GAS_466',
  'CA_FUEL_GAS_467',
  'CA_FUEL_GAS_468',
  'CA_FUEL_GAS_469',
  'CA_FUEL_GAS_470',
  'CA_FUEL_GAS_471',
  'CA_FUEL_GAS_472',
  'CA_FUEL_GAS_473',
  'CA_FUEL_GAS_474',
  'CA_FUEL_GAS_475',
  'CA_FUEL_GAS_476',
  'CA_FUEL_GAS_477',
  'CA_FUEL_GAS_478',
  'CA_FUEL_GAS_479',
  'CA_FUEL_GAS_480',
  'CA_FUEL_GAS_481',
  'CA_FUEL_GAS_482',
  'CA_FUEL_GAS_483',
  'CA_FUEL_GAS_484',
  'CA_FUEL_GAS_485',
  'CA_FUEL_GAS_486',
  'CA_FUEL_GAS_487',
  'CA_FUEL_GAS_488',
  'CA_FUEL_GAS_489',
  'CA_FUEL_GAS_490',
  'CA_FUEL_GAS_491',
  'CA_FUEL_GAS_492',
  'CA_FUEL_GAS_493',
  'CA_FUEL_GAS_494',
  'CA_FUEL_GAS_495',
  'CA_FUEL_GAS_496',
  'CA_FUEL_GAS_497',
  'CA_FUEL_GAS_498',
  'CA_FUEL_GAS_499',
  'CA_FUEL_GAS_500',
  'CA_FUEL_GAS_501',
  'CA_FUEL_GAS_502',
  'CA_FUEL_GAS_503',
  'CA_FUEL_GAS_504',
  'CA_FUEL_GAS_505',
  'CA_FUEL_GAS_506',
  'CA_FUEL_GAS_507',
  'CA_FUEL_GAS_508',
  'CA_FUEL_GAS_509',
  'CA_FUEL_GAS_510',
  'CA_FUEL_GAS_511',
  'CA_FUEL_GAS_512',
  'CA_FUEL_GAS_513',
  'CA_FUEL_GAS_514',
  'CA_FUEL_GAS_515',
  'CA_FUEL_GAS_516',
  'CA_FUEL_GAS_517',
  'CA_FUEL_GAS_518',
  'CA_FUEL_GAS_519',
  'CA_FUEL_GAS_520',
  'CA_FUEL_GAS_521',
  'CA_FUEL_GAS_522',
  'CA_FUEL_GAS_523',
  'CA_FUEL_GAS_524',
  'CA_FUEL_GAS_525',
  'CA_FUEL_GAS_526',
  'CA_FUEL_GAS_527',
  'CA_FUEL_GAS_528',
  'CA_FUEL_GAS_529',
  'CA_FUEL_GAS_530',
  'CA_FUEL_GAS_531',
  'CA_FUEL_GAS_532',
  'CA_FUEL_GAS_533',
  'CA_FUEL_GAS_534',
  'CA_FUEL_GAS_535',
  'CA_FUEL_GAS_536',
  'CA_FUEL_GAS_537',
  'CA_FUEL_GAS_538',
  'CA_FUEL_GAS_539',
  'CA_FUEL_GAS_540',
  'CA_FUEL_GAS_541',
  'CA_FUEL_GAS_542',
  'CA_FUEL_GAS_543',
  'CA_FUEL_GAS_544',
  'CA_FUEL_GAS_545',
  'CA_FUEL_GAS_546',
  'CA_FUEL_GAS_547',
  'CA_FUEL_GAS_548',
  'CA_FUEL_GAS_549',
  'CA_FUEL_GAS_550',
  'CA_FUEL_GAS_551',
  'CA_FUEL_GAS_552',
  'CA_FUEL_GAS_553',
  'CA_FUEL_GAS_554',
  'CA_FUEL_GAS_555',
  'CA_FUEL_GAS_556',
  'CA_FUEL_GAS_557',
  'CA_FUEL_GAS_558',
  'CA_FUEL_GAS_559',
  'CA_FUEL_GAS_560',
  'CA_FUEL_GAS_561',
  'CA_FUEL_GAS_562',
  'CA_FUEL_GAS_563',
  'CA_FUEL_GAS_564',
  'CA_FUEL_GAS_565',
  'CA_FUEL_GAS_566',
  'CA_FUEL_GAS_567',
  'CA_FUEL_GAS_568',
  'CA_FUEL_GAS_569',
  'CA_FUEL_GAS_570',
  'CA_FUEL_GAS_571',
  'CA_FUEL_GAS_572',
  'CA_FUEL_GAS_573',
  'CA_FUEL_GAS_574',
  'CA_FUEL_GAS_575',
  'CA_FUEL_GAS_576',
  'CA_FUEL_GAS_577',
  'CA_FUEL_GAS_578',
  'CA_FUEL_GAS_579',
  'CA_FUEL_GAS_580',
  'CA_FUEL_GAS_581',
  'CA_FUEL_GAS_582',
  'CA_FUEL_GAS_583',
  'CA_FUEL_GAS_584',
  'CA_FUEL_GAS_585',
  'CA_FUEL_GAS_586',
  'CA_FUEL_GAS_587',
  'CA_FUEL_GAS_588',
  'CA_FUEL_GAS_589',
  'CA_FUEL_GAS_590',
  'CA_FUEL_GAS_591',
  'CA_FUEL_GAS_592',
  'CA_FUEL_GAS_593',
  'CA_FUEL_GAS_594',
  'CA_FUEL_GAS_595',
  'CA_FUEL_GAS_596',
  'CA_FUEL_GAS_597',
  'CA_FUEL_GAS_598',
  'CA_FUEL_GAS_599',
  'CA_FUEL_GAS_600',
  'CA_FUEL_GAS_601',
  'CA_FUEL_GAS_602',
  'CA_FUEL_GAS_603',
  'CA_FUEL_GAS_604',
  'CA_FUEL_GAS_605',
  'CA_FUEL_GAS_606',
  'CA_FUEL_GAS_607',
  'CA_FUEL_GAS_608',
  'CA_FUEL_GAS_609',
  'CA_FUEL_GAS_610',
  'CA_FUEL_GAS_611',
  'CA_FUEL_GAS_612',
  'CA_FUEL_GAS_613',
  'CA_FUEL_GAS_614',
  'CA_FUEL_GAS_615',
  'CA_FUEL_GAS_616',
  'CA_FUEL_GAS_617',
  'CA_FUEL_GAS_618',
  'CA_FUEL_GAS_619',
  'CA_FUEL_GAS_620',
  'CA_FUEL_GAS_621',
  'CA_FUEL_GAS_622',
  'CA_FUEL_GAS_623',
  'CA_FUEL_GAS_624',
  'CA_FUEL_GAS_625',
  'CA_FUEL_GAS_626',
  'CA_FUEL_GAS_627',
  'CA_FUEL_GAS_628',
  'CA_FUEL_GAS_629',
  'CA_FUEL_GAS_630',
  'CA_FUEL_GAS_631',
  'CA_FUEL_GAS_632',
  'CA_FUEL_GAS_633',
  'CA_FUEL_GAS_634',
  'CA_FUEL_GAS_635',
  'CA_FUEL_GAS_636',
  'CA_FUEL_GAS_637',
  'CA_FUEL_GAS_638',
  'CA_FUEL_GAS_639',
  'CA_FUEL_GAS_640',
  'CA_FUEL_GAS_641',
  'CA_FUEL_GAS_642',
  'CA_FUEL_GAS_643',
  'CA_FUEL_GAS_644',
  'CA_FUEL_GAS_645',
  'CA_FUEL_GAS_646',
  'CA_FUEL_GAS_647',
  'CA_FUEL_GAS_648',
  'CA_FUEL_GAS_649',
  'CA_FUEL_GAS_650',
  'CA_FUEL_GAS_651',
  'CA_FUEL_GAS_652',
  'CA_FUEL_GAS_653',
  'CA_FUEL_GAS_654',
  'CA_FUEL_GAS_655',
  'CA_FUEL_GAS_656',
  'CA_FUEL_GAS_657',
  'CA_FUEL_GAS_658',
  'CA_FUEL_GAS_659',
  'CA_FUEL_GAS_660',
  'CA_FUEL_GAS_661',
  'CA_FUEL_GAS_662',
  'CA_FUEL_GAS_663',
  'CA_FUEL_GAS_664',
  'CA_FUEL_GAS_665',
  'CA_FUEL_GAS_666',
  'CA_FUEL_GAS_667',
  'CA_FUEL_GAS_668',
  'CA_FUEL_GAS_669',
  'CA_FUEL_GAS_670',
  'CA_FUEL_GAS_671',
  'CA_FUEL_GAS_672',
  'CA_FUEL_GAS_673',
  'CA_FUEL_GAS_674',
  'CA_FUEL_GAS_675',
  'CA_FUEL_GAS_676',
  'CA_FUEL_GAS_677',
  'CA_FUEL_GAS_678',
  'CA_FUEL_GAS_679',
  'CA_FUEL_GAS_680',
  'CA_FUEL_GAS_681',
  'CA_FUEL_GAS_682',
  'CA_FUEL_GAS_683',
  'CA_FUEL_GAS_684',
  'CA_FUEL_GAS_685',
  'CA_FUEL_GAS_686',
  'CA_FUEL_GAS_687',
  'CA_FUEL_GAS_688',
  'CA_FUEL_GAS_689',
  'CA_FUEL_GAS_690',
  'CA_FUEL_GAS_691',
  'CA_FUEL_GAS_692',
  'CA_FUEL_GAS_693',
  'CA_FUEL_GAS_694',
  'CA_FUEL_GAS_695',
  'CA_FUEL_GAS_696',
  'CA_FUEL_GAS_697',
  'CA_FUEL_GAS_698',
  'CA_FUEL_GAS_699',
  'CA_FUEL_GAS_700',
  'CA_FUEL_GAS_701',
  'CA_FUEL_GAS_702',
  'CA_FUEL_GAS_703',
  'CA_FUEL_GAS_704',
  'CA_FUEL_GAS_705',
  'CA_FUEL_GAS_706',
  'CA_FUEL_GAS_707',
  'CA_FUEL_GAS_708',
  'CA_FUEL_GAS_709',
  'CA_FUEL_GAS_710',
  'CA_FUEL_GAS_711',
  'CA_FUEL_GAS_712',
  'CA_FUEL_GAS_713',
  'CA_FUEL_GAS_714',
  'CA_FUEL_GAS_715',
  'CA_FUEL_GAS_716',
  'CA_FUEL_GAS_717',
  'CA_FUEL_GAS_718',
  'CA_FUEL_GAS_719',
  'CA_FUEL_GAS_720',
  'CA_FUEL_GAS_721',
  'CA_FUEL_GAS_722',
  'CA_FUEL_GAS_723',
  'CA_FUEL_GAS_724',
  'CA_FUEL_GAS_725',
  'CA_FUEL_GAS_726',
  'CA_FUEL_GAS_727',
  'CA_FUEL_GAS_728',
  'CA_FUEL_GAS_729',
  'CA_FUEL_GAS_730',
  'CA_FUEL_GAS_731',
  'CA_FUEL_GAS_732',
  'CA_FUEL_GAS_733',
  'CA_FUEL_GAS_734',
  'CA_FUEL_GAS_735',
  'CA_FUEL_GAS_736',
  'CA_FUEL_GAS_737',
  'CA_FUEL_GAS_738',
  'CA_FUEL_GAS_739',
  'CA_FUEL_GAS_740',
  'CA_FUEL_GAS_741',
  'CA_FUEL_GAS_742',
  'CA_FUEL_GAS_743',
  'CA_FUEL_GAS_744',
  'CA_FUEL_GAS_745',
  'CA_FUEL_GAS_746',
  'CA_FUEL_GAS_747',
  'CA_FUEL_GAS_748',
  'CA_FUEL_GAS_749',
  'CA_FUEL_GAS_750',
  'CA_FUEL_GAS_751',
  'CA_FUEL_GAS_752',
  'CA_FUEL_GAS_753',
  'CA_FUEL_GAS_754',
  'CA_FUEL_GAS_755',
  'CA_FUEL_GAS_756',
  'CA_FUEL_GAS_757',
  'CA_FUEL_GAS_758',
  'CA_FUEL_GAS_759',
  'CA_FUEL_GAS_760',
  'CA_FUEL_GAS_761',
  'CA_FUEL_GAS_762',
  'CA_FUEL_GAS_763',
  'CA_FUEL_GAS_764',
  'CA_FUEL_GAS_765',
  'CA_FUEL_GAS_766',
  'CA_FUEL_GAS_767',
  'CA_FUEL_GAS_768',
  'CA_FUEL_GAS_769',
  'CA_FUEL_GAS_770',
  'CA_FUEL_GAS_771',
  'CA_FUEL_GAS_772',
  'CA_FUEL_GAS_773',
  'CA_FUEL_GAS_774',
  'CA_FUEL_GAS_775',
  'CA_FUEL_GAS_776',
  'CA_FUEL_GAS_777',
  'CA_FUEL_GAS_778',
  'CA_FUEL_GAS_779',
  'CA_FUEL_GAS_780',
  'CA_FUEL_GAS_781',
  'CA_FUEL_GAS_782',
  'CA_FUEL_GAS_783',
  'CA_FUEL_GAS_784',
  'CA_FUEL_GAS_785',
  'CA_FUEL_GAS_786',
  'CA_FUEL_GAS_787',
  'CA_FUEL_GAS_788',
  'CA_FUEL_GAS_789',
  'CA_FUEL_GAS_790',
  'CA_FUEL_GAS_791',
  'CA_FUEL_GAS_792',
  'CA_FUEL_GAS_793',
  'CA_FUEL_GAS_794',
  'CA_FUEL_GAS_795',
  'CA_FUEL_GAS_796',
  'CA_FUEL_GAS_797',
  'CA_FUEL_GAS_798',
  'CA_FUEL_GAS_799',
  'CA_FUEL_GAS_800',
  'CA_FUEL_GAS_801',
  'CA_FUEL_GAS_802',
  'CA_FUEL_GAS_803',
  'CA_FUEL_GAS_804',
  'CA_FUEL_GAS_805',
  'CA_FUEL_GAS_806',
  'CA_FUEL_GAS_807',
  'CA_FUEL_GAS_808',
  'CA_FUEL_GAS_809',
  'CA_FUEL_GAS_810',
  'CA_FUEL_GAS_811',
  'CA_FUEL_GAS_812',
  'CA_FUEL_GAS_813',
  'CA_FUEL_GAS_814',
  'CA_FUEL_GAS_815',
  'CA_FUEL_GAS_816',
  'CA_FUEL_GAS_817',
  'CA_FUEL_GAS_818',
  'CA_FUEL_GAS_819',
  'CA_FUEL_GAS_820',
  'CA_FUEL_GAS_821',
  'CA_FUEL_GAS_822',
  'CA_FUEL_GAS_823',
  'CA_FUEL_GAS_824',
  'CA_FUEL_GAS_825',
  'CA_FUEL_GAS_826',
  'CA_FUEL_GAS_827',
  'CA_FUEL_GAS_828',
  'CA_FUEL_GAS_829',
  'CA_FUEL_GAS_830',
  'CA_FUEL_GAS_831',
  'CA_FUEL_GAS_832',
  'CA_FUEL_GAS_833',
  'CA_FUEL_GAS_834',
  'CA_FUEL_GAS_835',
  'CA_FUEL_GAS_836',
  'CA_FUEL_GAS_837',
  'CA_FUEL_GAS_838',
  'CA_FUEL_GAS_839',
  'CA_FUEL_GAS_840',
  'CA_FUEL_GAS_841',
  'CA_FUEL_GAS_842',
  'CA_FUEL_GAS_843',
  'CA_FUEL_GAS_844',
  'CA_FUEL_GAS_845',
  'CA_FUEL_GAS_846',
  'CA_FUEL_GAS_847',
  'CA_FUEL_GAS_848',
  'CA_FUEL_GAS_849',
  'CA_FUEL_GAS_850',
  'CA_FUEL_GAS_851',
  'CA_FUEL_GAS_852',
  'CA_FUEL_GAS_853',
  'CA_FUEL_GAS_854',
  'CA_FUEL_GAS_855',
  'CA_FUEL_GAS_856',
  'CA_FUEL_GAS_857',
  'CA_FUEL_GAS_858',
  'CA_FUEL_GAS_859',
  'CA_FUEL_GAS_860',
  'CA_FUEL_GAS_861',
  'CA_FUEL_GAS_862',
  'CA_FUEL_GAS_863',
  'CA_FUEL_GAS_864',
  'CA_FUEL_GAS_865',
  'CA_FUEL_GAS_866',
  'CA_FUEL_GAS_867',
  'CA_FUEL_GAS_868',
  'CA_FUEL_GAS_869',
  'CA_FUEL_GAS_870',
  'CA_FUEL_GAS_871',
  'CA_FUEL_GAS_872',
  'CA_FUEL_GAS_873',
  'CA_FUEL_GAS_874',
  'CA_FUEL_GAS_875',
  'CA_FUEL_GAS_876',
  'CA_FUEL_GAS_877',
  'CA_FUEL_GAS_878',
  'CA_FUEL_GAS_879',
  'CA_FUEL_GAS_880',
  'CA_FUEL_GAS_881',
  'CA_FUEL_GAS_882',
  'CA_FUEL_GAS_883',
  'CA_FUEL_GAS_884',
  'CA_FUEL_GAS_885',
  'CA_FUEL_GAS_886',
  'CA_FUEL_GAS_887',
  'CA_FUEL_GAS_888',
  'CA_FUEL_GAS_889',
  'CA_FUEL_GAS_890',
  'CA_FUEL_GAS_891',
  'CA_FUEL_GAS_892',
  'CA_FUEL_GAS_893',
  'CA_FUEL_GAS_894',
  'CA_FUEL_GAS_895',
  'CA_FUEL_GAS_896',
  'CA_FUEL_GAS_897',
  'CA_FUEL_GAS_898',
  'CA_FUEL_GAS_899',
  'CA_FUEL_GAS_900',
  'CA_FUEL_GAS_901',
  'CA_FUEL_GAS_902',
  'CA_FUEL_GAS_903',
  'CA_FUEL_GAS_904',
  'CA_FUEL_GAS_905',
  'CA_FUEL_GAS_906',
  'CA_FUEL_GAS_907',
  'CA_FUEL_GAS_908',
  'CA_FUEL_GAS_909',
  'CA_FUEL_GAS_910',
  'CA_FUEL_GAS_911',
  'CA_FUEL_GAS_912',
  'CA_FUEL_GAS_913',
  'CA_FUEL_GAS_914',
  'CA_FUEL_GAS_915',
  'CA_FUEL_GAS_916',
  'CA_FUEL_GAS_917',
  'CA_FUEL_GAS_918',
  'CA_FUEL_GAS_919',
  'CA_FUEL_GAS_920',
  'CA_FUEL_GAS_921',
  'CA_FUEL_GAS_922',
  'CA_FUEL_GAS_923',
  'CA_FUEL_GAS_924',
  'CA_FUEL_GAS_925',
  'CA_FUEL_GAS_926',
  'CA_FUEL_GAS_927',
  'CA_FUEL_GAS_928',
  'CA_FUEL_GAS_929',
  'CA_FUEL_GAS_930',
  'CA_FUEL_GAS_931',
  'CA_FUEL_GAS_932',
  'CA_FUEL_GAS_933',
  'CA_FUEL_GAS_934',
  'CA_FUEL_GAS_935',
  'CA_FUEL_GAS_936',
  'CA_FUEL_GAS_937',
  'CA_FUEL_GAS_938',
  'CA_FUEL_GAS_939',
  'CA_FUEL_GAS_940',
  'CA_FUEL_GAS_941',
  'CA_FUEL_GAS_942',
  'CA_FUEL_GAS_943',
  'CA_FUEL_GAS_944',
  'CA_FUEL_GAS_945',
  'CA_FUEL_GAS_946',
  'CA_FUEL_GAS_947',
  'CA_FUEL_GAS_948',
  'CA_FUEL_GAS_949',
  'CA_FUEL_GAS_950',
  'CA_FUEL_GAS_951',
  'CA_FUEL_GAS_952',
  'CA_FUEL_GAS_953',
  'CA_FUEL_GAS_954',
  'CA_FUEL_GAS_955',
  'CA_FUEL_GAS_956',
  'CA_FUEL_GAS_957',
  'CA_FUEL_GAS_958',
  'CA_FUEL_GAS_959',
  'CA_FUEL_GAS_960',
  'CA_FUEL_GAS_961',
  'CA_FUEL_GAS_962',
  'CA_FUEL_GAS_963',
  'CA_FUEL_GAS_964',
  'CA_FUEL_GAS_965',
  'CA_FUEL_GAS_966',
  'CA_FUEL_GAS_967',
  'CA_FUEL_GAS_968',
  'CA_FUEL_GAS_969',
  'CA_FUEL_GAS_970',
  'CA_FUEL_GAS_971',
  'CA_FUEL_GAS_972',
  'CA_FUEL_GAS_973',
  'CA_FUEL_GAS_974',
  'CA_FUEL_GAS_975',
  'CA_FUEL_GAS_976',
  'CA_FUEL_GAS_977',
  'CA_FUEL_GAS_978',
  'CA_FUEL_GAS_979',
  'CA_FUEL_GAS_980',
  'CA_FUEL_GAS_981',
  'CA_FUEL_GAS_982',
  'CA_FUEL_GAS_983',
  'CA_FUEL_GAS_984',
  'CA_FUEL_GAS_985',
  'CA_FUEL_GAS_986',
  'CA_FUEL_GAS_987',
  'CA_FUEL_GAS_988',
  'CA_FUEL_GAS_989',
  'CA_FUEL_GAS_990',
  'CA_FUEL_GAS_991',
  'CA_FUEL_GAS_992',
  'CA_FUEL_GAS_993',
  'CA_FUEL_GAS_994',
  'CA_FUEL_GAS_995',
  'CA_FUEL_GAS_996',
  'CA_FUEL_GAS_997',
  'CA_FUEL_GAS_998',
  'CA_FUEL_GAS_999',
  'CA_FUEL_GAS_1000',
  'CA_FUEL_GAS_1001',
  'CA_FUEL_GAS_1002',
  'CA_FUEL_GAS_1003',
  'CA_FUEL_GAS_1004',
  'CA_FUEL_GAS_1005',
  'CA_FUEL_GAS_1006',
  'CA_FUEL_GAS_1007',
  'CA_FUEL_GAS_1008',
  'CA_FUEL_GAS_1009',
  'CA_FUEL_GAS_1010',
  'CA_FUEL_GAS_1011',
  'CA_FUEL_GAS_1012',
  'CA_FUEL_GAS_1013',
  'CA_FUEL_GAS_1014',
  'CA_FUEL_GAS_1015',
  'CA_FUEL_GAS_1016',
  'CA_FUEL_GAS_1017',
  'CA_FUEL_GAS_1018',
  'CA_FUEL_GAS_1019',
  'CA_FUEL_GAS_1020',
  'CA_FUEL_GAS_1021',
  'CA_FUEL_GAS_1022',
  'CA_FUEL_GAS_1023',
  'CA_FUEL_GAS_1024',
  'CA_FUEL_GAS_1025',
  'CA_FUEL_GAS_1026',
  'CA_FUEL_GAS_1027',
  'CA_FUEL_GAS_1028',
  'CA_FUEL_GAS_1029',
  'CA_FUEL_GAS_1030',
  'CA_FUEL_GAS_1031',
  'CA_FUEL_GAS_1032',
  'CA_FUEL_GAS_1033',
  'CA_FUEL_GAS_1034',
  'CA_FUEL_GAS_1035',
  'CA_FUEL_GAS_1036',
  'CA_FUEL_GAS_1037',
  'CA_FUEL_GAS_1038',
  'CA_FUEL_GAS_1039',
  'CA_FUEL_GAS_1040',
  'CA_FUEL_GAS_1041',
  'CA_FUEL_GAS_1042',
  'CA_FUEL_GAS_1043',
  'CA_FUEL_GAS_1044',
  'CA_FUEL_GAS_1045',
  'CA_FUEL_GAS_1046',
  'CA_FUEL_GAS_1047',
  'CA_FUEL_GAS_1048',
  'CA_FUEL_GAS_1049',
  'CA_FUEL_GAS_1050',
  'CA_FUEL_GAS_1051',
  'CA_FUEL_GAS_1052',
  'CA_FUEL_GAS_1053',
  'CA_FUEL_GAS_1054',
  'CA_FUEL_GAS_1055',
  'CA_FUEL_GAS_1056',
  'CA_FUEL_GAS_1057',
  'CA_FUEL_GAS_1058',
  'CA_FUEL_GAS_1059',
  'CA_FUEL_GAS_1060',
  'CA_FUEL_GAS_1061',
  'CA_FUEL_GAS_1062',
  'CA_FUEL_GAS_1063',
  'CA_FUEL_GAS_1064',
  'CA_FUEL_GAS_1065',
  'CA_FUEL_GAS_1066',
  'CA_FUEL_GAS_1067',
  'CA_FUEL_GAS_1068',
  'CA_FUEL_GAS_1069',
  'CA_FUEL_GAS_1070',
  'CA_FUEL_GAS_1071',
  'CA_FUEL_GAS_1072',
  'CA_FUEL_GAS_1073',
  'CA_FUEL_GAS_1074',
  'CA_FUEL_GAS_1075',
  'CA_FUEL_GAS_1076',
  'CA_FUEL_GAS_1077',
  'CA_FUEL_GAS_1078',
  'CA_FUEL_GAS_1079',
  'CA_FUEL_GAS_1080',
  'CA_FUEL_GAS_1081',
  'CA_FUEL_GAS_1082',
  'CA_FUEL_GAS_1083',
  'CA_FUEL_GAS_1084',
  'CA_FUEL_GAS_1085',
  'CA_FUEL_GAS_1086',
  'CA_FUEL_GAS_1087',
  'CA_FUEL_GAS_1088',
  'CA_FUEL_GAS_1089',
  'CA_FUEL_GAS_1090',
  'CA_FUEL_GAS_1091',
  'CA_FUEL_GAS_1092',
  'CA_FUEL_GAS_1093',
  'CA_FUEL_GAS_1094',
  'CA_FUEL_GAS_1095',
  'CA_FUEL_GAS_1096',
  'CA_FUEL_GAS_1097',
  'CA_FUEL_GAS_1098',
  'CA_FUEL_GAS_1099',
  'CA_FUEL_GAS_1100',
  'CA_FUEL_GAS_1101',
  'CA_FUEL_GAS_1102',
  'CA_FUEL_GAS_1103',
  'CA_FUEL_GAS_1104',
  'CA_FUEL_GAS_1105',
  'CA_FUEL_GAS_1106',
  'CA_FUEL_GAS_1107',
  'CA_FUEL_GAS_1108',
  'CA_FUEL_GAS_1109',
  'CA_FUEL_GAS_1110',
  'CA_FUEL_GAS_1111',
  'CA_FUEL_GAS_1112',
  'CA_FUEL_GAS_1113',
  'CA_FUEL_GAS_1114',
  'CA_FUEL_GAS_1115',
  'CA_FUEL_GAS_1116',
  'CA_FUEL_GAS_1117',
  'CA_FUEL_GAS_1118',
  'CA_FUEL_GAS_1119',
  'CA_FUEL_GAS_1120',
  'CA_FUEL_GAS_1121',
  'CA_FUEL_GAS_1122',
  'CA_FUEL_GAS_1123',
  'CA_FUEL_GAS_1124',
  'CA_FUEL_GAS_1125',
  'CA_FUEL_GAS_1126',
  'CA_FUEL_GAS_1127',
  'CA_FUEL_GAS_1128',
  'CA_FUEL_GAS_1129',
  'CA_FUEL_GAS_1130',
  'CA_FUEL_GAS_1131',
  'CA_FUEL_GAS_1132',
  'CA_FUEL_GAS_1133',
  'CA_FUEL_GAS_1134',
  'CA_FUEL_GAS_1135',
  'CA_FUEL_GAS_1136',
  'CA_FUEL_GAS_1137',
  'CA_FUEL_GAS_1138',
  'CA_FUEL_GAS_1139',
  'CA_FUEL_GAS_1140',
  'CA_FUEL_GAS_1141',
  'CA_FUEL_GAS_1142',
  'CA_FUEL_GAS_1143',
  'CA_FUEL_GAS_1144',
  'CA_FUEL_GAS_1145',
  'CA_FUEL_GAS_1146',
  'CA_FUEL_GAS_1147',
  'CA_FUEL_GAS_1148',
  'CA_FUEL_GAS_1149',
  'CA_FUEL_GAS_1150',
  'CA_FUEL_GAS_1151',
  'CA_FUEL_GAS_1152',
  'CA_FUEL_GAS_1153',
  'CA_FUEL_GAS_1154',
  'CA_FUEL_GAS_1155',
  'CA_FUEL_GAS_1156',
  'CA_FUEL_GAS_1157',
  'CA_FUEL_GAS_1158',
  'CA_FUEL_GAS_1159',
  'CA_FUEL_GAS_1160',
  'CA_FUEL_GAS_1161',
  'CA_FUEL_GAS_1162',
  'CA_FUEL_GAS_1163',
  'CA_FUEL_GAS_1164',
  'CA_FUEL_GAS_1165',
  'CA_FUEL_GAS_1166',
  'CA_FUEL_GAS_1167',
  'CA_FUEL_GAS_1168',
  'CA_FUEL_GAS_1169',
  'CA_FUEL_GAS_1170',
  'CA_FUEL_GAS_1171',
  'CA_FUEL_GAS_1172',
  'CA_FUEL_GAS_1173',
  'CA_FUEL_GAS_1174',
  'CA_FUEL_GAS_1175',
  'CA_FUEL_GAS_1176',
  'CA_FUEL_GAS_1177',
  'CA_FUEL_GAS_1178',
  'CA_FUEL_GAS_1179',
  'CA_FUEL_GAS_1180',
  'CA_FUEL_GAS_1181',
  'CA_FUEL_GAS_1182',
  'CA_FUEL_GAS_1183',
  'CA_FUEL_GAS_1184',
  'CA_FUEL_GAS_1185',
  'CA_FUEL_GAS_1186',
  'CA_FUEL_GAS_1187',
  'CA_FUEL_GAS_1188',
  'CA_FUEL_GAS_1189',
  'CA_FUEL_GAS_1190',
  'CA_FUEL_GAS_1191',
  'CA_FUEL_GAS_1192',
  'CA_FUEL_GAS_1193',
  'CA_FUEL_GAS_1194',
  'CA_FUEL_GAS_1195',
  'CA_FUEL_GAS_1196',
  'CA_FUEL_GAS_1197',
  'CA_FUEL_GAS_1198',
  'CA_FUEL_GAS_1199',
  'CA_FUEL_GAS_1200',
  'CA_FUEL_GAS_1201',
  'CA_FUEL_GAS_1202',
  'CA_FUEL_GAS_1203',
  'CA_FUEL_GAS_1204',
  'CA_FUEL_GAS_1205',
  'CA_FUEL_GAS_1206',
  'CA_FUEL_GAS_1207',
  'CA_FUEL_GAS_1208',
  'CA_FUEL_GAS_1209',
  'CA_FUEL_GAS_1210',
  'CA_FUEL_GAS_1211',
  'CA_FUEL_GAS_1212',
  'CA_FUEL_GAS_1213',
  'CA_FUEL_GAS_1214',
  'CA_FUEL_GAS_1215',
  'CA_FUEL_GAS_1216',
  'CA_FUEL_GAS_1217',
  'CA_FUEL_GAS_1218',
  'CA_FUEL_GAS_1219',
  'CA_FUEL_GAS_1220',
  'CA_FUEL_GAS_1221',
  'CA_FUEL_GAS_1222',
  'CA_FUEL_GAS_1223',
  'CA_FUEL_GAS_1224',
  'CA_FUEL_GAS_1225',
  'CA_FUEL_GAS_1226',
  'CA_FUEL_GAS_1227',
  'CA_FUEL_GAS_1228',
  'CA_FUEL_GAS_1229',
  'CA_FUEL_GAS_1230',
  'CA_FUEL_GAS_1231',
  'CA_FUEL_GAS_1232',
  'CA_FUEL_GAS_1233',
  'CA_FUEL_GAS_1234',
  'CA_FUEL_GAS_1235',
  'CA_FUEL_GAS_1236',
  'CA_FUEL_GAS_1237',
  'CA_FUEL_GAS_1238',
  'CA_FUEL_GAS_1239',
  'CA_FUEL_GAS_1240',
  'CA_FUEL_GAS_1241',
  'CA_FUEL_GAS_1242',
  'CA_FUEL_GAS_1243',
  'CA_FUEL_GAS_1244',
  'CA_FUEL_GAS_1245',
  'CA_FUEL_GAS_1246',
  'CA_FUEL_GAS_1247',
  'CA_FUEL_GAS_1248',
  'CA_FUEL_GAS_1249',
  'CA_FUEL_GAS_1250',
  'CA_FUEL_GAS_1251',
  'CA_FUEL_GAS_1252',
  'CA_FUEL_GAS_1253',
  'CA_FUEL_GAS_1254',
  'CA_FUEL_GAS_1255',
  'CA_FUEL_GAS_1256',
  'CA_FUEL_GAS_1257',
  'CA_FUEL_GAS_1258',
  'CA_FUEL_GAS_1259',
  'CA_FUEL_GAS_1260',
  'CA_FUEL_GAS_1261',
  'CA_FUEL_GAS_1262',
  'CA_FUEL_GAS_1263',
  'CA_FUEL_GAS_1264',
  'CA_FUEL_GAS_1265',
  'CA_FUEL_GAS_1266',
  'CA_FUEL_GAS_1267',
  'CA_FUEL_GAS_1268',
  'CA_FUEL_GAS_1269',
  'CA_FUEL_GAS_1270',
  'CA_FUEL_GAS_1271',
  'CA_FUEL_GAS_1272',
  'CA_FUEL_GAS_1273',
  'CA_FUEL_GAS_1274',
  'CA_FUEL_GAS_1275',
  'CA_FUEL_GAS_1276',
  'CA_FUEL_GAS_1277',
  'CA_FUEL_GAS_1278',
  'CA_FUEL_GAS_1279',
  'CA_FUEL_GAS_1280',
  'CA_FUEL_GAS_1281',
  'CA_FUEL_GAS_1282',
  'CA_FUEL_GAS_1283',
  'CA_FUEL_GAS_1284',
  'CA_FUEL_GAS_1285',
  'CA_FUEL_GAS_1286',
  'CA_FUEL_GAS_1287',
  'CA_FUEL_GAS_1288',
  'CA_FUEL_GAS_1289',
  'CA_FUEL_GAS_1290',
  'CA_FUEL_GAS_1291',
  'CA_FUEL_GAS_1292',
  'CA_FUEL_GAS_1293',
  'CA_FUEL_GAS_1294',
  'CA_FUEL_GAS_1295',
  'CA_FUEL_GAS_1296',
  'CA_FUEL_GAS_1297',
  'CA_FUEL_GAS_1298',
  'CA_FUEL_GAS_1299',
  'CA_FUEL_GAS_1300',
  'CA_FUEL_GAS_1301',
  'CA_FUEL_GAS_1302',
  'CA_FUEL_GAS_1303',
  'CA_FUEL_GAS_1304',
  'CA_FUEL_GAS_1305',
  'CA_FUEL_GAS_1306',
  'CA_FUEL_GAS_1307',
  'CA_FUEL_GAS_1308',
  'CA_FUEL_GAS_1309',
  'CA_FUEL_GAS_1310',
  'CA_FUEL_GAS_1311',
  'CA_FUEL_GAS_1312',
  'CA_FUEL_GAS_1313',
  'CA_FUEL_GAS_1314',
  'CA_FUEL_GAS_1315',
  'CA_FUEL_GAS_1316',
  'CA_FUEL_GAS_1317',
  'CA_FUEL_GAS_1318',
  'CA_FUEL_GAS_1319',
  'CA_FUEL_GAS_1320',
  'CA_FUEL_GAS_1321',
  'CA_FUEL_GAS_1322',
  'CA_FUEL_GAS_1323',
  'CA_FUEL_GAS_1324',
  'CA_FUEL_GAS_1325',
  'CA_FUEL_GAS_1326',
  'CA_FUEL_GAS_1327',
  'CA_FUEL_GAS_1328',
  'CA_FUEL_GAS_1329',
  'CA_FUEL_GAS_1330',
  'CA_FUEL_GAS_1331',
  'CA_FUEL_GAS_1332',
  'CA_FUEL_GAS_1333',
  'CA_FUEL_GAS_1334',
  'CA_FUEL_GAS_1335',
  'CA_FUEL_GAS_1336',
  'CA_FUEL_GAS_1337',
  'CA_FUEL_GAS_1338',
  'CA_FUEL_GAS_1339',
  'CA_FUEL_GAS_1340',
  'CA_FUEL_GAS_1341',
  'CA_FUEL_GAS_1342',
  'CA_FUEL_GAS_1343',
  'CA_FUEL_GAS_1344',
  'CA_FUEL_GAS_1345',
  'CA_FUEL_GAS_1346',
  'CA_FUEL_GAS_1347',
  'CA_FUEL_GAS_1348',
  'CA_FUEL_GAS_1349',
  'CA_FUEL_GAS_1350',
  'CA_FUEL_GAS_1351',
  'CA_FUEL_GAS_1352',
  'CA_FUEL_GAS_1353',
  'CA_FUEL_GAS_1354',
  'CA_FUEL_GAS_1355',
  'CA_FUEL_GAS_1356',
  'CA_FUEL_GAS_1357',
  'CA_FUEL_GAS_1358',
  'CA_FUEL_GAS_1359',
  'CA_FUEL_GAS_1360',
  'CA_FUEL_GAS_1361',
  'CA_FUEL_GAS_1362',
  'CA_FUEL_GAS_1363',
  'CA_FUEL_GAS_1364',
  'CA_FUEL_GAS_1365',
  'CA_FUEL_GAS_1366',
  'CA_FUEL_GAS_1367',
  'CA_FUEL_GAS_1368',
  'CA_FUEL_GAS_1369',
  'CA_FUEL_GAS_1370',
  'CA_FUEL_GAS_1371',
  'CA_FUEL_GAS_1372',
  'CA_FUEL_GAS_1373',
  'CA_FUEL_GAS_1374',
  'CA_FUEL_GAS_1375',
  'CA_FUEL_GAS_1376',
  'CA_FUEL_GAS_1377',
  'CA_FUEL_GAS_1378',
  'CA_FUEL_GAS_1379',
  'CA_FUEL_GAS_1380',
  'CA_FUEL_GAS_1381',
  'CA_FUEL_GAS_1382',
  'CA_FUEL_GAS_1383',
  'CA_FUEL_GAS_1384',
  'CA_FUEL_GAS_1385',
  'CA_FUEL_GAS_1386',
  'CA_FUEL_GAS_1387',
  'CA_FUEL_GAS_1388',
  'CA_FUEL_GAS_1389',
  'CA_FUEL_GAS_1390',
  'CA_FUEL_GAS_1391',
  'CA_FUEL_GAS_1392',
  'CA_FUEL_GAS_1393',
  'CA_FUEL_GAS_1394',
  'CA_FUEL_GAS_1395',
  'CA_FUEL_GAS_1396',
  'CA_FUEL_GAS_1397',
  'CA_FUEL_GAS_1398',
  'CA_FUEL_GAS_1399',
  'CA_FUEL_GAS_1400',
  'CA_FUEL_GAS_1401',
  'CA_FUEL_GAS_1402',
  'CA_FUEL_GAS_1403',
  'CA_FUEL_GAS_1404',
  'CA_FUEL_GAS_1405',
  'CA_FUEL_GAS_1406',
  'CA_FUEL_GAS_1407',
  'CA_FUEL_GAS_1408',
  'CA_FUEL_GAS_1409',
  'CA_FUEL_GAS_1410',
  'CA_FUEL_GAS_1411',
  'CA_FUEL_GAS_1412',
  'CA_FUEL_GAS_1413',
  'CA_FUEL_GAS_1414',
  'CA_FUEL_GAS_1415',
  'CA_FUEL_GAS_1416',
  'CA_FUEL_GAS_1417',
  'CA_FUEL_GAS_1418',
  'CA_FUEL_GAS_1419',
  'CA_FUEL_GAS_1420',
  'CA_FUEL_GAS_1421',
  'CA_FUEL_GAS_1422',
  'CA_FUEL_GAS_1423',
  'CA_FUEL_GAS_1424',
  'CA_FUEL_GAS_1425',
  'CA_FUEL_GAS_1426',
  'CA_FUEL_GAS_1427',
  'CA_FUEL_GAS_1428',
  'CA_FUEL_GAS_1429',
  'CA_FUEL_GAS_1430',
  'CA_FUEL_GAS_1431',
  'CA_FUEL_GAS_1432',
  'CA_FUEL_GAS_1433',
  'CA_FUEL_GAS_1434',
  'CA_FUEL_GAS_1435',
  'CA_FUEL_GAS_1436',
  'CA_FUEL_GAS_1437',
  'CA_FUEL_GAS_1438',
  'CA_FUEL_GAS_1439',
  'CA_FUEL_GAS_1440',
  'CA_FUEL_GAS_1441',
  'CA_FUEL_GAS_1442',
  'CA_FUEL_GAS_1443',
  'CA_FUEL_GAS_1444',
  'CA_FUEL_GAS_1445',
  'CA_FUEL_GAS_1446',
  'CA_FUEL_GAS_1447',
  'CA_FUEL_GAS_1448',
  'CA_FUEL_GAS_1449',
  'CA_FUEL_GAS_1450',
  'CA_FUEL_GAS_1451',
  'CA_FUEL_GAS_1452',
  'CA_FUEL_GAS_1453',
  'CA_FUEL_GAS_1454',
  'CA_FUEL_GAS_1455',
  'CA_FUEL_GAS_1456',
  'CA_FUEL_GAS_1457',
  'CA_FUEL_GAS_1458',
  'CA_FUEL_GAS_1459',
  'CA_FUEL_GAS_1460',
  'CA_FUEL_GAS_1461',
  'CA_FUEL_GAS_1462',
  'CA_FUEL_GAS_1463',
  'CA_FUEL_GAS_1464',
  'CA_FUEL_GAS_1465',
  'CA_FUEL_GAS_1466',
  'CA_FUEL_GAS_1467',
  'CA_FUEL_GAS_1468',
  'CA_FUEL_GAS_1469',
  'CA_FUEL_GAS_1470',
  'CA_FUEL_GAS_1471',
  'CA_FUEL_GAS_1472',
  'CA_FUEL_GAS_1473',
  'CA_FUEL_GAS_1474',
  'CA_FUEL_GAS_1475',
  'CA_FUEL_GAS_1476',
  'CA_FUEL_GAS_1477',
  'CA_FUEL_GAS_1478',
  'CA_FUEL_GAS_1479',
  'CA_FUEL_GAS_1480',
  'CA_FUEL_GAS_1481',
  'CA_FUEL_GAS_1482',
  'CA_FUEL_GAS_1483',
  'CA_FUEL_GAS_1484',
  'CA_FUEL_GAS_1485',
  'CA_FUEL_GAS_1486',
  'CA_FUEL_GAS_1487',
  'CA_FUEL_GAS_1488',
  'CA_FUEL_GAS_1489',
  'CA_FUEL_GAS_1490',
  'CA_FUEL_GAS_1491',
  'CA_FUEL_GAS_1492',
  'CA_FUEL_GAS_1493',
  'CA_FUEL_GAS_1494',
  'CA_FUEL_GAS_1495',
  'CA_FUEL_GAS_1496',
  'CA_FUEL_GAS_1497',
  'CA_FUEL_GAS_1498',
  'CA_FUEL_GAS_1499',
  'CA_FUEL_GAS_1500',
  'CA_FUEL_GAS_1501',
  'CA_FUEL_GAS_1502',
  'CA_FUEL_GAS_1503',
  'CA_FUEL_GAS_1504',
  'CA_FUEL_GAS_1505',
  'CA_FUEL_GAS_1506',
  'CA_FUEL_GAS_1507',
  'CA_FUEL_GAS_1508',
  'CA_FUEL_GAS_1509',
  'CA_FUEL_GAS_1510',
  'CA_FUEL_GAS_1511',
  'CA_FUEL_GAS_1512',
  'CA_FUEL_GAS_1513',
  'CA_FUEL_GAS_1514',
  'CA_FUEL_GAS_1515',
  'CA_FUEL_GAS_1516',
  'CA_FUEL_GAS_1517',
  'CA_FUEL_GAS_1518',
  'CA_FUEL_GAS_1519',
  'CA_FUEL_GAS_1520',
  'CA_FUEL_GAS_1521',
  'CA_FUEL_GAS_1522',
  'CA_FUEL_GAS_1523',
  'CA_FUEL_GAS_1524',
  'CA_FUEL_GAS_1525',
  'CA_FUEL_GAS_1526',
  'CA_FUEL_GAS_1527',
  'CA_FUEL_GAS_1528',
  'CA_FUEL_GAS_1529',
  'CA_FUEL_GAS_1530',
  'CA_FUEL_GAS_1531',
  'CA_FUEL_GAS_1532',
  'CA_FUEL_GAS_1533',
  'CA_FUEL_GAS_1534',
  'CA_FUEL_GAS_1535',
  'CA_FUEL_GAS_1536',
  'CA_FUEL_GAS_1537',
  'CA_FUEL_GAS_1538',
  'CA_FUEL_GAS_1539',
  'CA_FUEL_GAS_1540',
  'CA_FUEL_GAS_1541',
  'CA_FUEL_GAS_1542',
  'CA_FUEL_GAS_1543',
  'CA_FUEL_GAS_1544',
  'CA_FUEL_GAS_1545',
  'CA_FUEL_GAS_1546',
  'CA_FUEL_GAS_1547',
  'CA_FUEL_GAS_1548',
  'CA_FUEL_GAS_1549',
  'CA_FUEL_GAS_1550',
  'CA_FUEL_GAS_1551',
  'CA_FUEL_GAS_1552',
  'CA_FUEL_GAS_1553',
  'CA_FUEL_GAS_1554',
  'CA_FUEL_GAS_1555',
  'CA_FUEL_GAS_1556',
  'CA_FUEL_GAS_1557',
  'CA_FUEL_GAS_1558',
  'CA_FUEL_GAS_1559',
  'CA_FUEL_GAS_1560',
  'CA_FUEL_GAS_1561',
  'CA_FUEL_GAS_1562',
  'CA_FUEL_GAS_1563',
  'CA_FUEL_GAS_1564',
  'CA_FUEL_GAS_1565',
  'CA_FUEL_GAS_1566',
  'CA_FUEL_GAS_1567',
  'CA_FUEL_GAS_1568',
  'CA_FUEL_GAS_1569',
  'CA_FUEL_GAS_1570',
  'CA_FUEL_GAS_1571',
  'CA_FUEL_GAS_1572',
  'CA_FUEL_GAS_1573',
  'CA_FUEL_GAS_1574',
  'CA_FUEL_GAS_1575',
  'CA_FUEL_GAS_1576',
  'CA_FUEL_GAS_1577',
  'CA_FUEL_GAS_1578',
  'CA_FUEL_GAS_1579',
  'CA_FUEL_GAS_1580',
  'CA_FUEL_GAS_1581',
  'CA_FUEL_GAS_1582',
  'CA_FUEL_GAS_1583',
  'CA_FUEL_GAS_1584',
  'CA_FUEL_GAS_1585',
  'CA_FUEL_GAS_1586',
  'CA_FUEL_GAS_1587',
  'CA_FUEL_GAS_1588',
  'CA_FUEL_GAS_1589',
  'CA_FUEL_GAS_1590',
  'CA_FUEL_GAS_1591',
  'CA_FUEL_GAS_1592',
  'CA_FUEL_GAS_1593',
  'CA_FUEL_GAS_1594',
  'CA_FUEL_GAS_1595',
  'CA_FUEL_GAS_1596',
  'CA_FUEL_GAS_1597',
  'CA_FUEL_GAS_1598',
  'CA_FUEL_GAS_1599',
  'CA_FUEL_GAS_1600',
  'CA_FUEL_GAS_1601',
  'CA_FUEL_GAS_1602',
  'CA_FUEL_GAS_1603',
  'CA_FUEL_GAS_1604',
  'CA_FUEL_GAS_1605',
  'CA_FUEL_GAS_1606',
  'CA_FUEL_GAS_1607',
  'CA_FUEL_GAS_1608',
  'CA_FUEL_GAS_1609',
  'CA_FUEL_GAS_1610',
  'CA_FUEL_GAS_1611',
  'CA_FUEL_GAS_1612',
  'CA_FUEL_GAS_1613',
  'CA_FUEL_GAS_1614',
  'CA_FUEL_GAS_1615',
  'CA_FUEL_GAS_1616',
  'CA_FUEL_GAS_1617',
  'CA_FUEL_GAS_1618',
  'CA_FUEL_GAS_1619',
  'CA_FUEL_GAS_1620',
  'CA_FUEL_GAS_1621',
  'CA_FUEL_GAS_1622',
  'CA_FUEL_GAS_1623',
  'CA_FUEL_GAS_1624',
  'CA_FUEL_GAS_1625',
  'CA_FUEL_GAS_1626',
  'CA_FUEL_GAS_1627',
  'CA_FUEL_GAS_1628',
  'CA_FUEL_GAS_1629',
  'CA_FUEL_GAS_1630',
  'CA_FUEL_GAS_1631',
  'CA_FUEL_GAS_1632',
  'CA_FUEL_GAS_1633',
  'CA_FUEL_GAS_1634',
  'CA_FUEL_GAS_1635',
  'CA_FUEL_GAS_1636',
  'CA_FUEL_GAS_1637',
  'CA_FUEL_GAS_1638',
  'CA_FUEL_GAS_1639',
  'CA_FUEL_GAS_1640',
  'CA_FUEL_GAS_1641',
  'CA_FUEL_GAS_1642',
  'CA_FUEL_GAS_1643',
  'CA_FUEL_GAS_1644',
  'CA_FUEL_GAS_1645',
  'CA_FUEL_GAS_1646',
  'CA_FUEL_GAS_1647',
  'CA_FUEL_GAS_1648',
  'CA_FUEL_GAS_1649',
  'CA_FUEL_GAS_1650',
  'CA_FUEL_GAS_1651',
  'CA_FUEL_GAS_1652',
  'CA_FUEL_GAS_1653',
  'CA_FUEL_GAS_1654',
  'CA_FUEL_GAS_1655',
  'CA_FUEL_GAS_1656',
  'CA_FUEL_GAS_1657',
  'CA_FUEL_GAS_1658',
  'CA_FUEL_GAS_1659',
  'CA_FUEL_GAS_1660',
  'CA_FUEL_GAS_1661',
  'CA_FUEL_GAS_1662',
  'CA_FUEL_GAS_1663',
  'CA_FUEL_GAS_1664',
  'CA_FUEL_GAS_1665',
  'CA_FUEL_GAS_1666',
  'CA_FUEL_GAS_1667',
  'CA_FUEL_GAS_1668',
  'CA_FUEL_GAS_1669',
  'CA_FUEL_GAS_1670',
  'CA_FUEL_GAS_1671',
  'CA_FUEL_GAS_1672',
  'CA_FUEL_GAS_1673',
  'CA_FUEL_GAS_1674',
  'CA_FUEL_GAS_1675',
  'CA_FUEL_GAS_1676',
  'CA_FUEL_GAS_1677',
  'CA_FUEL_GAS_1678',
  'CA_FUEL_GAS_1679',
  'CA_FUEL_GAS_1680',
  'CA_FUEL_GAS_1681',
  'CA_FUEL_GAS_1682',
  'CA_FUEL_GAS_1683',
  'CA_FUEL_GAS_1684',
  'CA_FUEL_GAS_1685',
  'CA_FUEL_GAS_1686',
  'CA_FUEL_GAS_1687',
  'CA_FUEL_GAS_1688',
  'CA_FUEL_GAS_1689',
  'CA_FUEL_GAS_1690',
  'CA_FUEL_GAS_1691',
  'CA_FUEL_GAS_1692',
  'CA_FUEL_GAS_1693',
  'CA_FUEL_GAS_1694',
  'CA_FUEL_GAS_1695',
  'CA_FUEL_GAS_1696',
  'CA_FUEL_GAS_1697',
  'CA_FUEL_GAS_1698',
  'CA_FUEL_GAS_1699',
  'CA_FUEL_GAS_1700',
  'CA_FUEL_GAS_1701',
  'CA_FUEL_GAS_1702',
  'CA_FUEL_GAS_1703',
  'CA_FUEL_GAS_1704',
  'CA_FUEL_GAS_1705',
  'CA_FUEL_GAS_1706',
  'CA_FUEL_GAS_1707',
  'CA_FUEL_GAS_1708',
  'CA_FUEL_GAS_1709',
  'CA_FUEL_GAS_1710',
  'CA_FUEL_GAS_1711',
  'CA_FUEL_GAS_1712',
  'CA_FUEL_GAS_1713',
  'CA_FUEL_GAS_1714',
  'CA_FUEL_GAS_1715',
  'CA_FUEL_GAS_1716',
  'CA_FUEL_GAS_1717',
  'CA_FUEL_GAS_1718',
  'CA_FUEL_GAS_1719',
  'CA_FUEL_GAS_1720',
  'CA_FUEL_GAS_1721',
  'CA_FUEL_GAS_1722',
  'CA_FUEL_GAS_1723',
  'CA_FUEL_GAS_1724',
  'CA_FUEL_GAS_1725',
  'CA_FUEL_GAS_1726',
  'CA_FUEL_GAS_1727',
  'CA_FUEL_GAS_1728',
  'CA_FUEL_GAS_1729',
  'CA_FUEL_GAS_1730',
  'CA_FUEL_GAS_1731',
  'CA_FUEL_GAS_1732',
  'CA_FUEL_GAS_1733',
  'CA_FUEL_GAS_1734',
  'CA_FUEL_GAS_1735',
  'CA_FUEL_GAS_1736',
  'CA_FUEL_GAS_1737',
  'CA_FUEL_GAS_1738',
  'CA_FUEL_GAS_1739',
  'CA_FUEL_GAS_1740',
  'CA_FUEL_GAS_1741',
  'CA_FUEL_GAS_1742',
  'CA_FUEL_GAS_1743',
  'CA_FUEL_GAS_1744',
  'CA_FUEL_GAS_1745',
  'CA_FUEL_GAS_1746',
  'CA_FUEL_GAS_1747',
  'CA_FUEL_GAS_1748',
  'CA_FUEL_GAS_1749',
  'CA_FUEL_GAS_1750',
  'CA_FUEL_GAS_1751',
  'CA_FUEL_GAS_1752',
  'CA_FUEL_GAS_1753',
  'CA_FUEL_GAS_1754',
  'CA_FUEL_GAS_1755',
  'CA_FUEL_GAS_1756',
  'CA_FUEL_GAS_1757',
  'CA_FUEL_GAS_1758',
  'CA_FUEL_GAS_1759',
  'CA_FUEL_GAS_1760',
  'CA_FUEL_GAS_1761',
  'CA_FUEL_GAS_1762',
  'CA_FUEL_GAS_1763',
  'CA_FUEL_GAS_1764',
  'CA_FUEL_GAS_1765',
  'CA_FUEL_GAS_1766',
  'CA_FUEL_GAS_1767',
  'CA_FUEL_GAS_1768',
  'CA_FUEL_GAS_1769',
  'CA_FUEL_GAS_1770',
  'CA_FUEL_GAS_1771',
  'CA_FUEL_GAS_1772',
  'CA_FUEL_GAS_1773',
  'CA_FUEL_GAS_1774',
  'CA_FUEL_GAS_1775',
  'CA_FUEL_GAS_1776',
  'CA_FUEL_GAS_1777',
  'CA_FUEL_GAS_1778',
  'CA_FUEL_GAS_1779',
  'CA_FUEL_GAS_1780',
  'CA_FUEL_GAS_1781',
  'CA_FUEL_GAS_1782',
  'CA_FUEL_GAS_1783',
  'CA_FUEL_GAS_1784',
  'CA_FUEL_GAS_1785',
  'CA_FUEL_GAS_1786',
  'CA_FUEL_GAS_1787',
  'CA_FUEL_GAS_1788',
  'CA_FUEL_GAS_1789',
  'CA_FUEL_GAS_1790',
  'CA_FUEL_GAS_1791',
  'CA_FUEL_GAS_1792',
  'CA_FUEL_GAS_1793',
  'CA_FUEL_GAS_1794',
  'CA_FUEL_GAS_1795',
  'CA_FUEL_GAS_1796',
  'CA_FUEL_GAS_1797',
  'CA_FUEL_GAS_1798',
  'CA_FUEL_GAS_1799',
  'CA_FUEL_GAS_1800',
  'CA_FUEL_GAS_1801',
  'CA_FUEL_GAS_1802',
  'CA_FUEL_GAS_1803',
  'CA_FUEL_GAS_1804',
  'CA_FUEL_GAS_1805',
  'CA_FUEL_GAS_1806',
  'CA_FUEL_GAS_1807',
  'CA_FUEL_GAS_1808',
  'CA_FUEL_GAS_1809',
  'CA_FUEL_GAS_1810',
  'CA_FUEL_GAS_1811',
  'CA_FUEL_GAS_1812',
  'CA_FUEL_GAS_1813',
  'CA_FUEL_GAS_1814',
  'CA_FUEL_GAS_1815',
  'CA_FUEL_GAS_1816',
  'CA_FUEL_GAS_1817',
  'CA_FUEL_GAS_1818',
  'CA_FUEL_GAS_1819',
  'CA_FUEL_GAS_1820',
  'CA_FUEL_GAS_1821',
  'CA_FUEL_GAS_1822',
  'CA_FUEL_GAS_1823',
  'CA_FUEL_GAS_1824',
  'CA_FUEL_GAS_1825',
  'CA_FUEL_GAS_1826',
  'CA_FUEL_GAS_1827',
  'CA_FUEL_GAS_1828',
  'CA_FUEL_GAS_1829',
  'CA_FUEL_GAS_1830',
  'CA_FUEL_GAS_1831',
  'CA_FUEL_GAS_1832',
  'CA_FUEL_GAS_1833',
  'CA_FUEL_GAS_1834',
  'CA_FUEL_GAS_1835',
  'CA_FUEL_GAS_1836',
  'CA_FUEL_GAS_1837',
  'CA_FUEL_GAS_1838',
  'CA_FUEL_GAS_1839',
  'CA_FUEL_GAS_1840',
  'CA_FUEL_GAS_1841',
  'CA_FUEL_GAS_1842',
  'CA_FUEL_GAS_1843',
  'CA_FUEL_GAS_1844',
  'CA_FUEL_GAS_1845',
  'CA_FUEL_GAS_1846',
  'CA_FUEL_GAS_1847',
  'CA_FUEL_GAS_1848',
  'CA_FUEL_GAS_1849',
  'CA_FUEL_GAS_1850',
  'CA_FUEL_GAS_1851',
  'CA_FUEL_GAS_1852',
  'CA_FUEL_GAS_1853',
  'CA_FUEL_GAS_1854',
  'CA_FUEL_GAS_1855',
  'CA_FUEL_GAS_1856',
  'CA_FUEL_GAS_1857',
  'CA_FUEL_GAS_1858',
  'CA_FUEL_GAS_1859',
  'CA_FUEL_GAS_1860',
  'CA_FUEL_GAS_1861',
  'CA_FUEL_GAS_1862',
  'CA_FUEL_GAS_1863',
  'CA_FUEL_GAS_1864',
  'CA_FUEL_GAS_1865',
  'CA_FUEL_GAS_1866',
  'CA_FUEL_GAS_1867',
  'CA_FUEL_GAS_1868',
  'CA_FUEL_GAS_1869',
  'CA_FUEL_GAS_1870',
  'CA_FUEL_GAS_1871',
  'CA_FUEL_GAS_1872',
  'CA_FUEL_GAS_1873',
  'CA_FUEL_GAS_1874',
  'CA_FUEL_GAS_1875',
  'CA_FUEL_GAS_1876',
  'CA_FUEL_GAS_1877',
  'CA_FUEL_GAS_1878',
  'CA_FUEL_GAS_1879',
  'CA_FUEL_GAS_1880',
  'CA_FUEL_GAS_1881',
  'CA_FUEL_GAS_1882',
  'CA_FUEL_GAS_1883',
  'CA_FUEL_GAS_1884',
  'CA_FUEL_GAS_1885',
  'CA_FUEL_GAS_1886',
  'CA_FUEL_GAS_1887',
  'CA_FUEL_GAS_1888',
  'CA_FUEL_GAS_1889',
  'CA_FUEL_GAS_1890',
  'CA_FUEL_GAS_1891',
  'CA_FUEL_GAS_1892',
  'CA_FUEL_GAS_1893',
  'CA_FUEL_GAS_1894',
  'CA_FUEL_GAS_1895',
  'CA_FUEL_GAS_1896',
  'CA_FUEL_GAS_1897',
  'CA_FUEL_GAS_1898',
  'CA_FUEL_GAS_1899',
  'CA_FUEL_GAS_1900',
  'CA_FUEL_GAS_1901',
  'CA_FUEL_GAS_1902',
  'CA_FUEL_GAS_1903',
  'CA_FUEL_GAS_1904',
  'CA_FUEL_GAS_1905',
  'CA_FUEL_GAS_1906',
  'CA_FUEL_GAS_1907',
  'CA_FUEL_GAS_1908',
  'CA_FUEL_GAS_1909',
  'CA_FUEL_GAS_1910',
  'CA_FUEL_GAS_1911',
  'CA_FUEL_GAS_1912',
  'CA_FUEL_GAS_1913',
  'CA_FUEL_GAS_1914',
  'CA_FUEL_GAS_1915',
  'CA_FUEL_GAS_1916',
  'CA_FUEL_GAS_1917',
  'CA_FUEL_GAS_1918',
  'CA_FUEL_GAS_1919',
  'CA_FUEL_GAS_1920',
  'CA_FUEL_GAS_1921',
  'CA_FUEL_GAS_1922',
  'CA_FUEL_GAS_1923',
  'CA_FUEL_GAS_1924',
  'CA_FUEL_GAS_1925',
  'CA_FUEL_GAS_1926',
  'CA_FUEL_GAS_1927',
  'CA_FUEL_GAS_1928',
  'CA_FUEL_GAS_1929',
  'CA_FUEL_GAS_1930',
  'CA_FUEL_GAS_1931',
  'CA_FUEL_GAS_1932',
  'CA_FUEL_GAS_1933',
  'CA_FUEL_GAS_1934',
  'CA_FUEL_GAS_1935',
  'CA_FUEL_GAS_1936',
  'CA_FUEL_GAS_1937',
  'CA_FUEL_GAS_1938',
  'CA_FUEL_GAS_1939',
  'CA_FUEL_GAS_1940',
  'CA_FUEL_GAS_1941',
  'CA_FUEL_GAS_1942',
  'CA_FUEL_GAS_1943',
  'CA_FUEL_GAS_1944',
  'CA_FUEL_GAS_1945',
  'CA_FUEL_GAS_1946',
  'CA_FUEL_GAS_1947',
  'CA_FUEL_GAS_1948',
  'CA_FUEL_GAS_1949',
  'CA_FUEL_GAS_1950',
  'CA_FUEL_GAS_1951',
  'CA_FUEL_GAS_1952',
  'CA_FUEL_GAS_1953',
  'CA_FUEL_GAS_1954',
  'CA_FUEL_GAS_1955',
  'CA_FUEL_GAS_1956',
  'CA_FUEL_GAS_1957',
  'CA_FUEL_GAS_1958',
  'CA_FUEL_GAS_1959',
  'CA_FUEL_OIL_1',
  'CA_FUEL_OIL_2',
  'CA_FUEL_OIL_3',
  'CA_FUEL_OIL_4',
  'CA_FUEL_OIL_5',
  'CA_FUEL_OIL_6',
  'CA_FUEL_OIL_7',
  'CA_FUEL_OIL_8',
  'CA_FUEL_OIL_9',
  'CA_FUEL_OIL_10',
  'CA_FUEL_OIL_11',
  'CA_FUEL_OIL_12',
  'CA_FUEL_OIL_13',
  'CA_FUEL_OIL_14',
  'CA_FUEL_OIL_15',
  'CA_FUEL_OIL_16',
  'CA_FUEL_OIL_17',
  'CA_FUEL_OIL_18',
  'CA_FUEL_OIL_19',
  'CA_FUEL_OIL_20',
  'CA_FUEL_OIL_21',
  'CA_FUEL_OIL_22',
  'CA_FUEL_OIL_23',
  'CA_FUEL_OIL_24',
  'CA_FUEL_OIL_25',
  'CA_FUEL_OIL_26',
  'CA_FUEL_OIL_27',
  'CA_FUEL_OIL_28',
  'CA_FUEL_OIL_29',
  'CA_FUEL_OIL_30',
  'CA_FUEL_OIL_31',
  'CA_FUEL_OIL_32',
  'CA_FUEL_OIL_33',
  'CA_FUEL_OIL_34',
  'CA_FUEL_OIL_35',
  'CA_FUEL_OIL_36',
  'CA_FUEL_OIL_37',
  'CA_FUEL_OIL_38',
  'CA_FUEL_OIL_39',
  'CA_FUEL_OIL_40',
  'CA_FUEL_OIL_41',
  'CA_FUEL_OIL_42',
  'CA_FUEL_OIL_43',
  'CA_FUEL_OIL_44',
  'CA_FUEL_OIL_45',
  'CA_FUEL_OIL_46',
  'CA_FUEL_OIL_47',
  'CA_FUEL_OIL_48',
  'CA_FUEL_OIL_49',
  'CA_FUEL_OIL_50',
  'CA_FUEL_OIL_51',
  'CA_FUEL_OIL_52',
  'CA_FUEL_OIL_53',
  'CA_FUEL_OIL_54',
  'CA_FUEL_OIL_55',
  'CA_FUEL_OIL_56',
  'CA_FUEL_OIL_57',
  'CA_FUEL_OIL_58',
  'CA_FUEL_OIL_59',
  'CA_FUEL_OIL_60',
  'CA_FUEL_OIL_61',
  'CA_FUEL_OIL_62',
  'CA_FUEL_OIL_63',
  'CA_FUEL_GAS_1964',
  'CA_FUEL_GAS_1965',
  'CA_FUEL_GAS_1966',
  'CA_FUEL_GAS_1967',
  'CA_FUEL_GAS_1968',
  'CA_FUEL_GAS_1969',
  'CA_FUEL_GAS_1970',
  'CA_FUEL_GAS_1971',
  'CA_FUEL_GAS_1972',
  'CA_FUEL_GAS_1973',
  'CA_FUEL_GAS_1974',
  'CA_FUEL_GAS_1975',
  'CA_FUEL_GAS_1976',
  'CA_FUEL_GAS_1977',
  'CA_FUEL_GAS_1978',
  'CA_FUEL_GAS_1979',
  'CA_FUEL_GAS_1980',
  'CA_FUEL_GAS_1981',
  'CA_FUEL_GAS_1982',
  'CA_FUEL_GAS_1983',
  'CA_FUEL_GAS_1984',
  'CA_FUEL_GAS_1985',
  'CA_FUEL_GAS_1986',
  'CA_FUEL_GAS_1987',
  'CA_FUEL_GAS_1988',
  'CA_FUEL_GAS_1989',
  'CA_FUEL_GAS_1990',
  'CA_FUEL_GAS_1991',
  'CA_FUEL_GAS_1992',
  'CA_FUEL_GAS_1993',
  'CA_FUEL_GAS_1994',
  'CA_FUEL_GAS_1995',
  'CA_FUEL_GAS_1996',
  'CA_FUEL_GAS_1997',
  'CA_FUEL_GAS_1998',
  'CA_FUEL_GAS_1999',
  'CA_FUEL_GAS_2000',
  'CA_FUEL_GAS_2001',
  'CA_FUEL_GAS_2002',
  'CA_FUEL_GAS_2003',
  'CA_FUEL_GAS_2004',
  'CA_FUEL_GAS_2005',
  'CA_COAL_1',
  'CA_COAL_2',
  'CA_COAL_3',
  'CA_COAL_4',
  'CA_COAL_5',
  'CA_COAL_6',
  'CA_COAL_7',
  'CA_COAL_8',
  'CA_COAL_9',
  'CA_COAL_10',
  'CA_COAL_11',
  'CA_COAL_12',
  'CA_COAL_13',
  'CA_COAL_14',
  'CA_COAL_15',
  'CA_COAL_16',
  'CA_COAL_17',
  'CA_COAL_18',
  'CA_COAL_19',
  'CA_COAL_20',
  'CA_COAL_21',
  'CA_COAL_22',
  'CA_COAL_23',
  'CA_COAL_24',
  'CA_COAL_25',
  'CA_COAL_26',
  'CA_COAL_27',
  'CA_COAL_28',
  'CA_COAL_29',
  'CA_COAL_30',
  'CA_COAL_31',
  'CA_COAL_32',
  'CA_COAL_33',
  'CA_COAL_34',
  'CA_COAL_35',
  'CA_COAL_36',
  'CA_COAL_37',
  'CA_COAL_38',
  'CA_COAL_39',
  'CA_COAL_40',
  'CA_COAL_41',
  'CA_COAL_42',
  'CA_COAL_43',
  'CA_COAL_44',
  'CA_COAL_45',
  'CA_COAL_46',
  'CA_COAL_47',
  'CA_COAL_48',
  'CA_COAL_49',
  'CA_COAL_50',
  'CA_COAL_51',
  'CA_COAL_52',
  'CA_FUEL_GAS_2006',
  'CA_ALTERNATIVE_FUEL_1',
  'CA_ALTERNATIVE_FUEL_2',
  'CA_ALTERNATIVE_FUEL_3',
  'CA_ALTERNATIVE_FUEL_4',
  'CA_ALTERNATIVE_FUEL_5',
  'CA_ALTERNATIVE_FUEL_6',
  'CA_ALTERNATIVE_FUEL_7',
  'CA_ALTERNATIVE_FUEL_8',
  'CA_ALTERNATIVE_FUEL_9',
  'CA_ALTERNATIVE_FUEL_10',
  'CA_ALTERNATIVE_FUEL_11',
  'CA_ALTERNATIVE_FUEL_12',
  'CA_ALTERNATIVE_FUEL_13',
  'CA_BIOMASS_1',
  'CA_BIOMASS_2',
  'CA_BIOMASS_3',
  'CA_BIOMASS_4',
  'CA_BIOMASS_5',
  'CA_BIOMASS_6',
  'CA_BIOMASS_7',
  'CA_FUEL_OIL_65',
  'CA_FUEL_OIL_66',
  'CA_FUEL_OIL_67',
  'CA_FUEL_OIL_68',
  'CA_FUEL_OIL_69',
  'CA_FUEL_OIL_70',
  'CA_FUEL_OIL_71',
  'CA_FUEL_OIL_72',
  'CA_FUEL_OIL_73',
  'CA_FUEL_OIL_74',
  'CA_FUEL_OIL_75',
  'CA_FUEL_OIL_76',
  'CA_FUEL_OIL_77',
  'CA_FUEL_OIL_78',
  'CA_FUEL_OIL_79',
  'CA_FUEL_OIL_80',
  'CA_FUEL_OIL_81',
  'CA_FUEL_OIL_82',
  'CA_FUEL_OIL_83',
  'CA_FUEL_OIL_84',
  'CA_FUEL_OIL_85',
  'CA_FUEL_OIL_86',
  'CA_FUEL_OIL_87',
  'CA_FUEL_GAS_2007',
  'CA_FUEL_OIL_64',
  'CA_FUEL_OIL_88',
  'CA_FUEL_OIL_89',
  'CA_FUEL_OIL_90',
  'CA_FUEL_OIL_91',
  'CA_FUEL_OIL_92',
  'CA_FUEL_OIL_93',
  'CA_FUEL_GAS_2008',
  'CA_FUEL_OIL_94',
  'CA_FUEL_OIL_95',
  'CA_FUEL_OIL_96',
  'CA_FUEL_OIL_97',
  'CA_FUEL_OIL_98',
  'CA_FUEL_OIL_99',
  'CA_FUEL_OIL_100',
  'CA_FUEL_OIL_101',
  'CA_FUEL_OIL_102',
  'CA_FUEL_OIL_103',
  'CA_FUEL_OIL_104',
  'HK_FUEL_OIL_1',
  'HK_FUEL_OIL_2',
  'HK_FUEL_OIL_3',
  'HK_BIOFUEL_1',
  'HK_FUEL_GAS_1',
  'HK_FUEL_OIL_4',
  'HK_FUEL_OIL_5',
  'HK_FUEL_OIL_6',
  'HK_FUEL_OIL_7',
  'HK_FUEL_OIL_8',
  'HK_FUEL_OIL_9',
  'HK_FUEL_OIL_10',
  'HK_FUEL_OIL_11',
  'HK_FUEL_OIL_12',
  'HK_FUEL_OIL_13',
  'HK_FUEL_OIL_14',
  'HK_FUEL_OIL_15',
  'HK_FUEL_OIL_16',
  'HK_FUEL_OIL_17',
  'HK_FUEL_OIL_18',
  'HK_FUEL_OIL_19',
  'EURO_RM_FUEL_1',
  'EURO_RM_FUEL_2',
  'EURO_RM_FUEL_3',
  'EURO_RM_FUEL_4',
  'EURO_RM_FUEL_5',
  'EURO_RM_FUEL_6',
  'EURO_RM_FUEL_7',
  'EURO_RM_FUEL_8',
  'EURO_RM_FUEL_9',
  'EURO_RM_FUEL_10',
  'EURO_RM_FUEL_11',
  'EURO_RM_FUEL_12',
  'EURO_RM_FUEL_13',
  'EURO_RM_FUEL_14',
  'EURO_RM_FUEL_15',
  'EURO_RM_FUEL_16',
  'EURO_RM_FUEL_17',
  'EURO_RM_FUEL_18',
  'EURO_RM_FUEL_19',
  'EURO_RM_FUEL_20',
  'EURO_RM_FUEL_21',
  'EURO_RM_FUEL_22',
  'EURO_RM_FUEL_23',
  'EURO_RM_FUEL_24',
  'EURO_RM_FUEL_25',
  'EURO_RM_FUEL_26',
  'EURO_RM_FUEL_27',
  'EURO_RM_FUEL_28',
  'EURO_RM_FUEL_29',
  'EURO_RM_FUEL_30',
  'EURO_RM_FUEL_31',
  'EURO_RM_FUEL_32',
  'NA_RM_FUEL_1',
  'NA_RM_FUEL_2',
  'NA_RM_FUEL_3',
  'NA_RM_FUEL_4',
  'NA_RM_FUEL_5',
  'NA_RM_FUEL_6',
  'NA_RM_FUEL_7',
  'NA_RM_FUEL_8',
  'NA_RM_FUEL_9',
  'NA_RM_FUEL_10',
  'NA_RM_FUEL_11',
  'NA_RM_FUEL_12',
  'NA_RM_FUEL_13',
  'NA_RM_FUEL_14',
  'NA_RM_FUEL_15',
  'NA_RM_FUEL_16',
  'NA_RM_FUEL_17',
  'NA_RM_FUEL_18',
  'NA_RM_FUEL_19',
  'NA_RM_FUEL_20',
  'NA_RM_FUEL_21',
  'NA_RM_FUEL_22',
  'NA_RM_FUEL_23',
  'NA_RM_FUEL_24',
  'NA_RM_FUEL_25',
  'NA_RM_FUEL_26',
  'NA_RM_FUEL_27',
  'NA_RM_FUEL_28',
  'EURO_RM_FUEL_33',
  'EURO_RM_FUEL_34',
  'EURO_RM_FUEL_35',
  'EURO_RM_FUEL_36',
  'EURO_RM_FUEL_37',
  'EURO_RM_FUEL_38',
  'EURO_RM_FUEL_39',
  'EURO_RM_FUEL_40',
  'EURO_RM_FUEL_41',
  'EURO_RM_FUEL_42',
  'EURO_RM_FUEL_43',
  'EURO_RM_FUEL_44',
  'EURO_RM_FUEL_45',
  'EURO_RM_FUEL_46',
  'EURO_RM_FUEL_47',
  'EURO_RM_FUEL_48',
  'EURO_RM_FUEL_49',
  'EURO_RM_FUEL_50',
  'EURO_RM_FUEL_51',
  'EURO_RM_FUEL_52',
  'EURO_RM_FUEL_53',
  'EURO_RM_FUEL_54',
  'EURO_RM_FUEL_55',
  'EURO_RM_FUEL_56',
  'EURO_RM_FUEL_57',
  'EURO_RM_FUEL_58',
  'EURO_RM_FUEL_59',
  'EURO_RM_FUEL_60',
  'EURO_RM_FUEL_61',
  'EURO_RM_FUEL_62',
  'EURO_RM_FUEL_63',
  'EURO_RM_FUEL_64',
  'NA_RM_FUEL_29',
  'NA_RM_FUEL_30',
  'NA_RM_FUEL_31',
  'NA_RM_FUEL_32',
  'NA_RM_FUEL_33',
  'NA_RM_FUEL_34',
  'NA_RM_FUEL_35',
  'NA_RM_FUEL_36',
  'NA_RM_FUEL_37',
  'NA_RM_FUEL_38',
  'NA_RM_FUEL_39',
  'NA_RM_FUEL_40',
  'NA_RM_FUEL_41',
  'NA_RM_FUEL_42',
  'NA_RM_FUEL_43',
  'NA_RM_FUEL_44',
  'NA_RM_FUEL_45',
  'NA_RM_FUEL_46',
  'NA_RM_FUEL_47',
  'NA_RM_FUEL_48',
  'NA_RM_FUEL_49',
  'NA_RM_FUEL_50',
  'NA_RM_FUEL_51',
  'NA_RM_FUEL_52',
  'NA_RM_FUEL_53',
  'NA_RM_FUEL_54',
  'NA_RM_FUEL_55',
  'NA_RM_FUEL_56',
  'EURO_RM_FUEL_65',
  'EURO_RM_FUEL_66',
  'EURO_RM_FUEL_67',
  'EURO_RM_FUEL_68',
  'EURO_RM_FUEL_69',
  'EURO_RM_FUEL_70',
  'EURO_RM_FUEL_71',
  'EURO_RM_FUEL_72',
  'EURO_RM_FUEL_73',
  'EURO_RM_FUEL_74',
  'EURO_RM_FUEL_75',
  'EURO_RM_FUEL_76',
  'EURO_RM_FUEL_77',
  'EURO_RM_FUEL_78',
  'EURO_RM_FUEL_79',
  'EURO_RM_FUEL_80',
  'EURO_RM_FUEL_81',
  'EURO_RM_FUEL_82',
  'EURO_RM_FUEL_83',
  'EURO_RM_FUEL_84',
  'EURO_RM_FUEL_85',
  'EURO_RM_FUEL_86',
  'EURO_RM_FUEL_87',
  'EURO_RM_FUEL_88',
  'EURO_RM_FUEL_89',
  'EURO_RM_FUEL_90',
  'EURO_RM_FUEL_91',
  'EURO_RM_FUEL_92',
  'EURO_RM_FUEL_93',
  'EURO_RM_FUEL_94',
  'EURO_RM_FUEL_95',
  'EURO_RM_FUEL_96',
  'NA_RM_FUEL_57',
  'NA_RM_FUEL_58',
  'NA_RM_FUEL_59',
  'NA_RM_FUEL_60',
  'NA_RM_FUEL_61',
  'NA_RM_FUEL_62',
  'NA_RM_FUEL_63',
  'NA_RM_FUEL_64',
  'NA_RM_FUEL_65',
  'NA_RM_FUEL_66',
  'NA_RM_FUEL_67',
  'NA_RM_FUEL_68',
  'NA_RM_FUEL_69',
  'NA_RM_FUEL_70',
  'NA_RM_FUEL_71',
  'NA_RM_FUEL_72',
  'NA_RM_FUEL_73',
  'NA_RM_FUEL_74',
  'NA_RM_FUEL_75',
  'NA_RM_FUEL_76',
  'NA_RM_FUEL_77',
  'NA_RM_FUEL_78',
  'NA_RM_FUEL_79',
  'NA_RM_FUEL_80',
  'NA_RM_FUEL_81',
  'NA_RM_FUEL_82',
  'NA_RM_FUEL_83',
  'NA_RM_FUEL_84',
  'EURO_RM_FUEL_97',
  'EURO_RM_FUEL_98',
  'EURO_RM_FUEL_99',
  'EURO_RM_FUEL_100',
  'EURO_RM_FUEL_101',
  'EURO_RM_FUEL_102',
  'EURO_RM_FUEL_103',
  'EURO_RM_FUEL_104',
  'EURO_RM_FUEL_105',
  'EURO_RM_FUEL_106',
  'EURO_RM_FUEL_107',
  'EURO_RM_FUEL_108',
  'EURO_RM_FUEL_109',
  'EURO_RM_FUEL_110',
  'EURO_RM_FUEL_111',
  'EURO_RM_FUEL_112',
  'EURO_RM_FUEL_113',
  'EURO_RM_FUEL_114',
  'EURO_RM_FUEL_115',
  'EURO_RM_FUEL_116',
  'EURO_RM_FUEL_117',
  'EURO_RM_FUEL_118',
  'EURO_RM_FUEL_119',
  'EURO_RM_FUEL_120',
  'EURO_RM_FUEL_121',
  'EURO_RM_FUEL_122',
  'EURO_RM_FUEL_123',
  'EURO_RM_FUEL_124',
  'EURO_RM_FUEL_125',
  'EURO_RM_FUEL_126',
  'EURO_RM_FUEL_127',
  'EURO_RM_FUEL_128',
  'NA_RM_FUEL_85',
  'NA_RM_FUEL_86',
  'NA_RM_FUEL_87',
  'NA_RM_FUEL_88',
  'NA_RM_FUEL_89',
  'NA_RM_FUEL_90',
  'NA_RM_FUEL_91',
  'NA_RM_FUEL_92',
  'NA_RM_FUEL_93',
  'NA_RM_FUEL_94',
  'NA_RM_FUEL_95',
  'NA_RM_FUEL_96',
  'NA_RM_FUEL_97',
  'NA_RM_FUEL_98',
  'NA_RM_FUEL_99',
  'NA_RM_FUEL_100',
  'NA_RM_FUEL_101',
  'NA_RM_FUEL_102',
  'NA_RM_FUEL_103',
  'NA_RM_FUEL_104',
  'NA_RM_FUEL_105',
  'NA_RM_FUEL_106',
  'NA_RM_FUEL_107',
  'NA_RM_FUEL_108',
  'NA_RM_FUEL_109',
  'NA_RM_FUEL_110',
  'NA_RM_FUEL_111',
  'NA_RM_FUEL_112',
  'SG_COAL_1',
  'SG_COAL_2',
  'SG_COAL_3',
  'SG_COAL_4',
  'SG_COAL_5',
  'SG_COAL_6',
  'SG_COAL_7',
  'SG_COAL_8',
  'SG_COAL_9',
  'SG_COAL_10',
  'SG_COAL_11',
  'SG_COAL_12',
  'SG_FUEL_OIL_1',
  'SG_FUEL_OIL_2',
  'SG_FUEL_OIL_3',
  'SG_FUEL_OIL_4',
  'SG_FUEL_OIL_5',
  'SG_FUEL_OIL_6',
  'SG_FUEL_OIL_7',
  'SG_FUEL_OIL_8',
  'SG_FUEL_OIL_9',
  'SG_FUEL_OIL_10',
  'SG_FUEL_OIL_11',
  'SG_FUEL_OIL_12',
  'SG_FUEL_OIL_13',
  'SG_FUEL_OIL_14',
  'SG_FUEL_OIL_15',
  'SG_FUEL_OIL_16',
  'SG_FUEL_OIL_17',
  'SG_FUEL_OIL_18',
  'SG_FUEL_OIL_19',
  'SG_FUEL_OIL_20',
  'SG_FUEL_OIL_21',
  'SG_FUEL_GAS_1',
  'SG_FUEL_GAS_2',
  'SG_FUEL_GAS_3',
  'SG_FUEL_GAS_4',
  'SG_FUEL_GAS_5',
  'SG_FUEL_GAS_6',
  'SG_FUEL_GAS_7',
  'SG_FUEL_GAS_8',
  'SG_BIOFUEL_1',
  'SG_BIOFUEL_2',
  'SG_BIOFUEL_3',
  'SG_BIOFUEL_4',
  'SG_BIOFUEL_5',
  'SG_BIOFUEL_6',
  'SG_BIOFUEL_7',
  'SG_BIOFUEL_8',
  'SG_BIOFUEL_9',
  'SG_BIOFUEL_10',
  'SG_BIOFUEL_11',
  'SG_BIOFUEL_12',
  'SG_BIOFUEL_13',
  'SG_BIOFUEL_14',
  'SG_BIOFUEL_15',
  'SG_BIOFUEL_16',
  'SG_BIOFUEL_17',
  'SG_BIOFUEL_18',
  'SG_BIOFUEL_19',
  'SG_BIOFUEL_20',
  'SG_OTHER_FUEL_1',
  'SG_OTHER_FUEL_2',
  'SG_COAL_13',
  'SG_COAL_14',
  'SG_COAL_15',
  'SG_COAL_16',
  'SG_COAL_17',
  'SG_COAL_18',
  'SG_COAL_19',
  'SG_COAL_20',
  'SG_COAL_21',
  'SG_COAL_22',
  'SG_COAL_23',
  'SG_COAL_24',
  'SG_FUEL_OIL_22',
  'SG_FUEL_OIL_23',
  'SG_FUEL_OIL_24',
  'SG_FUEL_OIL_25',
  'SG_FUEL_OIL_26',
  'SG_FUEL_OIL_27',
  'SG_FUEL_OIL_28',
  'SG_FUEL_OIL_29',
  'SG_FUEL_OIL_30',
  'SG_FUEL_OIL_31',
  'SG_FUEL_OIL_32',
  'SG_FUEL_OIL_33',
  'SG_FUEL_OIL_34',
  'SG_FUEL_OIL_35',
  'SG_FUEL_OIL_36',
  'SG_FUEL_OIL_37',
  'SG_FUEL_OIL_38',
  'SG_FUEL_OIL_39',
  'SG_FUEL_OIL_40',
  'SG_FUEL_OIL_41',
  'SG_FUEL_OIL_42',
  'SG_FUEL_GAS_9',
  'SG_FUEL_GAS_10',
  'SG_FUEL_GAS_11',
  'SG_FUEL_GAS_12',
  'SG_FUEL_GAS_13',
  'SG_FUEL_GAS_14',
  'SG_FUEL_GAS_15',
  'SG_FUEL_GAS_16',
  'SG_BIOFUEL_21',
  'SG_BIOFUEL_22',
  'SG_BIOFUEL_23',
  'SG_BIOFUEL_24',
  'SG_BIOFUEL_25',
  'SG_BIOFUEL_26',
  'SG_BIOFUEL_27',
  'SG_BIOFUEL_28',
  'SG_BIOFUEL_29',
  'SG_BIOFUEL_30',
  'SG_BIOFUEL_31',
  'SG_BIOFUEL_32',
  'SG_BIOFUEL_33',
  'SG_BIOFUEL_34',
  'SG_BIOFUEL_35',
  'SG_BIOFUEL_36',
  'SG_BIOFUEL_37',
  'SG_BIOFUEL_38',
  'SG_BIOFUEL_39',
  'SG_BIOFUEL_40',
  'SG_OTHER_FUEL_3',
  'SG_OTHER_FUEL_4',
  'GLEC_RM_FUEL_1',
  'GLEC_RM_FUEL_2',
  'GLEC_RM_FUEL_3',
  'GLEC_RM_FUEL_4',
  'GLEC_RM_FUEL_5',
  'GLEC_RM_FUEL_6',
  'GLEC_RM_FUEL_7',
  'GLEC_RM_FUEL_8',
  'GLEC_RM_FUEL_9',
  'GLEC_RM_FUEL_10',
  'GLEC_RM_FUEL_11',
  'GLEC_RM_FUEL_12',
  'GLEC_RM_FUEL_13',
  'GLEC_RM_FUEL_14',
  'GLEC_RM_FUEL_15',
  'GLEC_RM_FUEL_16',
  'GLEC_RM_FUEL_17',
  'GLEC_RM_FUEL_18',
  'GLEC_RM_FUEL_19',
  'GLEC_RM_FUEL_20',
  'GLEC_RM_FUEL_21',
  'GLEC_RM_FUEL_22',
  'GLEC_RM_FUEL_23',
  'GLEC_RM_FUEL_24',
  'GLEC_RM_FUEL_25',
  'GLEC_RM_FUEL_26',
  'GLEC_RM_FUEL_27',
  'GLEC_RM_FUEL_28',
  'GLEC_RM_FUEL_29',
  'GLEC_RM_FUEL_30',
  'GLEC_RM_FUEL_31',
  'GLEC_RM_FUEL_32',
  'GLEC_RM_FUEL_33',
  'GLEC_RM_FUEL_34',
  'GLEC_RM_FUEL_35',
  'GLEC_RM_FUEL_36',
  'GLEC_RM_FUEL_37',
  'GLEC_RM_FUEL_38',
  'GLEC_RM_FUEL_39',
  'GLEC_RM_FUEL_40',
  'GLEC_RM_FUEL_41',
  'GLEC_RM_FUEL_42',
  'GLEC_RM_FUEL_43',
  'GLEC_RM_FUEL_44',
  'GLEC_RM_FUEL_45',
  'GLEC_RM_FUEL_46',
  'GLEC_RM_FUEL_47',
  'GLEC_RM_FUEL_48',
  'GLEC_RM_FUEL_49',
  'GLEC_RM_FUEL_50',
  'GLEC_RM_FUEL_51',
  'GLEC_RM_FUEL_52',
  'GLEC_RM_FUEL_53',
  'GLEC_RM_FUEL_54',
  'GLEC_RM_FUEL_55',
  'GLEC_RM_FUEL_56',
  'GLEC_RM_FUEL_57',
  'GLEC_RM_FUEL_58',
  'GLEC_RM_FUEL_59',
  'GLEC_RM_FUEL_60',
  'GLEC_RM_FUEL_61',
  'GLEC_RM_FUEL_62',
  'GLEC_RM_FUEL_63',
  'GLEC_RM_FUEL_64',
  'GLEC_RM_FUEL_65',
  'GLEC_RM_FUEL_66',
  'GLEC_RM_FUEL_67',
  'GLEC_RM_FUEL_68',
  'GLEC_RM_FUEL_69',
  'GLEC_RM_FUEL_70',
  'GLEC_RM_FUEL_71',
  'GLEC_RM_FUEL_72',
  'GLEC_RM_FUEL_73',
  'GLEC_RM_FUEL_74',
  'GLEC_RM_FUEL_75',
  'GLEC_RM_FUEL_76',
  'GLEC_RM_FUEL_77',
  'GLEC_RM_FUEL_78',
  'GLEC_RM_FUEL_79',
  'GLEC_RM_FUEL_80',
  'GLEC_RM_FUEL_81',
  'GLEC_RM_FUEL_82',
  'GLEC_RM_FUEL_83',
  'GLEC_RM_FUEL_84',
  'GLEC_RM_FUEL_85',
  'GLEC_RM_FUEL_86',
  'GLEC_RM_FUEL_87',
  'GLEC_RM_FUEL_88',
  'GLEC_RM_FUEL_89',
  'GLEC_RM_FUEL_90',
  'GLEC_RM_FUEL_91',
  'GLEC_RM_FUEL_92',
  'GLEC_RM_FUEL_93',
  'GLEC_RM_FUEL_94',
  'GLEC_RM_FUEL_95',
  'GLEC_RM_FUEL_96',
  'GLEC_RM_FUEL_97',
  'GLEC_RM_FUEL_98',
  'GLEC_RM_FUEL_99',
  'GLEC_RM_FUEL_100',
  'GLEC_RM_FUEL_101',
  'GLEC_RM_FUEL_102',
  'GLEC_RM_FUEL_103',
  'GLEC_RM_FUEL_104',
  'GLEC_RM_FUEL_105',
  'GLEC_RM_FUEL_106',
  'GLEC_RM_FUEL_107',
  'GLEC_RM_FUEL_108',
  'GLEC_RM_FUEL_109',
  'GLEC_RM_FUEL_110',
  'GLEC_RM_FUEL_111',
  'GLEC_RM_FUEL_112',
  'GLEC_RM_FUEL_113',
  'GLEC_RM_FUEL_114',
  'GLEC_RM_FUEL_115',
  'GLEC_RM_FUEL_116',
  'GLEC_RM_FUEL_117',
  'GLEC_RM_FUEL_118',
  'GLEC_RM_FUEL_119',
  'GLEC_RM_FUEL_120',
  'GLEC_RM_FUEL_121',
  'GLEC_RM_FUEL_122',
  'GLEC_RM_FUEL_123',
  'GLEC_RM_FUEL_124',
  'GLEC_RM_FUEL_125',
  'GLEC_RM_FUEL_126',
  'GLEC_RM_FUEL_127',
  'GLEC_RM_FUEL_128',
  'GLEC_RM_FUEL_129',
  'GLEC_RM_FUEL_130',
  'GLEC_RM_FUEL_131',
  'GLEC_RM_FUEL_132',
  'GLEC_RM_FUEL_133',
  'GLEC_RM_FUEL_134',
  'GLEC_RM_FUEL_135',
  'GLEC_RM_FUEL_136',
  'GLEC_RM_FUEL_137',
  'GLEC_RM_FUEL_138',
  'GLEC_RM_FUEL_139',
  'GLEC_RM_FUEL_140',
  'GLEC_RM_FUEL_141',
  'GLEC_RM_FUEL_142',
  'GLEC_RM_FUEL_143',
  'GLEC_RM_FUEL_144',
  'GLEC_RM_FUEL_145',
  'GLEC_RM_FUEL_146',
  'GLEC_RM_FUEL_147',
  'GLEC_RM_FUEL_148',
  'GLEC_RM_FUEL_149',
  'GLEC_RM_FUEL_150',
  'GLEC_RM_FUEL_151',
  'GLEC_RM_FUEL_152',
  'GLEC_RM_FUEL_153',
  'GLEC_RM_FUEL_154',
  'GLEC_RM_FUEL_155',
  'GLEC_RM_FUEL_156',
  'GLEC_RM_FUEL_157',
  'GLEC_RM_FUEL_158',
  'GLEC_RM_FUEL_159',
  'GLEC_RM_FUEL_160',
  'GLEC_RM_FUEL_161',
  'GLEC_RM_FUEL_162',
  'GLEC_RM_FUEL_163',
  'GLEC_RM_FUEL_164',
  'GLEC_RM_FUEL_165',
  'GLEC_RM_FUEL_166',
  'GLEC_RM_FUEL_167',
  'GLEC_RM_FUEL_168',
  'GLEC_RM_FUEL_169',
  'GLEC_RM_FUEL_170',
  'GLEC_RM_FUEL_171',
  'GLEC_RM_FUEL_172',
  'GLEC_RM_FUEL_173',
  'GLEC_RM_FUEL_174',
  'GLEC_RM_FUEL_175',
  'GLEC_RM_FUEL_176',
  'GLEC_RM_FUEL_177',
  'GLEC_RM_FUEL_178',
  'GLEC_RM_FUEL_179',
  'GLEC_RM_FUEL_180',
  'GLEC_RM_FUEL_181',
  'GLEC_RM_FUEL_182',
  'GLEC_RM_FUEL_183',
  'GLEC_RM_FUEL_184',
  'GLEC_RM_FUEL_185',
  'GLEC_RM_FUEL_186',
  'GLEC_RM_FUEL_187',
  'GLEC_RM_FUEL_188',
  'GLEC_RM_FUEL_189',
  'GLEC_RM_FUEL_190',
  'GLEC_RM_FUEL_191',
  'GLEC_RM_FUEL_192',
  'GLEC_RM_FUEL_193',
  'GLEC_RM_FUEL_194',
  'GLEC_RM_FUEL_195',
  'GLEC_RM_FUEL_196',
  'GLEC_RM_FUEL_197',
  'GLEC_RM_FUEL_198',
  'GLEC_RM_FUEL_199',
  'GLEC_RM_FUEL_200',
  'GLEC_RM_FUEL_201',
  'GLEC_RM_FUEL_202',
  'GLEC_RM_FUEL_203',
  'GLEC_RM_FUEL_204',
  'GLEC_RM_FUEL_205',
  'GLEC_RM_FUEL_206',
  'GLEC_RM_FUEL_207',
  'GLEC_RM_FUEL_208',
  'GLEC_RM_FUEL_209',
  'GLEC_RM_FUEL_210',
  'GLEC_RM_FUEL_211',
  'GLEC_RM_FUEL_212',
  'GLEC_RM_FUEL_213',
  'GLEC_RM_FUEL_214',
  'GLEC_RM_FUEL_215',
  'GLEC_RM_FUEL_216',
  'GLEC_RM_FUEL_217',
  'GLEC_RM_FUEL_218',
  'GLEC_RM_FUEL_219',
  'GLEC_RM_FUEL_220',
  'GLEC_RM_FUEL_221',
  'GLEC_RM_FUEL_222',
  'GLEC_RM_FUEL_223',
  'GLEC_RM_FUEL_224',
  'GLEC_RM_FUEL_225',
  'GLEC_RM_FUEL_226',
  'GLEC_RM_FUEL_227',
  'GLEC_RM_FUEL_228',
  'GLEC_RM_FUEL_229',
  'GLEC_RM_FUEL_230',
  'GLEC_RM_FUEL_231',
  'GLEC_RM_FUEL_232',
  'GLEC_RM_FUEL_233',
  'GLEC_RM_FUEL_234',
  'GLEC_RM_FUEL_235',
  'GLEC_RM_FUEL_236',
  'GLEC_RM_FUEL_237',
  'GLEC_RM_FUEL_238',
  'GLEC_RM_FUEL_239',
  'GLEC_RM_FUEL_240',
  'GLEC_RM_FUEL_241',
  'GLEC_RM_FUEL_242',
  'GLEC_RM_FUEL_243',
  'GLEC_RM_FUEL_244',
  'GLEC_RM_FUEL_245',
  'GLEC_RM_FUEL_246',
  'GLEC_RM_FUEL_247',
  'GLEC_RM_FUEL_248',
  'GLEC_RM_FUEL_249',
  'GLEC_RM_FUEL_250',
  'GLEC_RM_FUEL_251',
  'GLEC_RM_FUEL_252',
  'GLEC_RM_FUEL_253',
  'GLEC_RM_FUEL_254',
  'GLEC_RM_FUEL_255',
  'GLEC_RM_FUEL_256',
  'GLEC_RM_FUEL_257',
  'GLEC_RM_FUEL_258',
  'GLEC_RM_FUEL_259',
  'GLEC_RM_FUEL_260',
  'GLEC_RM_FUEL_261',
  'GLEC_RM_FUEL_262',
  'GLEC_RM_FUEL_263',
  'GLEC_RM_FUEL_264',
  'GLEC_RM_FUEL_265',
  'GLEC_RM_FUEL_266',
  'GLEC_RM_FUEL_267',
  'GLEC_RM_FUEL_268',
  'GLEC_RM_FUEL_269',
  'GLEC_RM_FUEL_270',
  'GLEC_RM_FUEL_271',
  'GLEC_RM_FUEL_272',
  'GLEC_RM_FUEL_273',
  'GLEC_RM_FUEL_274',
  'GLEC_RM_FUEL_275',
  'GLEC_RM_FUEL_276',
  'GLEC_RM_FUEL_277',
  'GLEC_RM_FUEL_278',
  'GLEC_RM_FUEL_279',
  'GLEC_RM_FUEL_280',
  'GLEC_RM_FUEL_281',
  'GLEC_RM_FUEL_282',
  'GLEC_RM_FUEL_283',
  'GLEC_RM_FUEL_284',
  'GLEC_RM_FUEL_285',
  'GLEC_RM_FUEL_286',
  'GLEC_RM_FUEL_287',
  'GLEC_RM_FUEL_288',
  'GLEC_RM_FUEL_289',
  'GLEC_RM_FUEL_290',
  'GLEC_RM_FUEL_291',
  'GLEC_RM_FUEL_292',
  'GLEC_RM_FUEL_293',
  'GLEC_RM_FUEL_294',
  'GLEC_RM_FUEL_295',
  'GLEC_RM_FUEL_296',
  'GLEC_RM_FUEL_297',
  'GLEC_RM_FUEL_298',
  'GLEC_RM_FUEL_299',
  'GLEC_RM_FUEL_300',
  'GLEC_RM_FUEL_301',
  'GLEC_RM_FUEL_302',
  'GLEC_RM_FUEL_303',
  'GLEC_RM_FUEL_304',
  'GLEC_RM_FUEL_305',
  'GLEC_RM_FUEL_306',
  'GLEC_RM_FUEL_307',
  'GLEC_RM_FUEL_308',
  'GLEC_RM_FUEL_309',
  'GLEC_RM_FUEL_310',
  'GLEC_RM_FUEL_311',
  'GLEC_RM_FUEL_312',
  'GLEC_RM_FUEL_313',
  'GLEC_RM_FUEL_314',
  'GLEC_RM_FUEL_315',
  'GLEC_RM_FUEL_316',
  'GLEC_RM_FUEL_317',
  'GLEC_RM_FUEL_318',
  'GLEC_RM_FUEL_319',
  'GLEC_RM_FUEL_320',
  'GLEC_RM_FUEL_321',
  'GLEC_RM_FUEL_322',
  'GLEC_RM_FUEL_323',
  'GLEC_RM_FUEL_324',
  'GLEC_RM_FUEL_325',
  'GLEC_RM_FUEL_326',
  'GLEC_RM_FUEL_327',
  'GLEC_RM_FUEL_328',
  'GLEC_RM_FUEL_329',
  'GLEC_RM_FUEL_330',
  'GLEC_RM_FUEL_331',
  'GLEC_RM_FUEL_332',
  'GLEC_RM_FUEL_333',
  'GLEC_RM_FUEL_334',
  'GLEC_RM_FUEL_335',
  'GLEC_RM_FUEL_336',
  'GLEC_RM_FUEL_337',
  'GLEC_RM_FUEL_338',
  'GLEC_RM_FUEL_339',
  'GLEC_RM_FUEL_340',
  'GLEC_RM_FUEL_341',
  'GLEC_RM_FUEL_342',
  'GLEC_RM_FUEL_343',
  'GLEC_RM_FUEL_344',
  'GLEC_RM_FUEL_345',
  'GLEC_RM_FUEL_346',
  'GLEC_RM_FUEL_347',
  'GLEC_RM_FUEL_348',
  'GLEC_RM_FUEL_349',
  'GLEC_RM_FUEL_350',
  'GLEC_RM_FUEL_351',
  'GLEC_RM_FUEL_352',
  'GLEC_RM_FUEL_353',
  'GLEC_RM_FUEL_354',
  'GLEC_RM_FUEL_355',
  'GLEC_RM_FUEL_356',
  'GLEC_RM_FUEL_357',
  'GLEC_RM_FUEL_358',
  'GLEC_RM_FUEL_359',
  'GLEC_RM_FUEL_360',
  'GLEC_RM_FUEL_361',
  'GLEC_RM_FUEL_362',
  'GLEC_RM_FUEL_363',
  'GLEC_RM_FUEL_364',
  'GLEC_RM_FUEL_365',
  'GLEC_RM_FUEL_366',
  'GLEC_RM_FUEL_367',
  'GLEC_RM_FUEL_368',
  'GLEC_RM_FUEL_369',
  'GLEC_RM_FUEL_370',
  'GLEC_RM_FUEL_371',
  'GLEC_RM_FUEL_372',
  'GLEC_RM_FUEL_373',
  'GLEC_RM_FUEL_374',
  'GLEC_RM_FUEL_375',
  'GLEC_RM_FUEL_376',
  'GLEC_RM_FUEL_377',
  'GLEC_RM_FUEL_378',
  'GLEC_RM_FUEL_379',
  'GLEC_RM_FUEL_380',
  'GLEC_RM_FUEL_381',
  'GLEC_RM_FUEL_382',
  'GLEC_RM_FUEL_383',
  'GLEC_RM_FUEL_384',
  'GLEC_RM_FUEL_385',
  'GLEC_RM_FUEL_386',
  'GLEC_RM_FUEL_387',
  'GLEC_RM_FUEL_388',
  'CBAM_RM_FUEL_1',
  'CBAM_RM_FUEL_2',
  'CBAM_RM_FUEL_3',
  'CBAM_RM_FUEL_4',
  'CBAM_RM_FUEL_5',
  'CBAM_RM_FUEL_6',
  'CBAM_RM_FUEL_7',
  'CBAM_RM_FUEL_8',
  'CBAM_RM_FUEL_9',
  'CBAM_RM_FUEL_10',
  'CBAM_RM_FUEL_11',
  'CBAM_RM_FUEL_12',
  'CBAM_RM_FUEL_13',
  'CBAM_RM_FUEL_14',
  'CBAM_RM_FUEL_15',
  'CBAM_RM_FUEL_16',
  'CBAM_RM_FUEL_17',
  'CBAM_RM_FUEL_18',
  'CBAM_RM_FUEL_19',
  'CBAM_RM_FUEL_20',
  'CBAM_RM_FUEL_21',
  'CBAM_RM_FUEL_22',
  'CBAM_RM_FUEL_23',
  'CBAM_RM_FUEL_24',
  'CBAM_RM_FUEL_25',
  'CBAM_RM_FUEL_26',

  'ADEME_RM_FUEL_1',
  'ADEME_RM_FUEL_2',
  'ADEME_RM_FUEL_3',
  'ADEME_RM_FUEL_4',
  'ADEME_RM_FUEL_5',
  'ADEME_RM_FUEL_6',
  'ADEME_RM_FUEL_7',
  'ADEME_RM_FUEL_8',
  'ADEME_RM_FUEL_9',
  'ADEME_RM_FUEL_10',
  'ADEME_RM_FUEL_11',
  'ADEME_RM_FUEL_12',
  'ADEME_RM_FUEL_13',
  'ADEME_RM_FUEL_14',
  'ADEME_RM_FUEL_15',
  'ADEME_RM_FUEL_16',
  'ADEME_RM_FUEL_17',
  'ADEME_RM_FUEL_18',
  'ADEME_RM_FUEL_19',
  'ADEME_RM_FUEL_20',
  'ADEME_RM_FUEL_21',
  'ADEME_RM_FUEL_22',
  'ADEME_RM_FUEL_23',
  'ADEME_RM_FUEL_24',
  'ADEME_RM_FUEL_25',
  'ADEME_RM_FUEL_26',
  'ADEME_RM_FUEL_27',
  'ADEME_RM_FUEL_28',
  'ADEME_RM_FUEL_29',
  'ADEME_RM_FUEL_30',
  'ADEME_RM_FUEL_31',
  'ADEME_RM_FUEL_32',
  'ADEME_RM_FUEL_33',
  'ADEME_RM_FUEL_34',
  'ADEME_RM_FUEL_35',
  'ADEME_RM_FUEL_36',
  'ADEME_RM_FUEL_37',
  'ADEME_RM_FUEL_38',
  'ADEME_RM_FUEL_39',
  'ADEME_RM_FUEL_40',
  'ADEME_RM_FUEL_41',
  'ADEME_RM_FUEL_42',
  'ADEME_RM_FUEL_43',
  'ADEME_RM_FUEL_44',
  'ADEME_RM_FUEL_45',
  'ADEME_RM_FUEL_46',
  'ADEME_RM_FUEL_47',
  'ADEME_RM_FUEL_48',
  'ADEME_RM_FUEL_49',
  'ADEME_RM_FUEL_50',
  'ADEME_RM_FUEL_51',
  'ADEME_RM_FUEL_52',
  'ADEME_RM_FUEL_53',
  'ADEME_RM_FUEL_54',
  'ADEME_RM_FUEL_55',
  'ADEME_RM_FUEL_56',
  'ADEME_RM_FUEL_57',
  'ADEME_RM_FUEL_58',
  'ADEME_RM_FUEL_59',
  'ADEME_RM_FUEL_60',
  'ADEME_RM_FUEL_61',
  'ADEME_RM_FUEL_62',
  'ADEME_RM_FUEL_63',
  'ADEME_RM_FUEL_64',
  'ADEME_RM_FUEL_65',
  'ADEME_RM_FUEL_66',
  'ADEME_RM_FUEL_67',
  'ADEME_RM_FUEL_68',
  'ADEME_RM_FUEL_69',
  'ADEME_RM_FUEL_70',
  'ADEME_RM_FUEL_71',
  'ADEME_RM_FUEL_72',
  'ADEME_RM_FUEL_73',
  'ADEME_RM_FUEL_74',
  'ADEME_RM_FUEL_75',
  'ADEME_RM_FUEL_76',
  'ADEME_RM_FUEL_77',
  'ADEME_RM_FUEL_78',
  'ADEME_RM_FUEL_79',
  'ADEME_RM_FUEL_80',
  'ADEME_RM_FUEL_81',
  'ADEME_RM_FUEL_82',
  'ADEME_RM_FUEL_83',
  'ADEME_RM_FUEL_84',
  'ADEME_RM_FUEL_85',
  'ADEME_RM_FUEL_86',
  'ADEME_RM_FUEL_87',
  'ADEME_RM_FUEL_88',
  'ADEME_RM_FUEL_89',
  'ADEME_RM_FUEL_90',
  'ADEME_RM_FUEL_91',
  'ADEME_RM_FUEL_92',
  'ADEME_RM_FUEL_93',
  'ADEME_RM_FUEL_94',
  'ADEME_RM_FUEL_95',
  'ADEME_RM_FUEL_96',
  'ADEME_RM_FUEL_97',
  'ADEME_RM_FUEL_98',
  'ADEME_RM_FUEL_99',
  'ADEME_RM_FUEL_100',
  'ADEME_RM_FUEL_101',
  'ADEME_RM_FUEL_102',
  'ADEME_RM_FUEL_103',
  'ADEME_RM_FUEL_104',
  'ADEME_RM_FUEL_105',
  'ADEME_RM_FUEL_106',
  'ADEME_RM_FUEL_107',
  'ADEME_RM_FUEL_108',
  'ADEME_RM_FUEL_109',
  'ADEME_RM_FUEL_110',
  'ADEME_RM_FUEL_111',
  'ADEME_RM_FUEL_112',
  'ADEME_RM_FUEL_113',
  'ADEME_RM_FUEL_114',
  'ADEME_RM_FUEL_115',
  'ADEME_RM_FUEL_116',
  'ADEME_RM_FUEL_117',
  'ADEME_RM_FUEL_118',
  'ADEME_RM_FUEL_119',
  'ADEME_RM_FUEL_120',
  'ADEME_RM_FUEL_121',
  'ADEME_RM_FUEL_122',
  'ADEME_RM_FUEL_123',
  'ADEME_RM_FUEL_124',
  'ADEME_RM_FUEL_125',
  'ADEME_RM_FUEL_126',
  'ADEME_RM_FUEL_127',
  'ADEME_RM_FUEL_128',
  'ADEME_RM_FUEL_129',
  'ADEME_RM_FUEL_130',
  'ADEME_RM_FUEL_131',
  'ADEME_RM_FUEL_132',
  'ADEME_RM_FUEL_133',
  'ADEME_RM_FUEL_134',
  'ADEME_RM_FUEL_135',
  'ADEME_RM_FUEL_136',
  'ADEME_RM_FUEL_137',
  'ADEME_RM_FUEL_138',
  'ADEME_RM_FUEL_139',
  'ADEME_RM_FUEL_140',
  'ADEME_RM_FUEL_141',
  'ADEME_RM_FUEL_142',
  'ADEME_RM_FUEL_143',
  'ADEME_RM_FUEL_144',
  'ADEME_RM_FUEL_145',
  'ADEME_RM_FUEL_146',
  'ADEME_RM_FUEL_147',
  'ADEME_RM_FUEL_148',
  'ADEME_RM_FUEL_149',
  'ADEME_RM_FUEL_150',
  'ADEME_RM_FUEL_151',
  'ADEME_RM_FUEL_152',
  'ADEME_RM_FUEL_153',
  'ADEME_RM_FUEL_154',
  'ADEME_RM_FUEL_155',
  'ADEME_RM_FUEL_156',
  'ADEME_RM_FUEL_157',
  'ADEME_RM_FUEL_158',
  'ADEME_RM_FUEL_159',
  'ADEME_RM_FUEL_160',
  'ADEME_RM_FUEL_161',
  'ADEME_RM_FUEL_162',
  'ADEME_RM_FUEL_163',
  'ADEME_RM_FUEL_164',
  'ADEME_RM_FUEL_165',
  'ADEME_RM_FUEL_166',
  'ADEME_RM_FUEL_167',
  'ADEME_RM_FUEL_168',
  'ADEME_RM_FUEL_169',
  'ADEME_RM_FUEL_170',
  'ADEME_RM_FUEL_171',
  'ADEME_RM_FUEL_172',
  'ADEME_RM_FUEL_173',
  'ADEME_RM_FUEL_174',
  'ADEME_RM_FUEL_175',
  'ADEME_RM_FUEL_176',
  'ADEME_RM_FUEL_177',
  'ADEME_RM_FUEL_178',
  'ADEME_RM_FUEL_179',
  'ADEME_RM_FUEL_180',
  'ADEME_RM_FUEL_181',
  'ADEME_RM_FUEL_182',
  'ADEME_RM_FUEL_183',
  'ADEME_RM_FUEL_184',
  'ADEME_RM_FUEL_185',
  'ADEME_RM_FUEL_186',
  'ADEME_RM_FUEL_187',
  'ADEME_RM_FUEL_188',
  'ADEME_RM_FUEL_189',
  'ADEME_RM_FUEL_190',
  'ADEME_RM_FUEL_191',
  'ADEME_RM_FUEL_192',
  'ADEME_RM_FUEL_193',
  'ADEME_RM_FUEL_194',
  'ADEME_RM_FUEL_195',
  'ADEME_RM_FUEL_196',
  'ADEME_RM_FUEL_197',
  'ADEME_RM_FUEL_198',
  'ADEME_RM_FUEL_199',
  'ADEME_RM_FUEL_200',
  'ADEME_RM_FUEL_201',
  'ADEME_RM_FUEL_202',
  'ADEME_RM_FUEL_203',
  'ADEME_RM_FUEL_204',
  'ADEME_RM_FUEL_205',
  'ADEME_RM_FUEL_206',
  'ADEME_RM_FUEL_207',
  'ADEME_RM_FUEL_208',
  'ADEME_RM_FUEL_209',
  'ADEME_RM_FUEL_210',
  'ADEME_RM_FUEL_211',
  'ADEME_RM_FUEL_212',
  'ADEME_RM_FUEL_213',
  'ADEME_RM_FUEL_214',
  'ADEME_RM_FUEL_215',
  'ADEME_RM_FUEL_216',
  'ADEME_RM_FUEL_217',
  'ADEME_RM_FUEL_218',
  'ADEME_RM_FUEL_219',
  'ADEME_RM_FUEL_220',
  'ADEME_RM_FUEL_221',
  'ADEME_RM_FUEL_222',
  'ADEME_RM_FUEL_223',
  'ADEME_RM_FUEL_224',
  'ADEME_RM_FUEL_225',
  'ADEME_RM_FUEL_226',
  'ADEME_RM_FUEL_227',
  'ADEME_RM_FUEL_228',
  'ADEME_RM_FUEL_229',
  'ADEME_RM_FUEL_230',
  'ADEME_RM_FUEL_231',
  'ADEME_RM_FUEL_232',
  'ADEME_RM_FUEL_233',
  'ADEME_RM_FUEL_234',
  'ADEME_RM_FUEL_235',
  'ADEME_RM_FUEL_236',
  'ADEME_RM_FUEL_237',
  'ADEME_RM_FUEL_238',
  'ADEME_RM_FUEL_239',
  'ADEME_RM_FUEL_240',
  'ADEME_RM_FUEL_241',
  'ADEME_RM_FUEL_242',
  'ADEME_RM_FUEL_243',
  'ADEME_RM_FUEL_244',
  'ADEME_RM_FUEL_245',
  'ADEME_RM_FUEL_246',
  'ADEME_RM_FUEL_247',
  'ADEME_RM_FUEL_248',
  'ADEME_RM_FUEL_249',
  'ADEME_RM_FUEL_250',
  'ADEME_RM_FUEL_251',
  'ADEME_RM_FUEL_252',
  'ADEME_RM_FUEL_253',
  'ADEME_RM_FUEL_254',
  'ADEME_RM_FUEL_255',
  'ADEME_RM_FUEL_256',
  'ADEME_RM_FUEL_257',
  'ADEME_RM_FUEL_258',
  'ADEME_RM_FUEL_259',
  'ADEME_RM_FUEL_260',
  'ADEME_RM_FUEL_261',
  'ADEME_RM_FUEL_262',
  'ADEME_RM_FUEL_263',
  'ADEME_RM_FUEL_264',
  'ADEME_RM_FUEL_265',
  'ADEME_RM_FUEL_266',
  'ADEME_RM_FUEL_267',
  'ADEME_RM_FUEL_268',
  'ADEME_RM_FUEL_269',
  'ADEME_RM_FUEL_270',
  'ADEME_RM_FUEL_271',
  'ADEME_RM_FUEL_272',
  'ADEME_RM_FUEL_273',
  'ADEME_RM_FUEL_274',
  'ADEME_RM_FUEL_275',
  'ADEME_RM_FUEL_276',
  'ADEME_RM_FUEL_277',
  'ADEME_RM_FUEL_278',
  'ADEME_RM_FUEL_279',
  'ADEME_RM_FUEL_280',
  'ADEME_RM_FUEL_281',
  'ADEME_RM_FUEL_282',
  'ADEME_RM_FUEL_283',
  'ADEME_RM_FUEL_284',
  'ADEME_RM_FUEL_285',
  'ADEME_RM_FUEL_286',
  'ADEME_RM_FUEL_287',
  'ADEME_RM_FUEL_288',
  'ADEME_RM_FUEL_289',
  'ADEME_RM_FUEL_290',
  'ADEME_RM_FUEL_291',
  'ADEME_RM_FUEL_292',
  'ADEME_RM_FUEL_293',
  'ADEME_RM_FUEL_294',
  'ADEME_RM_FUEL_295',
  'ADEME_RM_FUEL_296',
  'ADEME_RM_FUEL_297',
  'ADEME_RM_FUEL_298',
  'ADEME_RM_FUEL_299',
  'ADEME_RM_FUEL_300',
  'ADEME_RM_FUEL_301',
  'ADEME_RM_FUEL_302',
  'ADEME_RM_FUEL_303',
  'ADEME_RM_FUEL_304',
  'ADEME_RM_FUEL_305',
  'ADEME_RM_FUEL_306',
  'ADEME_RM_FUEL_307',
  'ADEME_RM_FUEL_308',
  'ADEME_RM_FUEL_309',
  'ADEME_RM_FUEL_310',
  'ADEME_RM_FUEL_311',
  'ADEME_RM_FUEL_312',
  'ADEME_RM_FUEL_313',
  'ADEME_RM_FUEL_314',
  'ADEME_RM_FUEL_315',
  'ADEME_RM_FUEL_316',
  'ADEME_RM_FUEL_317',
  'ADEME_RM_FUEL_318',
  'ADEME_RM_FUEL_319',
  'ADEME_RM_FUEL_320',
  'ADEME_RM_FUEL_321',
  'ADEME_RM_FUEL_322',
  'ADEME_RM_FUEL_323',
  'ADEME_RM_FUEL_324',
  'ADEME_RM_FUEL_325',
  'ADEME_RM_FUEL_326',
  'ADEME_RM_FUEL_327',
  'ADEME_RM_FUEL_328',
  'ADEME_RM_FUEL_329',
  'ADEME_RM_FUEL_330',
  'ADEME_RM_FUEL_331',
  'ADEME_RM_FUEL_332',
  'ADEME_RM_FUEL_333',
  'ADEME_RM_FUEL_334',
  'ADEME_RM_FUEL_335',
  'ADEME_RM_FUEL_336',
  'ADEME_RM_FUEL_337',
  'ADEME_RM_FUEL_338',
  'ADEME_RM_FUEL_339',
  'ADEME_RM_FUEL_340',
  'ADEME_RM_FUEL_341',
  'ADEME_RM_FUEL_342',
  'ADEME_RM_FUEL_343',
  'ADEME_RM_FUEL_344',
  'ADEME_RM_FUEL_345',
  'ADEME_RM_FUEL_346',
  'ADEME_RM_FUEL_347',
  'ADEME_RM_FUEL_348',
  'ADEME_RM_FUEL_349',
  'ADEME_RM_FUEL_350',
  'ADEME_RM_FUEL_351',
  'ADEME_RM_FUEL_352',
  'ADEME_RM_FUEL_353',
  'ADEME_RM_FUEL_354',
  'ADEME_RM_FUEL_355',
  'ADEME_RM_FUEL_356',
  'ADEME_RM_FUEL_357',
  'ADEME_RM_FUEL_358',
  'ADEME_RM_FUEL_359',
  'ADEME_RM_FUEL_360',
  'ADEME_RM_FUEL_361',
  'ADEME_RM_FUEL_362',
  'ADEME_RM_FUEL_363',
  'ADEME_RM_FUEL_364',
  'ADEME_RM_FUEL_365',
  'ADEME_RM_FUEL_366',
  'ADEME_RM_FUEL_367',
  'ADEME_RM_FUEL_368',
  'ADEME_RM_FUEL_369',
  'ADEME_RM_FUEL_370',
  'ADEME_RM_FUEL_371',
  'ADEME_RM_FUEL_372',
  'ADEME_RM_FUEL_373',
  'ADEME_RM_FUEL_374',
  'ADEME_RM_FUEL_375',
  'ADEME_RM_FUEL_376',
  'ADEME_RM_FUEL_377',
  'ADEME_RM_FUEL_378',
  'ADEME_RM_FUEL_379',
  'ADEME_RM_FUEL_380',
  'ADEME_RM_FUEL_381',
  'ADEME_RM_FUEL_382',
  'ADEME_RM_FUEL_383',
  'ADEME_RM_FUEL_384',
  'ADEME_RM_FUEL_385',
  'ADEME_RM_FUEL_386',
  'ADEME_RM_FUEL_387',
  'ADEME_RM_FUEL_388',
  'ADEME_RM_FUEL_389',
  'ADEME_RM_FUEL_390',
  'ADEME_RM_FUEL_391',
  'ADEME_RM_FUEL_392',
  'ADEME_RM_FUEL_393',
  'ADEME_RM_FUEL_394',
  'ADEME_RM_FUEL_395',
  'ADEME_RM_FUEL_396',
  'ADEME_RM_FUEL_397',
  'ADEME_RM_FUEL_398',
  'ADEME_RM_FUEL_399',
  'ADEME_RM_FUEL_400',
  'ADEME_RM_FUEL_401',
  'ADEME_RM_FUEL_402',
  'ADEME_RM_FUEL_403',
  'ADEME_RM_FUEL_404',
  'ADEME_RM_FUEL_405',
  'ADEME_RM_FUEL_406',
  'ADEME_RM_FUEL_407',
  'ADEME_RM_FUEL_408',
  'ADEME_RM_FUEL_409',
  'ADEME_RM_FUEL_410',
  'ADEME_RM_FUEL_411',
  'ADEME_RM_FUEL_412',
  'ADEME_RM_FUEL_413',
  'ADEME_RM_FUEL_414',
  'ADEME_RM_FUEL_415',
  'ADEME_RM_FUEL_416',
  'ADEME_RM_FUEL_417',
  'ADEME_RM_FUEL_418',
  'ADEME_RM_FUEL_419',
  'ADEME_RM_FUEL_420',
  'ADEME_RM_FUEL_421',
  'ADEME_RM_FUEL_422',
  'ADEME_RM_FUEL_423',
  'ADEME_RM_FUEL_424',
  'ADEME_RM_FUEL_425',
  'ADEME_RM_FUEL_426',
  'ADEME_RM_FUEL_427',
  'ADEME_RM_FUEL_428',
  'ADEME_RM_FUEL_429',
  'ADEME_RM_FUEL_430',
  'ADEME_RM_FUEL_431',
  'ADEME_RM_FUEL_432',
  'ADEME_RM_FUEL_433',
  'ADEME_RM_FUEL_434',
  'ADEME_RM_FUEL_435',
  'ADEME_RM_FUEL_436',
  'ADEME_RM_FUEL_437',
  'ADEME_RM_FUEL_438',
  'ADEME_RM_FUEL_439',
  'ADEME_RM_FUEL_440',
  'ADEME_RM_FUEL_441',
  'ADEME_RM_FUEL_442',
  'ADEME_RM_FUEL_443',
  'ADEME_RM_FUEL_444',
  'ADEME_RM_FUEL_445',
  'ADEME_RM_FUEL_446',
  'ADEME_RM_FUEL_447',
  'ADEME_RM_FUEL_448',
  'ADEME_RM_FUEL_449',
  'ADEME_RM_FUEL_450',
  'ADEME_RM_FUEL_451',
  'ADEME_RM_FUEL_452',
  'ADEME_RM_FUEL_453',
  'ADEME_RM_FUEL_454',
  'ADEME_RM_FUEL_455',
  'ADEME_RM_FUEL_456',
  'ADEME_RM_FUEL_457',
  'ADEME_RM_FUEL_458',
  'ADEME_RM_FUEL_459',
  'ADEME_RM_FUEL_460',
  'ADEME_RM_FUEL_461',
  'ADEME_RM_FUEL_462',
  'ADEME_RM_FUEL_463',
  'ADEME_RM_FUEL_464',
  'ADEME_RM_FUEL_465',
  'ADEME_RM_FUEL_466',
  'ADEME_RM_FUEL_467',
  'ADEME_RM_FUEL_468',
  'ADEME_RM_FUEL_469',
  'ADEME_RM_FUEL_470',
  'ADEME_RM_FUEL_471',
  'ADEME_RM_FUEL_472',
  'ADEME_RM_FUEL_473',
  'ADEME_RM_FUEL_474',
  'ADEME_RM_FUEL_475',
  'ADEME_RM_FUEL_476',
  'ADEME_RM_FUEL_477',
  'ADEME_RM_FUEL_478',
  'ADEME_RM_FUEL_479',
  'ADEME_RM_FUEL_480',
  'ADEME_RM_FUEL_481',
  'ADEME_RM_FUEL_482',
  'ADEME_RM_FUEL_483',
  'ADEME_RM_FUEL_484',
  'ADEME_RM_FUEL_485',
  'ADEME_RM_FUEL_486',
  'ADEME_RM_FUEL_487',
  'ADEME_RM_FUEL_488',
  'ADEME_RM_FUEL_489',
  'ADEME_RM_FUEL_490',
  'ADEME_RM_FUEL_491',
  'ADEME_RM_FUEL_492',
  'ADEME_RM_FUEL_493',
  'ADEME_RM_FUEL_494',
  'ADEME_RM_FUEL_495',
  'ADEME_RM_FUEL_496',
  'ADEME_RM_FUEL_497',
  'ADEME_RM_FUEL_498',
  'ADEME_RM_FUEL_499',
  'ADEME_RM_FUEL_500',
  'ADEME_RM_FUEL_501',
  'ADEME_RM_FUEL_502',
  'ADEME_RM_FUEL_503',
  'ADEME_RM_FUEL_504',
  'ADEME_RM_FUEL_505',
  'ADEME_RM_FUEL_506',
  'ADEME_RM_FUEL_507',
  'ADEME_RM_FUEL_508',
  'ADEME_RM_FUEL_509',
  'ADEME_RM_FUEL_510',
  'ADEME_RM_FUEL_511',
  'ADEME_RM_FUEL_512',
  'ADEME_RM_FUEL_513',
  'ADEME_RM_FUEL_514',
  'ADEME_RM_FUEL_515',
  'ADEME_RM_FUEL_516',
  'ADEME_RM_FUEL_517',
  'ADEME_RM_FUEL_518',
  'ADEME_RM_FUEL_519',
  'ADEME_RM_FUEL_520',
  'ADEME_RM_FUEL_521',
  'ADEME_RM_FUEL_522',
  'ADEME_RM_FUEL_523',
  'ADEME_RM_FUEL_524',
  'ADEME_RM_FUEL_525',
  'ADEME_RM_FUEL_526',
  'ADEME_RM_FUEL_527',
  'ADEME_RM_FUEL_528',
  'ADEME_RM_FUEL_529',
  'ADEME_RM_FUEL_530',
  'ADEME_RM_FUEL_531',
  'ADEME_RM_FUEL_532',
  'ADEME_RM_FUEL_533',
  'ADEME_RM_FUEL_534',
  'ADEME_RM_FUEL_535',
  'ADEME_RM_FUEL_536',
  'ADEME_RM_FUEL_537',
  'ADEME_RM_FUEL_538',
  'ADEME_RM_FUEL_539',
  'ADEME_RM_FUEL_540',
  'ADEME_RM_FUEL_541',
  'ADEME_RM_FUEL_542',
  'ADEME_RM_FUEL_543',
  'ADEME_RM_FUEL_544',
  'ADEME_RM_FUEL_545',
  'ADEME_RM_FUEL_546',
  'ADEME_RM_FUEL_547',
  'ADEME_RM_FUEL_548',
  'ADEME_RM_FUEL_549',
  'ADEME_RM_FUEL_550',
  'ADEME_RM_FUEL_551',
  'ADEME_RM_FUEL_552',
  'ADEME_RM_FUEL_553',
  'ADEME_RM_FUEL_554',
  'ADEME_RM_FUEL_555',
  'ADEME_RM_FUEL_556',
  'ADEME_RM_FUEL_557',
  'ADEME_RM_FUEL_558',
  'ADEME_RM_FUEL_559',
  'ADEME_RM_FUEL_560',
  'ADEME_RM_FUEL_561',
  'ADEME_RM_FUEL_562',
  'ADEME_RM_FUEL_563',
  'ADEME_RM_FUEL_564',
  'ADEME_RM_FUEL_565',
  'ADEME_RM_FUEL_566',
  'ADEME_RM_FUEL_567',
  'ADEME_RM_FUEL_568',
  'ADEME_RM_FUEL_569',
  'ADEME_RM_FUEL_570',
  'ADEME_RM_FUEL_571',
  'ADEME_RM_FUEL_572',
  'ADEME_RM_FUEL_573',
  'ADEME_RM_FUEL_574',
  'ADEME_RM_FUEL_575',
  'ADEME_RM_FUEL_576',
  'ADEME_RM_FUEL_577',
  'ADEME_RM_FUEL_578',
  'ADEME_RM_FUEL_579',
  'ADEME_RM_FUEL_580',
  'ADEME_RM_FUEL_581',
  'ADEME_RM_FUEL_582',
  'ADEME_RM_FUEL_583',
  'ADEME_RM_FUEL_584',
  'ADEME_RM_FUEL_585',
  'ADEME_RM_FUEL_586',
  'ADEME_RM_FUEL_587',
  'ADEME_RM_FUEL_588',
  'ADEME_RM_FUEL_589',
  'ADEME_RM_FUEL_590',
  'ADEME_RM_FUEL_591',
  'ADEME_RM_FUEL_592',
  'ADEME_RM_FUEL_593',
  'ADEME_RM_FUEL_594',
  'ADEME_RM_FUEL_595',
  'ADEME_RM_FUEL_596',
  'ADEME_RM_FUEL_597',
  'ADEME_RM_FUEL_598',
  'ADEME_RM_FUEL_599',
  'ADEME_RM_FUEL_600',
  'ADEME_RM_FUEL_601',
  'ADEME_RM_FUEL_602',
  'ADEME_RM_FUEL_603',
  'ADEME_RM_FUEL_604',
  'ADEME_RM_FUEL_605',
];

export const DEFAULT_GAS = EmissionSourceGreenHouseGases.CO2;

export const REFRIGERANT_OTHERS_OPTION = RefrigerantGHG.GHG_CUSTOM_1;

export const REFRIGERANT_CUSTOM_KEYS = [
  RefrigerantGHG.GHG_CUSTOM_1,
  RefrigerantGHG.GHG_CUSTOM_2,
  RefrigerantGHG.GHG_CUSTOM_3,
  RefrigerantGHG.GHG_CUSTOM_4,
  RefrigerantGHG.GHG_CUSTOM_5,
];
